import React, { Component } from "react";
import { Card, OverlayTrigger, Tooltip, ToastContainer, Toast } from "react-bootstrap";
import CustomNavbar from "../../components/component.customNavbar";
import "./component.applyNow.css";
import Sidebar from "../../components/component.customSideBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faQuestion } from "@fortawesome/free-solid-svg-icons";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applyNowActions from '../../redux/actions/applyNow.actions';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Moment from 'moment';
import { trackPromise } from 'react-promise-tracker';
import * as customerDetailsActions from "../../redux/actions/customerDetails.actions";
import { Modal } from "react-bootstrap"
import { faAngleDown, faAngleUp, faClose, faCheck, faCircleXmark, faCircle } from "@fortawesome/free-solid-svg-icons";
import IdleTimeModal from "../../components/component.idleTimeModal";
import AugmentesIdleTime from "../../components/component.augmentesIdleTime";
import * as authActions from '../../redux/actions/authActions';
import * as storeactions from '../../redux/actions/storeNumber.actions';
import * as userRightsActions from "../../redux/actions/adminUserRights.actions";
import * as adminUserListActions from '../../redux/actions/adminUserList.actions';
import ReCAPTCHA from "react-google-recaptcha";
import { IMaskInput } from 'react-imask';
import axios from 'axios';
import APIFailedMessage from "../../components/component.apiFailedMessage";
import GetDateFromMMYYYY from "../../components/component.GetDateFromMMYYYY";
import GetDateFromMMDDYYYY from "../../components/component.GetDateFromMMDDYYYY";
import formatPhoneNumber from "../../components/component.formatPhoneNumber";
import formatCC from "../../components/component.formatCC";
import DanielsDisclosureForm from "./component.danielsDisclosureForm";
import * as adminActions from '../../redux/actions/admin.actions';
import Autocomplete from 'react-autocomplete';
import FortivaDisclosures from "../../components/component.fortivaDisclosures";
import FortivaDialog from "../../components/component.noFortivaDialog";
import ConfirmDialog from "../../components/component.confirmDialog";
import ProgUownForm from "./component.progUownForm";
import FortivaErrorDialog from "../../components/component.fortivaErrorDialog";
import GetInfo from "../../components/component.getInfo";
import ProgUownModal from "../../components/component.progUownModal";
import DanielsEStatementDisclosure from "./component.danielsEStatementDisclosure";
//import MagixCrediAppDialog from "../../components/component.magixCreditAppDialog";
import * as customerLookupAction from "../../redux/actions/customerLookup.actions";
import * as customerUpdationActions from "../../redux/actions/customerUpdation.actions";
import AddressSuggestionForm from "./component.addressSuggestionForm";

class ApplyNow extends Component {
    constructor() {
        super();
        this.state = {
            step1: true,
            isStep1Complete: false,
            step2: false,
            toggled: false,
            isStep2Complete: false,
            step3: false,
            isStep3Complete: false,
            step4: false,
            isStep4Complete: false,
            step5: false,
            isStep5Complete: false,
            step6: false,
            isStep6Complete: false,
            step7: false,
            isStep7Complete: false,
            step8: false,
            isStep8Complete: false,
            step9: false,
            isStep9Complete: false,
            step10: false,
            isStep10Complete: false,
            step11: false,
            isStep11Complete: false,
            step12: false,
            isStep12Complete: false,
            isVerifyPassword: false,
            danielsCredit: true,
            synchronyCredit: true,
            fortivaCredit: true,
            progressiveLeasing: false,
            UOwnLeasing: false,
            danielsDisclosure: false,
            synchronyDisclosure: false,
            fortivaDisclosure: false,
            fortivaElecDisclosure: false,
            fortivaWrittenInstr: false,
            fortivaDisMsg: "",
            fortivaElectronicDisMsg: "",
            verifyPassword: false,
            showPopup: false,
            customerInfo: [],
            progressiveDisclosure: false,
            progressiveSMS: false,
            UOwnDisclosure: false,
            showSubmitConfirmation: false,
            showSubmittedAlert: false,
            isAgreed: false,
            isAPIError: false,
            isAPIErrorMsg: "",
            isSMSError: false,
            isSMSErrorMsg: "",
            SMSCodeSent: false,
            iframeUrl: "",
            iframeError: false,
            iframeErrorMsg: "",
            custIdEnt: "",
            autoPay: false,
            autoPaySubmitted: false,
            autoPayDisclosure: false,
            autoPayStatus: "",
            formObj: {
                applicationId: "",
                credit_Id: 0,
                customerNo: "NEW",
                account: "",
                storeCode: "0",
                suffix: "0",
                firstName: "",
                middleName: "",
                lastName: "",
                mailingAdr: "",
                emailAdr: "",
                aptUnit: "",
                dob: "",
                city: "",
                mobileNo: "",
                state: "0",
                secPhone: "",
                zipCode: "",
                empName: "",
                empStartDate: "",
                empPhoneNo: "",
                netIncome: "",
                duties: "",
                housingInfo: "0",
                ssn: "",
                primaryIdType: "0",
                primaryIdNo: "",
                primaryIdState: "0",
                primaryIdExpiryDate: "",
                secondIdType: "0",
                secondIdIssuedBy: "",
                secondIdExpiryDate: "",
                relativeName: "",
                relativePhone: "",
                relativeRelation: "",
                verificationCode: "",
                oftenPaid: "0",
                cc: "",
                lastPayDay: "",
                ccExpiryDate: "",
                nextPayDay: "",
                ccName: "",
                primarySourceIncome: "0",
                creditCardBillingAddress: false,
                ccmailingAdr: "",
                ccaptUnit: "",
                cccity: "",
                ccstate: "0",
                cczipCode: "",
                bankRouteNo: "",
                checkAccNo: "",
                bankAccountDuration: "0",
                associateEmployeeNo: "",
                associatePassword: "",
                rdApply: "DS",
                lstSuffix: [],
                lstState: [],
                lstCCState: [],
                lstHousingInfo: [],
                lstPrimaryIdType: [],
                lstPrimaryIdState: [],
                lstOftenPaid: [],
                lstPrimarySourceIncome: [],
                lstBankAccountDuration: [],
                lstSecondIdType: [],
                lstStoreCode: []
            },
            limitedState: [],
            formErrors: {},
            roles: [],
            site_page_details: [],
            sitePages: [],
            userRights: [],
            permission_status: '',
            thirdPartyLink: true,
            SMSLink: false,
            thirdPartySessionLink: false,
            cartId: "",
            isAutoPayRequired: false,
            sessionId: "",
            captchaVerified: false,
            isDanielsApp: false,
            sessionIdVerificationRes: false,
            toastModal: false,
            siteKey: "",
            show: false,
            autoPayModal: false,
            isSMSOverride: false,
            isSMSVerified: false,
            smsURLError: false,
            errorInActVerification: false,
            errorInMobileInfo: false,
            errorInPersonalInfo: false,
            errorInEmployment: false,
            errorInIdentification: false,
            errorInDaniels: false,
            errorInSynchrony: false,
            applicantIdMatch: false,
            synchronyAgreementGiven: false,
            chkSynchronyOnly: false,
            erronInProgressive: false,
            errorInUown: false,
            errorInAutoPay: false,
            errorInDisclosure: false,
            verificationBox: false,
            djoId: "",
            djoIdError: "",
            djoSubmitted: false,
            showTempCode: false,
            djoIdConfirm: false,
            storesList: [],
            nonSynchronyCD: true,
            fortivaApp: false,
            danielsApp: false,
            progressiveApp: false,
            uownApp: false,
            allAddress: [],
            allAptUnit: [],
            addressAutoFillEnable: false,
            isWaterFallEnable: false,
            ABAError: undefined,
            isDuplicateCustomer: false,
            ABAChanged: false,
            showAddressSuggestionForm: false,
            originalAddress: '',
            suggestedAddress: '',
            isElectronicDisclosure: false,
            isApplicationDisclosure: false,
            isAlldisclosuresChecked: false,
            isAutoPayEnabled: true,
            isSynchronySendEmail: false,
            duplicateCustData: {
                customer_id: "",
                firstName: "",
                middleName: "",
                ssn: "",
                lastName: "",
                dob: "",
                birthDate: "",
                emailAddress: "",
                application_id: "",
                existing_Customer: false,
            },
            magixDuplicateCustData: {},
            associateRelogin: false,
            noStoreAssign: false,
            accessModal: false,
            userStatus: false,
            waterfallObj: {
                showProgUown: false,
                isDaniel: false,
                customerId: "",
                applicationId: "",
                creditId: "",
                isUownChecked: true,
                isProgChecked: true,
                waterFallStatus: false,
                fortivaOffer: null,
                synchronyOffer: null
            },
            synchronyPending: false,
            synchronyDeclined: false,
            showFortiva: false,
            successMsg: "",
            offerModal: false,
            associateId: localStorage.getItem('loggedUserEmail') != "null" ? localStorage.getItem('loggedUserEmail') : "",
            store_Id: localStorage.getItem("associateStores") != "null" ? JSON.parse(localStorage.getItem("associateStores")) : "",
            fortivaAppError: false,
            fortivaAppErrMsg: "",
            fortivaAppErrMsgDesc: "",
            isEstatementEnable: true,
            isDanielEStatementDisclosure: true,
            showEstatementPopup: false,
            // magixAcctList:[],
            // selectedMagixAccount:"",
            // selectedMagixStoreId:"",
            eStatementContent: "<div>" +
                "<h4><b>Daniel’s Jewelers e-Statement Agreement</b></h4>" +
                "<h5><b>PURPOSE OF THE e-STATEMENT AGREEMENT</b></h5>" +
                "<p>The purpose of this e-Statement Agreement is to acknowledge your consent to receive periodic account billing statements relating to your credit account with Daniel’s Jewelers in electronic form, rather than in paper form. You are delivering this consent voluntarily and you expressly agree that you are under no compulsion to enter into this Agreement.</p>" +
                "<p>If you consent to these electronic deliveries, Daniel’s Jewelers will make electronic periodic account billing statements (“e-Statements”) available to you electronically through email and/or text message, instead of providing them to you in paper form through US mail.</p>" +
                "<p>Daniel’s Jewelers is referred to in this Agreement as “we,” “our,” “us” or “Company,” and individuals who maintain a Daniel’s Credit Account are referred to in this e-Agreement as “you” and “your.”</p>" +
                "</div>" +
                "<div>" +
                "<h5><b>CONSEQUENCES OF ENTERING INTO THIS e-STATEMENT AGREEMENT</b></h5>" +
                "<p>By entering into this e-Statement Agreement:</p>" +
                "<ul>" +
                "<li>You are enrolling in the e-Statement service, and you are affirmatively consenting to receive your Daniel’s Credit account periodic billing statements electronically by email and/or text message.</li>" +
                "<li>You agree to discontinue the receipt of a monthly paper statement for your account, now and in the future. If you change your mind at a later date about enrolling for e-statements or discontinuing e-statements (and return to paper statements), please call our Customer Accounts department at 800.819.8000 Option 5 or 310.665.2170.</li>" +
                "</ul>" +
                "</div>" +
                "<div>" +
                "<h5><b>TECHNICAL REQUIREMENTS FOR USING e-STATEMENTS</b></h5>" +
                "<p>To access and retain your e-Statements, you will need:</p>" +
                "<ul>" +
                "<li>Internet access and a valid email address and/or mobile number that you can receive these e-Statements at.</li>" +
                "<li>A browser that supports 128-bit encryption, Transport Layered Security (TLS) 1.1 or higher. For the best results, we recommend you utilize the most current version of the following browsers: Google Chrome, Mozilla Firefox, Safari, or Microsoft Edge.</li>" +
                "<li>Please note that we are not responsible for the performance of any third-party software or for any damage to your computer or other equipment caused by the installation of any third-party software.</li>" +
                "<li>Access to a printer or the ability to keep copies of your e-Statements for your records.</li>" +
                "</ul>" +
                "</div>" +
                "<div>" +
                "<h5><b>ACCESS TO YOUR e-STATEMENTS</b></h5>" +
                "<p>After you accept this e-Statement Agreement, you will receive your monthly e-Statements via email and/or text message using the email address and /or text message you provided to us.</p>" +
                "<p>In most instances, e-Statements will be emailed and/or text messaged to you starting with your first billing statement generated following enrollment. Your normal statement billing date will not change when you elect to receive e-Statements. For your existing accounts upon enrollment in the e-Statement service, please call our Customer Accounts department at 800.819.8000 Option 5 or 310.665.2170 for statements generated prior to your enrollment in e-Statements.</p>" +
                "</div>" +
                "<div>" +
                "<h5><b>ONGOING AVAILABILITY OF YOUR e-STATEMENTS</b></h5>" +
                "<p>Each e-Statement will be available for up to 18 months by clicking on the browser link in the email and/or text message that was sent to you each month a billing statement was generated.</p>" +
                "<p>You may request a paper statement by contacting us as provided below (see “How to Contact Us”).</p>" +
                "</div>" +
                "<div>" +
                "<h5><b>HOW TO DISCONTINUE ELECTRONIC DELIVERY OF e-STATEMENTS</b></h5>" +
                "<p>At any time, you may revoke your consent to electronic delivery and instead receive statements in paper form. You may revoke your consent in any of these ways:</p>" +
                "<ul>" +
                "<li>Login to your account at <a href='https://payments.danielsjewelers.com' target='_blank' style='color: rgb(0, 174, 239); cursor: pointer;'>https://payments.danielsjewelers.com</a> to change your selection.</li>" +
                "<li>Call our Customer Accounts department at 310.665.2170.</li>" +
                "<li>Send a written letter stating that you wish to revoke your consent to receive e-Statements and wish to receive these materials in paper form. For written communication sent by mail, include your full name and your applicable Daniel’s Credit account number and mail to Daniel’s Jewelers Customer Service Department, P.O. Box 3750, Culver City, CA 90231-3750.</li>" +
                "</ul>" +
                "</div>" +
                "<div>" +
                "<h5><b>YOUR RESPONSIBILITY TO NOTIFY US REGARDING ERRORS, IRREGULARITIES OR UNAUTHORIZED ACCESS</b></h5>" +
                "<p>You must promptly review your e-Statements and any accompanying items. Notify us immediately (see “How to Contact Us” below) of any suspected error, alteration or other irregularity (i) with your e-Statements; or (ii) with your account, including unauthorized access. Telephoning us or writing to us immediately is the best way to try to address these issues.</p>" +
                "</div>" +
                "<div>" +
                "<h5><b>YOUR RESPONSIBILITY TO UPDATE YOUR ELECTRONIC CONTACT INFORMATION</b></h5>" +
                "<p>You must promptly notify us if there is a change in your email address and/or mobile number or in other information needed to contact you electronically (see “How to Contact Us” below).</p>" +
                "</div>" +
                "<div>" +
                "<h5><b>HOW TO CONTACT US</b></h5>" +
                "<p>If you need to contact us in any of the circumstances described above, or for any other reason, you may contact us:</p>" +
                "<ul>" +
                "<li>by Telephone at 800.819.8000 Option 5 or 310.665.2170; or</li>" +
                "<li>in writing by U.S. Mail to: Daniel’s Jewelers Customer Service Department, P.O. Box 3750, Culver City, CA 90231-3750.</li>" +
                "</ul>" +
                "</div>" +
                "<div>" +
                "<h5><b>FEES FOR e-STATEMENTS</b></h5>" +
                "<p>We do not currently charge fees for electronic delivery of e-Statements. We reserve the right to impose or change fees for electronic delivery and charge your credit account for these fees at any time after providing such notice to you as may be required by applicable law or regulation.</p>" +
                "</div>" +
                "<div>" +
                "<h5><b>LIMITATION OF LIABILITY</b></h5>" +
                "<p>We will use our best efforts to deliver your e-Statements in a timely manner and in accordance with any applicable time required by law. However, we shall incur no liability if we are unable to deliver your e-Statements because of the existence of any one or more of the following circumstances:</p>" +
                "<ol>" +
                "<li>Your equipment or Internet access was not working properly, or</li>" +
                "<li>Internet service is interrupted (e.g., due to traffic or other disruptions), or</li>" +
                "<li>Circumstances beyond our control (including, but not limited to, fire, flood, interruption in telephone service or other communication lines, interference from an outside force, legal restriction or delays in e-mail service) prevent proper delivery, and we have taken reasonable precautions within our control to avoid such circumstances.</li>" +
                "<li>Changes in your email address and/or mobile number or your failure to access the email and or text message provided.</li>" +
                "</ol>" +
                "<p>To the extent permitted by applicable law or regulation, we hereby disclaim all other warranties, express or implied, including warranties of merchantability and fitness for a particular purpose, and in no event shall we be liable for any special indirect, incidental or consequential damages whatsoever resulting from the loss or use of data, whether or not advised of the possibility of such loss or damage.</p>" +
                "</div>" +
                "<div>" +
                "<h5><b>MODIFICATION OF THIS AGREEMENT</b></h5>" +
                "<p>This Agreement may be modified by us by the delivery of any notice required by applicable law.</p>" +
                "</div>" +
                "<div>" +
                "<h5><b>AGREEMENT REGARDING YOUR USE OF e-STATEMENTS</b></h5>" +
                "<p>You agree not to alter or use the e-Statements for any unauthorized, fraudulent or other illegal purpose.</p>" +
                "</div>" +
                "<p>Current 03.24</p>",
            isMobileNoVerifiedOnSameDay: false,
            notify_me_via_text_at: true,
            notify_me_via_email_at: true,
            previousMobileNo: "",
            addOnwithOutchanges: false,
            addOnWithChange: false,
            isDanielsApplicationFlowChanges: false,
            isAssociateStore_IP: false,
            associateStoreId: undefined,
            autoPayMessagePopup: false,
            autoPayMessage: "",
            isLeasingAppOnly: false,
            isMagixDuplicateCustomer: false,
            selectedDuplicateMagixRecord: {},
            validateMagix: false,
            showAppInProgress: false,
            setTimerForAppDelay: 0,
            submissionStatus: {
                synchrony: false,
                fortiva: false,
                daniels: false,
                progressive: false,
                uwon: false
            },
            alterPopupmessage: [],
        };
    }

    onElectronicAgree = (event) => {
        event.preventDefault();
        this.setState({ isAgreed: !this.state.isAgreed });
    }

    validateABA = async () => {
        if (this.state.progressiveLeasing && this.state.ABAChanged) {
            let result = false;
            let obj = this.state.formObj.bankRouteNo;
            result = await this.props.actions.validateABANumber(this.state.formObj.customerNo, obj);
            if (result) {
                if (!result.isValid)
                    this.setState({ ABAError: "Please enter a valid Bank Routing Number." });
                else
                    this.setState({ ABAError: undefined, ABAChanged: false });
                return result.isValid;
            }
        }
        else
            return true;
    }
    validateDuplicateCustomer = async () => {
        let result = false;
        let dob = GetDateFromMMDDYYYY(this.state.formObj.dob);
        let response = await this.props.actions.validateDuplicateCustomer(this.state.formObj.ssn, dob);
        if (response) {
            this.setState({ duplicateCustData: response });
            if (response.customer_id === 0) {
                this.setState({ isDuplicateCustomer: false });
                let obj = {
                    phone: "",
                    ssn: this.state.formObj.ssn,
                    name: "",
                    birthDate: Moment(this.state.formObj.dob).format("MM/DD/YYYY"),
                    id: "",
                    accountId: "",
                    danielsAccId: "",
                    zipCode: "",
                    pageIndex: 1,
                    pageSize: 10,
                    sortBy: "maxCustBal",
                    sortOrder: "desc",
                };
                let magixRes = await this.props.customerLookUpActions.getMagixDetails(obj);
                if (magixRes) {
                    if (magixRes?.data?.length === 0) {
                        this.setState({ isMagixDuplicateCustomer: false });
                        result = true;
                        return result;
                    }
                    else {
                        let count = 1;
                        magixRes?.data?.map((item) => {
                            return item.id = count++;
                        })
                        if (sessionStorage.getItem("logout/continue") != "true") {
                            this.setState({ isMagixDuplicateCustomer: true, magixDuplicateCustData: magixRes });
                            result = false;
                            return result;
                        }
                        else {
                            this.setState({ associateRelogin: true, magixDuplicateCustData: magixRes });
                            result = false;
                            return result;
                        }

                    }
                }
                result = true;
                return result;
            }
            else {
                if (response.existing_Customer === true) {
                    if (this.state.SMSLink || this.state.thirdPartySessionLink) {
                        localStorage.setItem("applicationId", response.application_id);
                        localStorage.setItem("customerId", response.customer_id);
                        sessionStorage.setItem("isNewApplication", false);
                        this.setState({ isDuplicateCustomer: false, duplicateCustData: response });
                        result = true;
                        this.loadCustomer();
                        return result;
                    }
                    else if (sessionStorage.getItem("logout/continue") != "true") {
                        this.setState({ isDuplicateCustomer: true, duplicateCustData: response });
                        result = false;
                        return result;
                    }
                    else {
                        this.setState({ associateRelogin: true, duplicateCustData: response });
                        result = false;
                        return result;
                    }
                }
                else {
                    if (sessionStorage.getItem("logout/continue") != "true")
                        this.setState({ isDuplicateCustomer: true, duplicateCustData: response });
                    else
                        this.setState({ associateRelogin: true, duplicateCustData: response });
                    let obj = {
                        phone: "",
                        ssn: this.state.formObj.ssn,
                        name: "",
                        birthDate: Moment(this.state.formObj.dob).format("MM/DD/YYYY"),
                        id: "",
                        accountId: "",
                        danielsAccId: "",
                        zipCode: "",
                        pageIndex: 1,
                        pageSize: 10,
                        sortBy: "maxCustBal",
                        sortOrder: "desc",
                    };
                    let magixRes = await this.props.customerLookUpActions.getMagixDetails(obj);
                    if (magixRes) {
                        if (magixRes?.data?.length === 0) {
                            this.setState({ isMagixDuplicateCustomer: false });
                            result = false;
                            return result;
                        }
                        else {
                            let count = 1;
                            magixRes?.data?.map((item) => {
                                return item.id = count++;
                            })
                            this.setState({ magixDuplicateCustData: magixRes });
                            result = false;
                            return result;
                        }
                    }
                    else {
                        result = true;
                        return result;
                    }
                }
            }
        }
    }


    handleFormValidation(currStep) {

        let formErrors = {};
        let formIsValid = true;

        formErrors["danielsDisclosureErr"] = "";
        formErrors["synchronyDisclosureErr"] = "";
        formErrors["storeCodeErr"] = "";
        formErrors["firstNameErr"] = "";
        formErrors["lastNameErr"] = "";
        formErrors["mailingAdrErr"] = "";
        formErrors["emailAdrErr"] = "";
        formErrors["aptUnitErr"] = "";
        formErrors["dobErr"] = "";
        formErrors["cityErr"] = "";
        formErrors["mobileNoErr"] = "";
        formErrors["stateErr"] = "";
        formErrors["zipCodeErr"] = "";
        formErrors["empNameErr"] = "";
        formErrors["empStartDateErr"] = "";
        formErrors["empPhoneNoErr"] = "";
        formErrors["netIncomeErr"] = "";
        formErrors["dutiesErr"] = "";
        formErrors["housingInfoErr"] = "";
        formErrors["ssnErr"] = "";
        formErrors["primaryIdTypeErr"] = "";
        formErrors["primaryIdNoErr"] = "";
        formErrors["primaryIdStateErr"] = "";
        formErrors["primaryIdExpiryDateErr"] = "";
        formErrors["secondIdTypeErr"] = "";
        formErrors["secondIdIssuedByErr"] = "";
        formErrors["secondIdExpiryDateErr"] = "";
        formErrors["relativeNameErr"] = "";
        formErrors["relativePhoneErr"] = "";
        formErrors["relativeRelationErr"] = "";
        formErrors["verificationCodeErr"] = "";
        formErrors["progressiveDisclosureErr"] = "";
        formErrors["UOwnDisclosureErr"] = "";
        formErrors["oftenPaidErr"] = "";
        formErrors["ccErr"] = "";
        formErrors["lastPayDayErr"] = "";
        formErrors["ccExpiryDateErr"] = "";
        formErrors["nextPayDayErr"] = "";
        formErrors["ccNameErr"] = "";
        formErrors["primarySourceIncomeErr"] = "";
        formErrors["creditCardBillingAddressErr"] = "";
        formErrors["ccmailingAdrErr"] = "";
        formErrors["ccaptUnitErr"] = "";
        formErrors["cccityErr"] = "";
        formErrors["ccstateErr"] = "";
        formErrors["cczipCodeErr"] = "";
        formErrors["bankRouteNoErr"] = "";
        formErrors["checkAccNoErr"] = "";
        formErrors["bankAccountDurationErr"] = "";
        formErrors["associateEmployeeNoErr"] = "";
        formErrors["associatePasswordErr"] = "";
        formErrors["secPhoneErr"] = "";
        formErrors["captchaErr"] = "";
        formErrors["autoPayErr"] = "";
        formErrors["uOwnOftenPaidErr"] = "";
        formErrors["uOwnLastPayDayErr"] = "";
        formErrors["uOwnNextPayDayErr"] = "";
        formErrors["applicantIdMatchErr"] = "";
        formErrors["chkSynchronyOnlyErr"] = "";
        formErrors["fortivaDisclosureErr"] = "";
        formErrors["fortivaElecDiscErr"] = "";
        formErrors["fortivaWrittenInstrErr"] = "";

        if (currStep === "mobileNo") {
            if (this.state.formObj.mobileNo.length === 0) {
                formIsValid = false;
                formErrors["mobileNoErr"] = "Mobile number is required.";
            }
            else if (this.state.formObj.mobileNo.slice(0, 1) == 1 || this.state.formObj.mobileNo.slice(0, 1) == 0) {
                formIsValid = false;
                formErrors["mobileNoErr"] = "Mobile number cannot start with a 0 or 1.";
            }
            else if (this.state.formObj.mobileNo.length !== 12) {
                formIsValid = false;
                formErrors["mobileNoErr"] = "Mobile number must be 10 digit.";
            }
        }

        if (currStep === "verificationCodeCheck") {
            if (!this.state.isSMSOverride) {
                if (this.state.formObj.verificationCode.length === 0) {
                    formIsValid = false;
                    formErrors["verificationCodeErr"] = "We need to verify your cell phone. Please check your cell for the text message we just sent and enter the code above and click verify.";
                }
                else if (this.state.formObj.verificationCode.length !== 6) {
                    formIsValid = false;
                    formErrors["verificationCodeErr"] = "Verification code must be 6 digit.";
                }
            }
        }

        if (currStep === "codeMatchFailed") {
            formIsValid = false;
            formErrors["verificationCodeErr"] = "Invalid Code.";
        }

        if (currStep === "Step 1") {
            if (this.state.formObj.dob.length === 0) {
                formIsValid = false;
                formErrors["dobErr"] = "Date of birth is required.";
            }
            else if (parseInt(this.state.formObj.dob.split('/')[2]) < 1900) {
                formIsValid = false;
                formErrors["dobErr"] = "Year must be greater than 1900.";
            }
            else if (this.state.formObj.dob.length !== 0) {
                var today = new Date();
                var birthDate = new Date(this.state.formObj.dob);
                var age = today.getFullYear() - birthDate.getFullYear();
                var m = today.getMonth() - birthDate.getMonth();
                if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }
                if (age < 18) {
                    formIsValid = false;
                    formErrors["dobErr"] = "You must be 18 years or older to apply.";
                }
            }
            if (this.state.formObj.ssn.length === 0) {
                formIsValid = false;
                formErrors["ssnErr"] = "SSN/ITIN is required.";
            }
            else if (this.state.formObj.ssn.length < 11) {
                formIsValid = false;
                formErrors["ssnErr"] = "SSN/ITIN must be 9 digit number.";
            }
        }
        if (currStep === "Step 2") {
            if (!this.state.isSMSOverride) {
                if (this.state.formObj.verificationCode.length === 0) {
                    formIsValid = false;
                    formErrors["verificationCodeErr"] = "We need to verify your cell phone. Please check your cell for the text message we just sent and enter the code above and click verify.";
                }
                else if (this.state.formObj.verificationCode.length !== 6) {
                    formIsValid = false;
                    formErrors["verificationCodeErr"] = "Verification code must be 6 digit.";
                }
            }
            if (this.state.formObj.mobileNo.length === 0) {
                formIsValid = false;
                formErrors["mobileNoErr"] = "Mobile number is required.";
            }
            else if (this.state.formObj.mobileNo.slice(0, 1) == 1 || this.state.formObj.mobileNo.slice(0, 1) == 0) {
                formIsValid = false;
                formErrors["mobileNoErr"] = "Mobile number cannot start with a 0 or 1.";
            }
            else if (this.state.formObj.mobileNo.length !== 12) {
                formIsValid = false;
                formErrors["mobileNoErr"] = "Mobile number must be 10 digit.";
            }
        }

        if (currStep === "DJOaddressVerify") {
            formIsValid = false;
            formErrors["mailingAdrErr"] = "You must reside in one of the approved states listed on this application.";
        }

        if (currStep === "revertDJOaddressVerify") {
            formErrors["mailingAdrErr"] = undefined;
        }

        if (currStep === "Step 3") {
            if (!this.state.thirdPartySessionLink && !this.state.SMSLink && (!sessionStorage.getItem("SMSLink") || sessionStorage.getItem("SMSLink") === null)) {
                if (parseInt(this.state.formObj.storeCode) === 0) {
                    formIsValid = false;
                    formErrors["storeCodeErr"] = "Store code is required.";
                }
            }
            if (this.state.formObj.firstName.length === 0) {
                formIsValid = false;
                formErrors["firstNameErr"] = "First name is required.";
            }
            if (this.state.formObj.lastName.length === 0) {
                formIsValid = false;
                formErrors["lastNameErr"] = "Last name is required.";
            }
            if (this.state.danielsCredit) {
                if (this.state.formObj.secPhone.length !== 0 && this.state.formObj.secPhone.length !== 12) {
                    formIsValid = false;
                    formErrors["secPhoneErr"] = "Secondary Phone must be 10 digit number.";
                }
                else if (this.state.formObj.secPhone.length !== 0 && (this.state.formObj.secPhone.slice(0, 1) == 1 || this.state.formObj.secPhone.slice(0, 1) == 0)) {
                    formIsValid = false;
                    formErrors["secPhoneErr"] = "Secondary phone number cannot start with a 0 or 1.";
                }
                else if (this.state.formObj.mobileNo === this.state.formObj.secPhone) {
                    formIsValid = false;
                    formErrors["secPhoneErr"] = "Secondary phone number and mobile number cannot be same.";
                }
            }
            if (this.state.formObj.emailAdr.length === 0) {
                formIsValid = false;
                formErrors["emailAdrErr"] = "Email address is required.";
            }
            else {
                let res = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                if (!res.test(this.state.formObj.emailAdr)) {
                    formIsValid = false;
                    formErrors["emailAdrErr"] = "Enter a valid email address.";
                }
            }
            if (this.state.formObj.mailingAdr.length === 0) {
                formIsValid = false;
                formErrors["mailingAdrErr"] = "Mailing address is required.";
            }
            else if (this.state.progressiveLeasing || this.state.SMSLink || this.state.thirdPartySessionLink) {
                let mailaddr1 = this.state.formObj.mailingAdr?.toLowerCase()?.includes("p.o box");
                let mailaddr2 = this.state.formObj.mailingAdr?.toLowerCase()?.includes("p.obox");
                let mailaddr3 = this.state.formObj.mailingAdr?.toLowerCase()?.includes("po box");
                let mailaddr4 = this.state.formObj.mailingAdr?.toLowerCase()?.includes("pobox");
                let mailaddr5 = this.state.formObj.mailingAdr?.toLowerCase()?.includes("p.o. box");
                let mailaddr6 = this.state.formObj.mailingAdr?.toLowerCase()?.includes("po. box");

                if (mailaddr1 || mailaddr2 || mailaddr3 || mailaddr4 || mailaddr5 || mailaddr6) {
                    if (this.state.SMSLink || this.state.thirdPartySessionLink) {
                        formIsValid = false;
                        formErrors["mailingAdrErr"] = "P.O Box is not accepted.";
                    }
                    else {
                        formIsValid = false;
                        formErrors["mailingAdrErr"] = "P.O Box is not accepted by Progressive.";
                    }

                }
                else if ((this.state.formObj.mailingAdr?.split(" ")[0]?.replace(/[0-9]/g, '') === "") && (this.state.formObj.mailingAdr?.trim()?.split(" ")?.length <= 1)) {
                    formIsValid = false;
                    formErrors["mailingAdrErr"] = "Please enter a valid mailing address.";
                }
                else if ((this.state.formObj.mailingAdr?.trim()?.split(" ")?.length <= 1)) {
                    formIsValid = false;
                    formErrors["mailingAdrErr"] = "Please enter a valid mailing address.";
                }
                else {
                    let mailaddr = this.state.formObj.mailingAdr?.split(" ");
                    mailaddr = mailaddr?.filter((val) => { return val !== "" });
                    if ((mailaddr[1]?.replace(/[0-9]/g, "") === "")) {
                        formIsValid = false;
                        formErrors["mailingAdrErr"] = "Please enter a valid mailing address.";
                    }
                }
            }
            else if ((this.state.formObj.mailingAdr?.split(" ")[0]?.replace(/[0-9]/g, '') === "") && (this.state.formObj.mailingAdr?.trim()?.split(" ")?.length <= 1)) {
                formIsValid = false;
                formErrors["mailingAdrErr"] = "Please enter a valid mailing address.";
            }
            else if ((this.state.formObj.mailingAdr?.trim()?.split(" ")?.length <= 1)) {
                formIsValid = false;
                formErrors["mailingAdrErr"] = "Please enter a valid mailing address.";
            }
            else {
                let mailaddr = this.state.formObj.mailingAdr?.split(" ");
                mailaddr = mailaddr?.filter((val) => { return val !== "" });
                if ((mailaddr[1]?.replace(/[0-9]/g, "") === "")) {
                    formIsValid = false;
                    formErrors["mailingAdrErr"] = "Please enter a valid mailing address.";
                }
            }
            if (this.state.allAptUnit?.length > 0) {
                if (this.state.formObj.aptUnit?.length === 0) {
                    formIsValid = false;
                    formErrors["aptUnitErr"] = "Unit number is required.";
                }
            }
            if (this.state.formObj.city.length === 0) {
                formIsValid = false;
                formErrors["cityErr"] = "City is required.";
            }
            if (this.state.progressiveLeasing) {
                if (parseInt(this.state.formObj.state) === 93) {
                    formIsValid = false;
                    formErrors["stateErr"] = "State should not be Mexico if applying for progressive.";
                }
            }
            if (this.state.thirdPartySessionLink) {
                if (isNaN(parseInt(this.state.formObj.state))) {
                    if (this.state.formObj.lstState.find((state) => this.state.formObj.state.toLowerCase() == state.description.toLowerCase()) === undefined) {
                        formIsValid = false;
                        formErrors["stateErr"] = "State is required.";
                    }
                    else {
                        const selectedState = this.state.formObj.lstState.find((state) => this.state.formObj.state.toLowerCase() == state.description.toLowerCase())
                        this.setState({
                            formObj: { ...this.state.formObj, state: selectedState.id },
                        });

                    }
                }
                else {
                    if (this.state.formObj.lstState.find((state) => this.state.formObj.state == state.id) === undefined) {
                        formIsValid = false;
                        formErrors["stateErr"] = "State is required.";
                    }
                }
            }
            else {
                let state = this.state.formObj.lstState.find(item => { return item.id == parseInt(this.state.formObj.state) })
                if (state) {
                    if (parseInt(this.state.formObj.state) === 0) {
                        // console.log("start");
                        formIsValid = false;
                        formErrors["stateErr"] = "State is required.";
                    }
                }
                else {
                    // console.log("start2");
                    formIsValid = false;
                    formErrors["stateErr"] = "State is required.";
                }
            }

            if (this.state.formObj.zipCode.length === 0) {
                formIsValid = false;
                formErrors["zipCodeErr"] = "Zip code is required.";
            }
            else if (this.state.formObj.zipCode.length < 5) {
                formIsValid = false;
                formErrors["zipCodeErr"] = "Zip code must be 5 digit.";
            }

            if (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit)) {
                if (parseInt(this.state.formObj.housingInfo) === 0) {
                    formIsValid = false;
                    formErrors["housingInfoErr"] = "Housing information is required.";
                }
            }

        }

        if (currStep === "Step 4") {
            if (this.state.danielsCredit || this.state.UOwnLeasing) {
                if (this.state.formObj.empName.length === 0) {
                    formIsValid = false;
                    formErrors["empNameErr"] = "Employer's name is required.";
                }
            }

            if (this.state.danielsCredit) {
                if (this.state.formObj.duties.length === 0) {
                    formIsValid = false;
                    formErrors["dutiesErr"] = "Duties is required.";
                }
                if (this.state.formObj.empStartDate.length === 0) {
                    formIsValid = false;
                    formErrors["empStartDateErr"] = "Employment start date is required.";
                }
                else {
                    var empDate = this.state.formObj.empStartDate;
                    empDate = new Date(empDate.split("/")[1], empDate.split("/")[0], this.state.formObj.dob.split("/")[1]);
                    var birthDate = new Date(this.state.formObj.dob);
                    if (birthDate > empDate) {
                        formIsValid = false;
                        formErrors["empStartDateErr"] = "Employment start date could not be before birth date.";
                    }
                }
            }

            if (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit)) {
                if (this.state.formObj.empPhoneNo.length === 0) {
                    formIsValid = false;
                    formErrors["empPhoneNoErr"] = "Employer's phone number is required.";
                }
                else if (this.state.formObj.empPhoneNo.length < 12) {
                    formIsValid = false;
                    formErrors["empPhoneNoErr"] = "Employer's phone number must be 10 digit.";
                }
                else if (this.state.formObj.empPhoneNo.slice(0, 1) == 1 || this.state.formObj.empPhoneNo.slice(0, 1) == 0) {
                    formIsValid = false;
                    formErrors["empPhoneNoErr"] = "Phone number cannot start with a 0 or 1.";
                }
            }

            if (this.state.formObj.netIncome?.length === 0) {
                formIsValid = false;
                formErrors["netIncomeErr"] = "Net income is required.";
            }
            else if (this.state.formObj.netIncome < 100) {
                formIsValid = false;
                formErrors["netIncomeErr"] = "Net income must be greater than $100.";
            }
            else if (this.state.formObj.netIncome > 99999) {
                formIsValid = false;
                formErrors["netIncomeErr"] = "Net income must be lesser than $99999.";
            }
        }
        if (currStep === "Step 5") {
            if (this.state.danielsCredit) {
                if (parseInt(this.state.formObj.primaryIdType) === 0) {
                    formIsValid = false;
                    formErrors["primaryIdTypeErr"] = "Primary ID Type is required.";
                }
                if (this.state.formObj.primaryIdNo.length === 0) {
                    formIsValid = false;
                    formErrors["primaryIdNoErr"] = "Primary ID number is required.";
                }
                else if (this.state.formObj.primaryIdNo.length < 3) {
                    formIsValid = false;
                    formErrors["primaryIdNoErr"] = "Primary ID number should contain at least 3 characters.";
                }

            }
            if (this.state.danielsCredit) {
                if (parseInt(this.state.formObj.primaryIdState) === 0) {
                    formIsValid = false;
                    formErrors["primaryIdStateErr"] = "Primary ID state is required.";
                }
            }
            if (this.state.progressiveLeasing) {
                if (this.state.formObj.primaryIdNo.length === 0) {
                    formIsValid = false;
                    formErrors["primaryIdNoErr"] = "Primary ID number is required.";
                }
                else if (this.state.formObj.primaryIdNo.length < 3) {
                    formIsValid = false;
                    formErrors["primaryIdNoErr"] = "Primary ID number should contain at least 3 characters.";
                }
                if (parseInt(this.state.formObj.primaryIdState) === 93) {
                    formIsValid = false;
                    formErrors["primaryIdStateErr"] = "State should not be Mexico if applying for progressive.";
                }
            }
            if ((this.state.nonSynchronyCD && this.state.synchronyCredit)) {
                if (parseInt(this.state.formObj.primaryIdType) === 0) {
                    formIsValid = false;
                    formErrors["primaryIdTypeErr"] = "Primary ID Type is required.";
                }
                else if (this.state.synchronyCredit) {
                    if (this.state.formObj.lstPrimaryIdType.find(obj => obj.id == this.state.formObj.primaryIdType)?.description === "Consular Id") {
                        formIsValid = false;
                        formErrors["primaryIdTypeErr"] = "Primary ID Type should not be 'Consular ID' if applying for Synchrony.";
                    }
                }
                if (this.state.formObj.primaryIdNo.length === 0) {
                    formIsValid = false;
                    formErrors["primaryIdNoErr"] = "Primary ID number is required.";
                }
                else if (this.state.formObj.primaryIdNo.length < 3) {
                    formIsValid = false;
                    formErrors["primaryIdNoErr"] = "Primary ID number should contain at least 3 characters.";
                }
                if (parseInt(this.state.formObj.primaryIdState) === 0) {
                    formIsValid = false;
                    formErrors["primaryIdStateErr"] = "Primary ID state is required.";
                }
            }
        }

        if (currStep === "Step 6") {
            if (this.state.danielsCredit) {
                if (this.state.formObj.relativeName.length === 0) {
                    formIsValid = false;
                    formErrors["relativeNameErr"] = "Relative name is required.";
                }
                if (this.state.formObj.relativePhone.length === 0) {
                    formIsValid = false;
                    formErrors["relativePhoneErr"] = "Relative phone number is required.";
                }
                else if (this.state.formObj.relativePhone.length < 12) {
                    formIsValid = false;
                    formErrors["relativePhoneErr"] = "Relative Phone number must be 10 digit.";
                }
                else if (this.state.formObj.relativePhone.slice(0, 1) == 1 || this.state.formObj.relativePhone.slice(0, 1) == 0) {
                    formIsValid = false;
                    formErrors["relativePhoneErr"] = "Relative Phone number cannot start with a 0 or 1.";
                }
                else if (this.state.formObj.mobileNo === this.state.formObj.relativePhone) {
                    formIsValid = false;
                    formErrors["relativePhoneErr"] = "Relative phone number and mobile number cannot be same.";
                }
                else if (this.state.formObj.secPhone === this.state.formObj.relativePhone) {
                    formIsValid = false;
                    formErrors["relativePhoneErr"] = "Relative phone number and secondary phone number cannot be same.";
                }
                if (this.state.formObj.relativeRelation.length === 0) {
                    formIsValid = false;
                    formErrors["relativeRelationErr"] = "Relative relation is required.";
                }
            }
        }

        if (currStep === "Step 7") {
            if (this.state.nonSynchronyCD && this.state.synchronyCredit) {
                if (this.state.formObj.primaryIdExpiryDate.length === 0) {
                    formIsValid = false;
                    formErrors["primaryIdExpiryDateErr"] = "Field is required if applying for Synchrony.";
                }
                if (parseInt(this.state.formObj.secondIdType) === 0) {
                    formIsValid = false;
                    formErrors["secondIdTypeErr"] = "Field is required if applying for Synchrony.";
                }
                else if (parseInt(this.state.formObj.primaryIdType) > 0) {
                    if (this.state.formObj.lstSecondIdType.find(obj => obj.id == this.state.formObj.secondIdType)?.description === this.state.formObj.lstPrimaryIdType.find(obj => obj.id == this.state.formObj.primaryIdType)?.description) {
                        formIsValid = false;
                        formErrors["secondIdTypeErr"] = "Primary ID type and secondary ID type cannot be same.";
                    }
                }
                if (this.state.formObj.secondIdIssuedBy.length === 0) {
                    formIsValid = false;
                    formErrors["secondIdIssuedByErr"] = "Field is required if applying for Synchrony.";
                }
                if (this.state.formObj.secondIdExpiryDate.length === 0) {
                    formIsValid = false;
                    formErrors["secondIdExpiryDateErr"] = "Field is required if applying for Synchrony.";
                }
            }
        }

        if (currStep === "Step 8") {
            if (this.state.progressiveLeasing) {
                if (this.state.formObj.bankRouteNo.length === 0) {
                    formIsValid = false;
                    formErrors["bankRouteNoErr"] = "Field is required if applying for Progressive.";
                }
                else if (this.state.formObj.bankRouteNo.length < 9) {
                    formIsValid = false;
                    formErrors["bankRouteNoErr"] = "Bank routing number must be 9 digits.";
                }
                if (this.state.formObj.checkAccNo.length === 0) {
                    formIsValid = false;
                    formErrors["checkAccNoErr"] = "Field is required if applying for Progressive.";
                }
                if (parseInt(this.state.formObj.oftenPaid) === 0) {
                    formIsValid = false;
                    formErrors["oftenPaidErr"] = "Field is required if applying for Progressive.";
                }

                if (this.state.formObj.lastPayDay.length === 0) {
                    formIsValid = false;
                    formErrors["lastPayDayErr"] = "Field is required if applying for Progressive.";
                    formErrors["lastPayDayErr"] = "Field is required if applying for Progressive.";
                    formErrors["lastPayDayErr"] = "Field is required if applying for Progressive.";
                }
                else {
                    let time = new Date().getTime() - (new Date(this.state.formObj.lastPayDay)).getTime();
                    let days = time / (1000 * 3600 * 24);
                    days = Math.floor(days);
                    if (days > 35) {
                        formIsValid = false;
                        formErrors["lastPayDayErr"] = "Last pay date must be within 35 days.";
                    }
                }
                if (this.state.formObj.nextPayDay.length === 0) {
                    formIsValid = false;
                    formErrors["nextPayDayErr"] = "Field is required if applying for Progressive.";
                }
                if (this.state.formObj.cc.length === 0) {
                    formIsValid = false;
                    formErrors["ccErr"] = "Field is required if applying for Progressive.";
                }
                else if (this.state.formObj.cc.length < 7) {
                    formIsValid = false;
                    formErrors["ccErr"] = "Credit card number must be first 6 digit number";
                }

                if (this.state.formObj.ccExpiryDate.length === 0) {
                    formIsValid = false;
                    formErrors["ccExpiryDateErr"] = "Field is required if applying for Progressive.";
                }

                if (this.state.formObj.ccName.length === 0) {
                    formIsValid = false;
                    formErrors["ccNameErr"] = "Field is required if applying for Progressive.";
                }

                if (!this.state.formObj.creditCardBillingAddress) {
                    //formIsValid = false;
                    //formErrors["creditCardBillingAddressErr"] = "Credit card home address is required.";

                    if (this.state.formObj.ccmailingAdr.length === 0) {
                        formIsValid = false;
                        formErrors["ccmailingAdrErr"] = "Field is required if applying for Progressive.";
                    }
                    else {
                        let mailaddr1 = this.state.formObj.ccmailingAdr?.toLowerCase()?.includes("p.o box");
                        let mailaddr2 = this.state.formObj.ccmailingAdr?.toLowerCase()?.includes("p.obox");
                        let mailaddr3 = this.state.formObj.ccmailingAdr?.toLowerCase()?.includes("po box");
                        let mailaddr4 = this.state.formObj.ccmailingAdr?.toLowerCase()?.includes("pobox");
                        let mailaddr5 = this.state.formObj.mailingAdr?.toLowerCase()?.includes("p.o. box");
                        let mailaddr6 = this.state.formObj.mailingAdr?.toLowerCase()?.includes("po. box");
                        if (mailaddr1 || mailaddr2 || mailaddr3 || mailaddr4 || mailaddr5 || mailaddr6) {
                            formIsValid = false;
                            formErrors["ccmailingAdrErr"] = "P.O Box is not accepted by Progressive.";
                        }
                    }
                    // if (this.state.formObj.ccaptUnit.length === 0) {
                    //     formIsValid = false;
                    //     formErrors["ccaptUnitErr"] = "Apt/Unit is required.";
                    // }

                    if (this.state.formObj.cccity.length === 0) {
                        formIsValid = false;
                        formErrors["cccityErr"] = "Field is required if applying for Progressive.";
                    }

                    if (parseInt(this.state.formObj.ccstate) === 0) {
                        formIsValid = false;
                        formErrors["ccstateErr"] = "Field is required if applying for Progressive.";
                    }
                    if (this.state.progressiveLeasing) {
                        if (parseInt(this.state.formObj.ccstate) === 93) {
                            formIsValid = false;
                            formErrors["ccstateErr"] = "State should not be Mexico if applying for progressive.";
                        }
                    }
                    if (this.state.formObj.cczipCode.length === 0) {
                        formIsValid = false;
                        formErrors["cczipCodeErr"] = "Field is required if applying for Progressive.";
                    }
                }
            }
        }

        if (currStep === "Step 9") {
            if (this.state.UOwnLeasing) {
                if (parseInt(this.state.formObj.oftenPaid) === 0) {
                    formIsValid = false;
                    formErrors["uOwnOftenPaidErr"] = "Field is required if applying for Uown.";
                }
                if (this.state.formObj.lastPayDay.length === 0) {
                    formIsValid = false;
                    formErrors["uOwnLastPayDayErr"] = "Field is required if applying for Uown.";
                }
                else {
                    let time = new Date().getTime() - (new Date(this.state.formObj.lastPayDay)).getTime();
                    let days = time / (1000 * 3600 * 24);
                    days = Math.floor(days);
                    if (days > 36) {
                        formIsValid = false;
                        formErrors["uOwnLastPayDayErr"] = "Last pay date must be within 35 days.";
                    }
                }
                if (this.state.formObj.nextPayDay.length === 0) {
                    formIsValid = false;
                    formErrors["uOwnNextPayDayErr"] = "Field is required if applying for Uown.";
                }
            }
        }

        if (currStep === "Step 10") {
            if (this.state.isAutoPayEnabled) {
                if (this.state.danielsCredit === true) {
                    if (this.state.autoPay === true) {
                        if (this.state.autoPayStatus.length === 0) {
                            formIsValid = false;
                            formErrors["autoPayErr"] = "Auto pay submission is required if you opt for auto pay.";
                        }
                    }
                }
            }
        }

        if (currStep === "Step 11") {
            if (this.state.danielsCredit && this.state.isDanielEStatementDisclosure) {
                if (!this.state.notify_me_via_text_at && !this.state.notify_me_via_email_at) {
                    formIsValid = false;
                    formErrors["notifyViaTextandEmailErr"] = "At least one option selection is required.";
                }
            }
        }

        if (currStep === "Step 12") {
            if (this.state.danielsCredit === true) {
                if (!this.state.danielsDisclosure) {
                    formIsValid = false;
                    formErrors["danielsDisclosureErr"] = "Disclosure agreement is required.";
                }
                if (this.state.thirdPartyLink === true) {
                    if (this.state.captchaVerified === false) {
                        formIsValid = false;
                        formErrors["captchaErr"] = "Captcha verification is required.";
                    }
                }
            }
            if (this.state.synchronyCredit === true) {
                if (!this.state.synchronyDisclosure) {
                    formIsValid = false;
                    formErrors["synchronyDisclosureErr"] = "Disclosure agreement is required.";
                }

            }
            if (this.state.fortivaCredit === true) {
                if (!this.state.synchronyCredit) {
                    if (!this.state.fortivaDisclosure) {
                        formIsValid = false;
                        formErrors["fortivaDisclosureErr"] = "Disclosure agreement is required.";
                    }
                    if (!this.state.fortivaElecDisclosure) {
                        formIsValid = false;
                        formErrors["fortivaElecDiscErr"] = "Disclosure agreement is required.";
                    }
                    if (!this.state.fortivaWrittenInstr) {
                        formIsValid = false;
                        formErrors["fortivaWrittenInstrErr"] = "Disclosure agreement is required.";
                    }

                }
            }
            if (this.state.fortivaCredit === true && this.state.synchronyCredit === true) {
                if (!this.state.fortivaElecDisclosure) {
                    formIsValid = false;
                    formErrors["fortivaElecDiscErr"] = "Disclosure agreement is required.";
                }
            }
            if (this.state.progressiveLeasing === true) {
                if (!this.state.progressiveDisclosure) {
                    formIsValid = false;
                    formErrors["progressiveDisclosureErr"] = "Disclosure agreement is required.";
                }
            }
            if (this.state.UOwnLeasing === true) {
                if (!this.state.UOwnDisclosure) {
                    formIsValid = false;
                    formErrors["UOwnDisclosureErr"] = "Disclosure agreement is required.";
                }
            }
        }

        if (currStep === "employee validation") {
            if (this.state.nonSynchronyCD && this.state.synchronyCredit) {
                if (this.state.applicantIdMatch === false) {
                    formIsValid = false;
                    formErrors["applicantIdMatchErr"] = "Field is required if applying for Synchrony.";
                }
                if (this.state.synchronyAgreementGiven === false) {
                    formIsValid = false;
                    formErrors["synchronyAgreementGivenErr"] = "Field is required if applying for Synchrony.";
                }
                if (!this.state.isVerifyPassword) {
                    formIsValid = false;
                    formErrors["associateVerifiedErr"] = "Associate Verification is required.";
                }
            }
            if ((this.state.nonSynchronyCD && this.state.synchronyCredit) && !this.state.danielsCredit) {
                if (this.state.chkSynchronyOnly === false) {
                    formIsValid = false;
                    formErrors["chkSynchronyOnlyErr"] = "Field is required if applying for Synchrony.";
                }
            }
        }

        if (currStep === "Authentication Failed") {
            formIsValid = false;
            formErrors["associateVerifiedErr"] = "Authentication Failed. Email/Password is invalid.";
        }



        //if (parseInt(this.state.formObj.bankAccountDuration) === 0) {
        //    formIsValid = false;
        //    formErrors["bankAccountDurationErr"] = "Bank Account Duration is required.";
        //}

        this.setState({ formErrors: formErrors });
        return formIsValid;
    }
    disclosureValidation() {
        let formErrors = {};
        formErrors["danielsDisErr"] = "";
        formErrors["synchronyDisErr"] = "";
        formErrors["progressiveDisErr"] = "";
        formErrors["uownDisErr"] = "";
        formErrors["fortivaDisErr"] = "";
        if (this.state.fortivaCredit) {
            if (this.state.fortivaCredit && this.state.synchronyCredit) {
                if (this.state.fortivaElecDisclosure) {
                    formErrors["fortivaDisErr"] = "";
                }
                else {
                    formErrors["fortivaDisErr"] = "Fortiva disclsoures not checked";
                }
            }
            else {
                if (this.state.fortivaElecDisclosure && this.state.fortivaDisclosure && this.state.fortivaWrittenInstr) {
                    formErrors["fortivaDisErr"] = "";
                }
                else {
                    formErrors["fortivaDisErr"] = "Fortiva disclsoures not checked";
                }
            }

        }
        if (this.state.danielsCredit) {
            if (this.state.thirdPartyLink || this.state.thirdPartySessionLink) {
                if (this.state.danielsDisclosure && this.state.captchaVerified) {
                    formErrors["danielsDisErr"] = "";
                }
                else {
                    formErrors["danielsDisErr"] = "daniels disclsoures not checked";
                }
            }
            else {
                if (this.state.danielsDisclosure) {
                    formErrors["danielsDisErr"] = "";
                }
                else {
                    formErrors["danielsDisErr"] = "daniels disclsoures not checked";
                }
            }
        }
        if (this.state.synchronyCredit) {
            if (this.state.nonSynchronyCD) {
                //old synchrony
                if (this.state.synchronyCredit && !this.state.danielsCredit) {
                    if (this.state.synchronyDisclosure && this.state.isVerifyPassword && this.state.applicantIdMatch && this.state.chkSynchronyOnly && this.state.synchronyAgreementGiven) {
                        formErrors["synchronyDisErr"] = "";
                    }
                    else {
                        formErrors["synchronyDisErr"] = "synchrony disclsoures not checked";
                    }
                }
                else {
                    if (this.state.synchronyDisclosure && this.state.isVerifyPassword && this.state.applicantIdMatch && this.state.synchronyAgreementGiven) {
                        formErrors["synchronyDisErr"] = "";
                    }
                    else {
                        formErrors["synchronyDisErr"] = "synchrony disclsoures not checked";
                    }
                }

            } else {
                if (this.state.synchronyDisclosure) {
                    formErrors["synchronyDisErr"] = "";
                }
                else {
                    formErrors["synchronyDisErr"] = "synchrony disclsoures not checked";
                }
            }
        }
        if (this.state.progressiveLeasing) {
            if (this.state.progressiveDisclosure) {
                formErrors["progressiveDisErr"] = "";
            }
            else {
                formErrors["progressiveDisErr"] = "progressive disclsoures not checked";
            }
        }
        if (this.state.UOwnLeasing) {
            if (this.state.UOwnDisclosure) {
                formErrors["uownDisErr"] = "";
            }
            else {
                formErrors["uownDisErr"] = "uown disclsoures not checked";
            }
        }
        this.setState({ formErrors: formErrors });
        return formErrors;
    }

    verifyCaptcha = (response) => {
        if (response) {
            this.setState({ captchaVerified: true }, () => {
                let formErrors = this.disclosureValidation();
                this.gayOutSubmit(formErrors);
            });
        }
    }

    gayOutSubmit(formErrors) {
        let { fortivaDisErr, danielsDisErr, synchronyDisErr, progressiveDisErr, uownDisErr } = formErrors;
        if (!fortivaDisErr && !danielsDisErr && !synchronyDisErr && !progressiveDisErr && !uownDisErr) {
            this.setState({ isAlldisclosuresChecked: true });
        }
        else
            this.setState({ isAlldisclosuresChecked: false });
    }

    handleToggleSidebar() {
        this.setState({
            toggled: !this.state.toggled
        });
    };

    handleSubmittedAlert(event) {
        event.preventDefault();
        this.setState({ showSubmittedAlert: !this.state.showSubmittedAlert });
        let fortivaAPIErrorMsg = this.state.fortivaAppErrMsg;
        let customerId = localStorage.getItem("customerId");
        if (fortivaAPIErrorMsg) {
            this.redirectToViewOffers();
        }
        else if (this.state.isWaterFallEnable) {
            if ((this.state.danielsCredit) && !this.state.progressiveLeasing && !this.state.UOwnLeasing && !this.state.synchronyCredit && !this.state.fortivaCredit) {
                this.setState({ waterfallObj: { ...this.state.waterfallObj, waterFallStatus: true } });
            }
            else if ((this.state.fortivaCredit || this.state.danielsCredit) && !this.state.progressiveLeasing && !this.state.UOwnLeasing && !this.state.synchronyCredit) {
                this.fortivaOffers();
            }
            else if (this.state.synchronyCredit && (!this.state.fortivaCredit && !this.state.danielsCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing)) {
                let isSynchronyOnly = true;
                this.synchronyOffers(isSynchronyOnly);
            }
            else if ((this.state.synchronyCredit && this.state.fortivaCredit) && !this.state.danielsCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing) {
                this.synchronyOffers();
            }
            else if (this.state.synchronyCredit && this.state.fortivaCredit && this.state.danielsCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing) {
                this.synchronyOffers();
            }
            else if ((this.state.synchronyCredit && this.state.danielsCredit) && !this.state.progressiveLeasing && !this.state.UOwnLeasing && !this.state.fortivaCredit) {
                this.synchronyOffers();
                this.setState({ waterfallObj: { ...this.state.waterfallObj } });
            }
            else if (this.state.progressiveLeasing || this.state.UOwnLeasing) {
                this.redirectToViewOffers();
            }
            else {
                this.redirectToViewOffers();
            }
        }
        else {
            this.redirectToViewOffers();
        }
    }

    redirectToViewOffers() {
        if (sessionStorage.getItem("logout/continue") == "true")
            window.location.replace("https://www.danielsjewelers.com/");
        else
            this.props.history.push("/view-offers");
    }
    onProgressiveLeasingChecked() {
        this.setState({ progressiveLeasing: !this.state.progressiveLeasing }, () => {
            let formErrors = this.disclosureValidation();
            this.gayOutSubmit(formErrors);
        });
    }

    onDanielsCreditChecked() {
        this.setState({ danielsCredit: !this.state.danielsCredit }, () => {
            let formErrors = this.disclosureValidation();
            this.gayOutSubmit(formErrors);
            this.trackChanges();
        });
    }
    onFortivaChecked() {
        this.setState({ fortivaCredit: !this.state.fortivaCredit }, () => {
            let formErrors = this.disclosureValidation();
            this.gayOutSubmit(formErrors);
        });
    }

    onCreditCardBillingAddressChecked() {
        this.setState({
            formObj: { ...this.state.formObj, creditCardBillingAddress: !this.state.formObj.creditCardBillingAddress },
        });
    }

    onSynchronyCreditChecked() {
        this.setState({ synchronyCredit: !this.state.synchronyCredit }, () => {
            let formErrors = this.disclosureValidation();
            this.gayOutSubmit(formErrors);
        });
    }

    onDanielsDisclosureChecked() {
        this.setState({ danielsDisclosure: !this.state.danielsDisclosure }, () => {
            let formErrors = this.disclosureValidation();
            this.gayOutSubmit(formErrors);
        })
    }
    onSynchronyDisclosureChecked() {
        this.setState({ synchronyDisclosure: !this.state.synchronyDisclosure }, () => {
            let formErrors = this.disclosureValidation();
            this.gayOutSubmit(formErrors);
        });
    }
    onApplicantIdMatchChecked() {
        this.setState({ applicantIdMatch: !this.state.applicantIdMatch }, () => {
            let formErrors = this.disclosureValidation();
            this.gayOutSubmit(formErrors);
        });
    }
    onSynchronyAgreementGivenChecked() {
        this.setState({ synchronyAgreementGiven: !this.state.synchronyAgreementGiven }, () => {
            let formErrors = this.disclosureValidation();
            this.gayOutSubmit(formErrors);
        });
    }
    onChkSynchronyOnly() {
        this.setState({ chkSynchronyOnly: !this.state.chkSynchronyOnly }, () => {
            let formErrors = this.disclosureValidation();
            this.gayOutSubmit(formErrors);
        });
    }
    onAutoPayChecked() {
        this.setState({ autoPay: !this.state.autoPay });

    }
    onDanielEStatementDisclosureChecked() {
        this.setState({ isDanielEStatementDisclosure: !this.state.isDanielEStatementDisclosure }, () => {
            if (!this.state.isDanielEStatementDisclosure)
                this.setState({ notify_me_via_text_at: false, notify_me_via_email_at: false });
        });
    }
    onNotifyMeViaTextOrEmailChecked(type) {
        if (type === "Text")
            this.setState({ notify_me_via_text_at: !this.state.notify_me_via_text_at });
        if (type === "Email")
            this.setState({ notify_me_via_email_at: !this.state.notify_me_via_email_at });
    }
    onDanielsEstatementDisclosureClicked = (event) => {
        event.preventDefault();
        this.setState({ showEstatementPopup: !this.state.showEstatementPopup });
    }
    augmentAutoPay() {
        this.setState({ autoPayModal: !this.state.autoPayModal });
    }
    onDanielsDisclosureClicked = (event) => {
        event.preventDefault();
        this.setState({ showPopup: !this.state.showPopup });
    }
    onFortivaDisclosure = (event) => {
        this.setState({ [event.target.name]: event.target.checked }, () => {
            let formErrors = this.disclosureValidation();
            this.gayOutSubmit(formErrors);
        });
    }
    isAgreedRevort = () => {
        this.setState({ isAgreed: false });
    }
    onProgressiveDisclosureChecked() {
        this.setState({ progressiveDisclosure: !this.state.progressiveDisclosure }, () => {
            let formErrors = this.disclosureValidation();
            this.gayOutSubmit(formErrors);
        });
    }
    onProgressiveSMSChecked() {
        this.setState({ progressiveSMS: !this.state.progressiveSMS });
    }
    onUOwnLeasingChecked() {
        this.setState({ UOwnLeasing: !this.state.UOwnLeasing }, () => {
            let formErrors = this.disclosureValidation();
            this.gayOutSubmit(formErrors);
        });
    }
    onUOwnDisclosureChecked() {
        this.setState({ UOwnDisclosure: !this.state.UOwnDisclosure }, () => {
            let formErrors = this.disclosureValidation();
            this.gayOutSubmit(formErrors);
        });
    }

    onVerifyPassword(event) {
        event.preventDefault();
        this.setState({ verifyPassword: true });
    }

    goStep1(event) {
        event.preventDefault();
        if (this.state.isStep1Complete) {
            this.setState({ step1: !this.state.step1 });
        }
    }

    goStep2(event) {
        event.preventDefault();
        if (this.state.isStep2Complete) {
            this.setState({ step2: !this.state.step2 });
        }
    }

    goStep3(event) {
        event.preventDefault();
        if (this.state.isStep3Complete) {
            this.setState({ step3: !this.state.step3 });
        }
    }

    goStep4(event) {
        event.preventDefault();
        if (this.state.isStep4Complete) {
            this.setState({ step4: !this.state.step4 });
        }
    }

    goStep5(event) {
        event.preventDefault();
        if (this.state.isStep5Complete) {
            this.setState({ step5: !this.state.step5 });
        }
    }

    goStep6(event) {
        event.preventDefault();
        if (this.state.isStep6Complete) {
            this.setState({ step6: !this.state.step6 });
        }
    }

    goStep7(event) {
        event.preventDefault();
        if (this.state.isStep7Complete) {
            this.setState({ step7: !this.state.step7 });
        }
    }

    goStep8(event) {
        event.preventDefault();
        if (this.state.isStep8Complete) {
            this.setState({ step8: !this.state.step8 });
        }
    }

    goStep9(event) {
        event.preventDefault();
        if (this.state.isStep9Complete) {
            this.setState({ step9: !this.state.step9 });
        }
    }
    goStep10(event) {
        event.preventDefault();
        if (this.state.isStep10Complete) {
            this.setState({ step10: !this.state.step10 });
        }
    }
    goStep11(event) {
        event.preventDefault();
        if (this.state.isStep11Complete) {
            this.setState({ step11: !this.state.step11 });
        }
    }
    goStep12(event) {
        event.preventDefault();
        if (this.state.isStep12Complete) {
            this.setState({ step12: !this.state.step12 });
        }
    }

    submitMobileNo(event) {
        event.preventDefault();
        this.setState({ isSMSErrorMsg: "" });
        if (this.handleFormValidation("mobileNo")) {
            let obj = {
                "firstName": (sessionStorage.getItem("isNewApplication") == "false" ? this.state.formObj.firstName?.split(",")[0] : "New"),
                "lastName": (sessionStorage.getItem("isNewApplication") == "false" ? this.state.formObj.lastName === "" ? (this.state.formObj.firstName?.split(" ")[1] === undefined ? this.state.formObj.firstName?.split(",")[0] : this.state.formObj.firstName?.split(" ")[1]) : this.state.formObj.lastName : "User"),
                "mobileNo": this.state.formObj.mobileNo,
                "message": "",
                "code": "",
                "sendRica": false,
            }
            trackPromise(
                this.props.actions.mobilesendcodeormsg(obj).then(
                    response => {
                        if (response) {
                            this.setState({ isSMSError: false, isSMSErrorMsg: '' });
                            if (response.twilioStatus?.toLowerCase() === "pending") {
                                this.setState({ toastModal: !this.state.toastModal, SMSCodeSent: true });
                                this.txtVerificationCode.focus();
                            }
                            else if (response.errorMessage?.length > 0 && JSON.parse(sessionStorage.getItem("thirdPartyLink")) != true) {
                                this.setState({ isSMSError: true });
                                this.setState({ isSMSErrorMsg: "Error in connection, please bypass sms to process further." });
                            }
                            else if (response.errorMessage.length > 0 && JSON.parse(sessionStorage.getItem("thirdPartyLink"))) {
                                this.setState({ isSMSError: true });
                                this.setState({ isSMSErrorMsg: "Error in connection, please try after sometime." });
                            }
                        }
                    }
                ).catch(err => {
                    APIFailedMessage.displayError(err);
                })
            )
        }
    }
    async submitStep1(event) {
        event.preventDefault();
        if (this.handleFormValidation("Step 1")) {
            if (this.state.formObj.account) {
                if (((!this.state.danielsCredit || !this.state.synchronyCredit || !this.state.fortivaCredit) && this.state.fortivaAppErrMsgDesc?.length === 0) && (!this.state.isStep1Complete)) {
                    this.setState({ isLeasingAppOnly: !this.state.isLeasingAppOnly })
                }
                this.setState({ step1: true, isStep1Complete: true, step2: true }, () => {
                    document.getElementById("txtMobileNo")?.focus();
                });
            }
            else {
                if (await this.validateDuplicateCustomer()) {
                    if (((!this.state.danielsCredit || !this.state.synchronyCredit || !this.state.fortivaCredit) && this.state.fortivaAppErrMsgDesc?.length === 0) && (!this.state.isStep1Complete)) {
                        this.setState({ isLeasingAppOnly: !this.state.isLeasingAppOnly })
                    }
                    this.setState({ step1: true, isStep1Complete: true, step2: true }, () => {
                        document.getElementById("txtMobileNo")?.focus();
                    });
                }
            }
        }
    }

    //Associate need to relogin in logout&continue scenario to view duplicate customer popup.
    associateRelogin() {
        this.setState({ associateRelogin: false });
        try {
            this.props.authActions.login().then(
                res => {
                    if (res) {
                        localStorage.setItem('loggedUserName', res.idToken.name);
                        localStorage.setItem('loggedUserEmail', res.account.userName);
                        localStorage.setItem('loggedUserObjectId', res.idToken.objectId);
                        if (this.state.duplicateCustData?.customer_id !== 0) {
                            this.setState({ isDuplicateCustomer: true });
                        }
                        else {
                            this.setState({ isMagixDuplicateCustomer: true });
                        }
                    }
                }
            )
        }
        catch (error) {
            APIFailedMessage.displayError(error);
        }
    }
    handleErrorMessage() {
        this.setState({ isAPIError: false, isAPIErrorMsg: "" });
        //let progUownApplications=sessionStorage.getItem("progUownApplications");
        // if(progUownApplications){
        //     let reg2 =/nextpaydate/gi;  
        //     if(!this.state.isAPIErrorMsg.match(reg2)){
        //         let customerId = localStorage.getItem("customerId");
        //         sessionStorage.removeItem("progUownApplications");
        //         if(sessionStorage.getItem("logout/continue") == "true") {
        //             window.location.replace("https://www.danielsjewelers.com/");
        //         }
        //         else{
        //             this.props.history.push(`/customer-details/${customerId}`)
        //         }
        //     }
        // }
    }

    handleAccessModal = () => {
        this.setState({ noStoreAssign: false, accessModal: false, userStatus: false });
        window.location.replace(window.location.href?.split("/apply")[0]);
    }
    loadAllAddresses(searchFilter) {
        if (searchFilter?.length > 2){
            var searchObj = {
                line1: searchFilter.split(",")[0]?.replace(",", ""),
                city: searchFilter.split(",")[1] === undefined ? "" : searchFilter.split(",")[1]?.trim(),
                state: searchFilter.split(",")[2] === undefined ? "" : searchFilter.split(",")[2]?.trim()
            }
            this.props.actions.getAddress(searchObj).then(
                response => {
                    if (response) {
                        let array = response.Results?.map((val) => {
                            return val.Address;
                        });
                        array?.map((item) => {
                            item.fullAddress = item?.AddressLine1 + ", " + item?.City + ", " + item?.State + ", " + item?.PostalCode?.split("-")[0] + (item?.SuiteName == "" ? "" : ", " + item?.SuiteName)
                        })
                        if (this.state.formObj.mailingAdr?.length > 2)
                            this.setState({ allAddress: array });
                        else
                            this.setState({ allAddress: [] });
                    }
                }
            ).catch(err => {
                APIFailedMessage.displayError(err);
            })
        }
    }
    submitStep2(event) {
        event.preventDefault();
        if (this.handleFormValidation("mobileNo") && this.handleFormValidation("verificationCodeCheck")) {
            if (this.state.showTempCode) {
                if ((this.state.formObj.verificationCode === "010101")) {
                    this.setState({ isSMSOverride: true });
                    if (this.handleFormValidation("Step 1")) {
                        this.setState({ isSMSError: false, isSMSErrorMsg: '' });
                        this.setState({ step2: true, isStep2Complete: true, step3: true });
                        setTimeout(() => {
                            document.getElementById("txtFirstName")?.focus();
                        }, 200);
                    }
                }
                else {
                    let obj = {
                        "firstName": (sessionStorage.getItem("isNewApplication") == "false" ? this.state.formObj.firstName?.split(",")[0] : "New"),
                        "lastName": (sessionStorage.getItem("isNewApplication") == "false" ? this.state.formObj.lastName === "" ? (this.state.formObj.firstName?.split(" ")[1] === undefined ? this.state.formObj.firstName?.split(",")[0] : this.state.formObj.firstName?.split(" ")[1]) : this.state.formObj.lastName : "User"),
                        "mobileNo": this.state.formObj.mobileNo,
                        "message": "",
                        "code": this.state.formObj.verificationCode,
                        "sendRica": false,
                    }
                    trackPromise(
                        this.props.actions.mobilesendcodeormsg(obj).then(
                            response => {
                                if (response) {
                                    if (response.twilioStatus?.toLowerCase() === "approved") {
                                        if (this.handleFormValidation("Step 1")) {
                                            this.setState({ isSMSError: false, isSMSErrorMsg: '', isSMSVerified: true });
                                            this.setState({ step2: true, isStep2Complete: true, step3: true });
                                            setTimeout(() => {
                                                document.getElementById("txtFirstName")?.focus();
                                            }, 200);
                                        }
                                    }
                                    else if (response.twilioStatus?.toLowerCase() === "pending") {
                                        this.handleFormValidation("codeMatchFailed");
                                    }
                                }
                            }
                        ).catch(err => {
                            APIFailedMessage.displayError(err);
                        })
                    )
                }
            }
            else {
                let obj = {
                    "firstName": (sessionStorage.getItem("isNewApplication") == "false" ? this.state.formObj.firstName?.split(",")[0] : "New"),
                    "lastName": (sessionStorage.getItem("isNewApplication") == "false" ? this.state.formObj.lastName === "" ? (this.state.formObj.firstName?.split(" ")[1] === undefined ? this.state.formObj.firstName?.split(",")[0] : this.state.formObj.firstName?.split(" ")[1]) : this.state.formObj.lastName : "User"),
                    "mobileNo": this.state.formObj.mobileNo,
                    "message": "",
                    "code": this.state.formObj.verificationCode,
                    "sendRica": false,
                }
                trackPromise(
                    this.props.actions.mobilesendcodeormsg(obj).then(
                        response => {
                            if (response) {
                                if (response.twilioStatus?.toLowerCase() === "approved") {
                                    if (this.handleFormValidation("Step 1")) {
                                        this.setState({ isSMSError: false, isSMSErrorMsg: '', isSMSVerified: true });
                                        this.setState({ step2: true, isStep2Complete: true, step3: true });
                                        setTimeout(() => {
                                            document.getElementById("txtFirstName")?.focus();
                                        }, 200);
                                    }
                                }
                                else if (response.twilioStatus?.toLowerCase() === "pending" || response.twilioStatus === null) {
                                    this.handleFormValidation("codeMatchFailed");
                                }
                            }
                        }
                    ).catch(err => {
                        APIFailedMessage.displayError(err);
                    })
                )
            }
        }
    }

    async submitStep3(event) {
        event.preventDefault();
        if (!this.handleFormValidation("Step 1")) {
            this.setState({ errorInActVerification: true });
        }
        if (!this.handleFormValidation("Step 2")) {
            this.setState({ errorInMobileInfo: true });
        }
        if (this.handleFormValidation("Step 1") && this.handleFormValidation("Step 2") && this.handleFormValidation("Step 3")) {
            if (this.validateAddress()) {
                this.finishStep3();
            }
        }
    }
    finishStep3() {
        this.setState({ step3: true, isStep3Complete: true, step4: true });
        if (!this.state.formObj.account) {
            this.createCustomer();
        }
        setTimeout(() => {
            if (this.state.danielsCredit) {
                document.getElementById("txtEmpName")?.focus();
            }
            else if (this.state.nonSynchronyCD && this.state.synchronyCredit) {
                document.getElementById("txtEmpPhoneNo")?.focus();
            }
            else if (this.state.synchronyCredit || this.state.fortivaCredit || this.state.progressiveLeasing) {
                document.getElementById("txtNetIncome")?.focus();
            }
        }, 200);
    }

    validateAddress() {
        let mailingAdr = this.state.formObj.mailingAdr ?? "";
        let aptUnit = this.state.formObj.aptUnit ?? "";
        let city = this.state.formObj.city ?? "";
        let state = this.state.formObj.lstState?.find((val) => val.id === this.state.formObj.state)?.code ?? "";
        let zipCode = this.state.formObj.zipCode ?? "";

        let originalAddress = mailingAdr;
        if (city !== '') originalAddress += ', ' + city;
        if (state !== '') originalAddress += ', ' + state;
        if (zipCode !== '') originalAddress += ', ' + zipCode;

        let allAddress = this.state.allAddress.filter(address => address.fullAddress.toLowerCase().startsWith(mailingAdr.toLowerCase()));
        if (allAddress.length <= 0) {
            this.setState({ originalAddress: originalAddress, suggestedAddress: 'N/A', showAddressSuggestionForm: true });
            return false;
        }
        if (aptUnit !== '') originalAddress += ', ' + aptUnit;

        if (allAddress?.length != null && allAddress?.length > 0) {
            let isValidAddress = allAddress.some(address => {
                let fullAddress = address.fullAddress;
                if (address.SuiteCount > 0 && aptUnit !== '') {
                    let suite = ''
                    suite = address.SuiteList.find(suite => suite.toLowerCase() === aptUnit.toLowerCase());
                    if (suite === undefined) {
                        return fullAddress.toLowerCase() === originalAddress.toLowerCase()
                    }

                    let lastCommaIndex = fullAddress.lastIndexOf(',');
                    fullAddress = fullAddress.substring(0, lastCommaIndex);
                    fullAddress += ', ' + suite;
                }
                return fullAddress.toLowerCase() === originalAddress.toLowerCase()
            });
            if (!isValidAddress) {
                this.setState({ originalAddress: originalAddress, suggestedAddress: allAddress[0].fullAddress, showAddressSuggestionForm: true });
                return false;
            }
        }
        return true;
    }

    onUseOriginalAddress() {
        this.setState({ originalAddress: '', suggestedAddress: '', showAddressSuggestionForm: false });
        this.finishStep3();
    }

    onUseSuggestedAddress() {
        let suggestedFullAddress = this.state.suggestedAddress;
        let suggestedAddress = this.state.allAddress.find(address => address.fullAddress.toLowerCase() === suggestedFullAddress.toLowerCase());
        if (suggestedAddress !== undefined) {
            this.autoFill(suggestedAddress.AddressKey);
        }
        this.setState({ originalAddress: '', suggestedAddress: '', showAddressSuggestionForm: false });
    }

    submitStep4(event) {
        event.preventDefault();
        if (!this.handleFormValidation("Step 1")) {
            this.setState({ errorInActVerification: true });
        }
        if (!this.handleFormValidation("Step 2")) {
            this.setState({ errorInMobileInfo: true });
        }
        if (!this.handleFormValidation("Step 3")) {
            this.setState({ errorInPersonalInfo: true });
        }
        if (this.handleFormValidation("Step 1") && this.handleFormValidation("Step 2") && this.handleFormValidation("Step 3") && this.handleFormValidation("Step 4")) {
            this.setState({ step4: true, isStep4Complete: true, step5: true });
            setTimeout(() => {
                if (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit)) {
                    document.getElementById("cmbPrimaryIdType")?.focus();
                }
                else if (this.state.progressiveLeasing) {
                    document.getElementById("txtPrimaryIdNo")?.focus();
                }
                else {
                    document.getElementById("confirmStep5")?.focus();
                }
            }, 200);
        }
    }

    submitStep5(event) {
        event.preventDefault();
        if (!this.handleFormValidation("Step 1")) {
            this.setState({ errorInActVerification: true });
        }
        if (!this.handleFormValidation("Step 2")) {
            this.setState({ errorInMobileInfo: true });
        }
        if (!this.handleFormValidation("Step 3")) {
            this.setState({ errorInPersonalInfo: true });
        }
        if (!this.handleFormValidation("Step 4")) {
            this.setState({ errorInEmployment: true });
        }
        if (this.handleFormValidation("Step 1") && this.handleFormValidation("Step 2") && this.handleFormValidation("Step 3") && this.handleFormValidation("Step 4") && this.handleFormValidation("Step 5")) {
            this.setState({ step5: true, isStep5Complete: true, step6: true });
            setTimeout(() => {
                if (this.state.danielsCredit || this.state.SMSLink || this.state.thirdPartySessionLink) {
                    document.getElementById("txtRelativeName")?.focus();
                }
                else {
                    document.getElementById("confirmStep6")?.focus();
                }
            }, 200);
        }
    }

    submitStep6(event) {
        event.preventDefault();
        if (!this.handleFormValidation("Step 1")) {
            this.setState({ errorInActVerification: true });
        }
        if (!this.handleFormValidation("Step 2")) {
            this.setState({ errorInMobileInfo: true });
        }
        if (!this.handleFormValidation("Step 3")) {
            this.setState({ errorInPersonalInfo: true });
        }
        if (!this.handleFormValidation("Step 4")) {
            this.setState({ errorInEmployment: true });
        }
        if (!this.handleFormValidation("Step 5")) {
            this.setState({ errorInIdentification: true });
        }
        if (this.handleFormValidation("Step 1") && this.handleFormValidation("Step 2") && this.handleFormValidation("Step 3") && this.handleFormValidation("Step 4") && this.handleFormValidation("Step 5") && this.handleFormValidation("Step 6")) {
            if (this.state.thirdPartySessionLink) {
                this.setState({ step9: true, isStep9Complete: true, step10: true });
                setTimeout(() => {
                    if ((this.state.cartId?.length > 0 && this.state.cartId !== "0")) {
                        document.getElementById("chkAutoPay")?.focus();
                    }
                    else {
                        document.getElementById("confirmStep10")?.focus();
                    }
                }, 200);
            }
            else if (this.state.SMSLink) {
                this.setState({ step11: true, isStep11Complete: true, step12: true }, () => {
                    document.getElementById("chkDanielsDisclosure")?.focus();
                });
            }
            else if (this.state.nonSynchronyCD && this.state.synchronyCredit) {
                this.setState({ step6: true, isStep6Complete: true, step7: true });
                setTimeout(() => {
                    if (this.state.synchronyCredit) {
                        document.getElementById("txtPrimaryIdExpiryDate")?.focus();
                    }
                    else {
                        document.getElementById("confirmStep8")?.focus();
                    }
                }, 200);
            }
            else {
                this.setState({ step6: true, isStep6Complete: true, step7: true });
                setTimeout(() => {
                    if (this.state.progressiveLeasing) {
                        document.getElementById("txtBankRouteNo")?.focus();
                    }
                    else {
                        document.getElementById("confirmStep8")?.focus();
                    }
                }, 200);
            }
        }
    }

    async submitStep7(event) {
        event.preventDefault();
        if (!this.handleFormValidation("Step 1")) {
            this.setState({ errorInActVerification: true });
        }
        if (!this.handleFormValidation("Step 2")) {
            this.setState({ errorInMobileInfo: true });
        }
        if (!this.handleFormValidation("Step 3")) {
            this.setState({ errorInPersonalInfo: true });
        }
        if (!this.handleFormValidation("Step 4")) {
            this.setState({ errorInEmployment: true });
        }
        if (!this.handleFormValidation("Step 5")) {
            this.setState({ errorInIdentification: true });
        }
        if (!this.handleFormValidation("Step 6")) {
            this.setState({ errorInDaniels: true });
        }
        if (this.handleFormValidation("Step 1") && this.handleFormValidation("Step 2") && this.handleFormValidation("Step 3") && this.handleFormValidation("Step 4") && this.handleFormValidation("Step 5") && this.handleFormValidation("Step 6") && this.handleFormValidation("Step 7")) {
            this.setState({ step7: true, isStep7Complete: true, step8: true });
            setTimeout(() => {
                if (this.state.UOwnLeasing) {
                    document.getElementsByClassName("UownCmbOftenPaid")[0]?.focus();
                }
                else {
                    document.getElementById("confirmStep8")?.focus();
                }
            }, 200);
        }
    }

    async submitStep8(event) {
        event.preventDefault();
        if (!this.handleFormValidation("Step 1")) {
            this.setState({ errorInActVerification: true });
        }
        if (!this.handleFormValidation("Step 2")) {
            this.setState({ errorInMobileInfo: true });
        }
        if (!this.handleFormValidation("Step 3")) {
            this.setState({ errorInPersonalInfo: true });
        }
        if (!this.handleFormValidation("Step 4")) {
            this.setState({ errorInEmployment: true });
        }
        if (!this.handleFormValidation("Step 5")) {
            this.setState({ errorInIdentification: true });
        }
        if (!this.handleFormValidation("Step 6")) {
            this.setState({ errorInDaniels: true });
        }
        if (!this.handleFormValidation("Step 7")) {
            this.setState({ errorInSynchrony: true });
        }
        if (this.handleFormValidation("Step 1") && this.handleFormValidation("Step 2") && this.handleFormValidation("Step 3") && this.handleFormValidation("Step 4") && this.handleFormValidation("Step 5") && this.handleFormValidation("Step 6") && this.handleFormValidation("Step 7") && await this.validateABA() && this.handleFormValidation("Step 8")) {
            this.setState({ step8: true, isStep8Complete: true, step9: true });
            setTimeout(() => {
                if (this.state.UOwnLeasing) {
                    document.getElementById("cmbOftenPaid")?.focus();
                }
                else {
                    document.getElementById("confirmStep9")?.focus();
                }
            }, 200);
        }
    }

    async submitStep9(event) {
        event.preventDefault();
        if (!this.handleFormValidation("Step 1")) {
            this.setState({ errorInActVerification: true });
        }
        if (!this.handleFormValidation("Step 2")) {
            this.setState({ errorInMobileInfo: true });
        }
        if (!this.handleFormValidation("Step 3")) {
            this.setState({ errorInPersonalInfo: true });
        }
        if (!this.handleFormValidation("Step 4")) {
            this.setState({ errorInEmployment: true });
        }
        if (!this.handleFormValidation("Step 5")) {
            this.setState({ errorInIdentification: true });
        }
        if (!this.handleFormValidation("Step 6")) {
            this.setState({ errorInDaniels: true });
        }
        if (!this.handleFormValidation("Step 7")) {
            this.setState({ errorInSynchrony: true });
        }
        if (!this.handleFormValidation("Step 8") || (await this.validateABA() === false)) {
            this.setState({ erronInProgressive: true });
        }
        if (this.handleFormValidation("Step 1") && this.handleFormValidation("Step 2") && this.handleFormValidation("Step 3") && this.handleFormValidation("Step 4") && this.handleFormValidation("Step 5") && this.handleFormValidation("Step 6") && this.handleFormValidation("Step 7") && await this.validateABA() && this.handleFormValidation("Step 8") && this.handleFormValidation("Step 9")) {
            if (this.state.isAutoPayEnabled)
                this.setState({ step9: true, isStep9Complete: true, step10: true });
            else if (this.state.isEstatementEnable)
                this.setState({ step9: true, isStep10Complete: true, step11: true });
            else
                this.setState({ step9: true, isStep11Complete: true, step12: true });
            setTimeout(() => {
                if (this.state.isAutoPayEnabled) {
                    if (this.state.danielsCredit) {
                        document.getElementById("chkAutoPay")?.focus();
                    }
                    else {
                        document.getElementById("confirmStep10")?.focus();
                    }
                }
                else if (this.state.isEstatementEnable) {
                    if (this.state.danielsCredit) {
                        document.getElementById("chkDanielEStatementDisclosure")?.focus();
                    }
                    else {
                        document.getElementById("confirmStep11")?.focus();
                    }
                }
                else if (this.state.synchronyCredit) {
                    document.getElementById("chkSynchronyDisclosure")?.focus();
                }
                else if (this.state.fortivaCredit) {
                    document.getElementById("chkFortivaElecDisclosure")?.focus();
                }
                else if (this.state.danielsCredit) {
                    document.getElementById("chkDanielsDisclosure")?.focus();
                }
                else if (this.state.progressiveLeasing) {
                    document.getElementById("chkProgressiveDisclosure")?.focus();
                }
                else if (this.state.UOwnLeasing) {
                    document.getElementById("chkUOwnDisclosure")?.focus();
                }
            }, 200);
        }
        this.trackChanges();
    }

    submitStep10 = async (event) => {
        this.setState({ autoPayMessagePopup: false });
        event.preventDefault();
        if (!this.handleFormValidation("Step 1")) {
            this.setState({ errorInActVerification: true });
        }
        if (!this.handleFormValidation("Step 2")) {
            this.setState({ errorInMobileInfo: true });
        }
        if (!this.handleFormValidation("Step 3")) {
            this.setState({ errorInPersonalInfo: true });
        }
        if (!this.handleFormValidation("Step 4")) {
            this.setState({ errorInEmployment: true });
        }
        if (!this.handleFormValidation("Step 5")) {
            this.setState({ errorInIdentification: true });
        }
        if (!this.handleFormValidation("Step 6")) {
            this.setState({ errorInDaniels: true });
        }
        if (!this.handleFormValidation("Step 7")) {
            this.setState({ errorInSynchrony: true });
        }
        if (!this.handleFormValidation("Step 8") || (await this.validateABA() === false)) {
            this.setState({ erronInProgressive: true });
        }
        if (!this.handleFormValidation("Step 9")) {
            this.setState({ errorInUown: true });
        }
        if (this.handleFormValidation("Step 1") && this.handleFormValidation("Step 2") && this.handleFormValidation("Step 3") && this.handleFormValidation("Step 4") && this.handleFormValidation("Step 5") && this.handleFormValidation("Step 6") && this.handleFormValidation("Step 7") && await this.validateABA() && this.handleFormValidation("Step 8") && this.handleFormValidation("Step 9") && this.handleFormValidation("Step 10")) {
            if (this.state.isEstatementEnable)
                this.setState({ step10: true, isStep10Complete: true, step11: true });
            else
                this.setState({ step11: true, isStep11Complete: true, step12: true });
            setTimeout(() => {
                if (this.state.isEstatementEnable) {
                    if (this.state.danielsCredit) {
                        document.getElementById("chkDanielEStatementDisclosure")?.focus();
                    }
                    else {
                        document.getElementById("confirmStep11")?.focus();
                    }
                }
                else if (this.state.synchronyCredit) {
                    document.getElementById("chkSynchronyDisclosure")?.focus();
                }
                else if (this.state.fortivaCredit) {
                    document.getElementById("chkFortivaElecDisclosure")?.focus();
                }
                else if (this.state.danielsCredit) {
                    document.getElementById("chkDanielsDisclosure")?.focus();
                }
                else if (this.state.progressiveLeasing) {
                    document.getElementById("chkProgressiveDisclosure")?.focus();
                }
                else if (this.state.UOwnLeasing) {
                    document.getElementById("chkUOwnDisclosure")?.focus();
                }
            }, 200);
        }
        this.trackChanges();
    }

    submitStep11 = async (event) => {
        event.preventDefault();
        if (!this.handleFormValidation("Step 1")) {
            this.setState({ errorInActVerification: true });
        }
        if (!this.handleFormValidation("Step 2")) {
            this.setState({ errorInMobileInfo: true });
        }
        if (!this.handleFormValidation("Step 3")) {
            this.setState({ errorInPersonalInfo: true });
        }
        if (!this.handleFormValidation("Step 4")) {
            this.setState({ errorInEmployment: true });
        }
        if (!this.handleFormValidation("Step 5")) {
            this.setState({ errorInIdentification: true });
        }
        if (!this.handleFormValidation("Step 6")) {
            this.setState({ errorInDaniels: true });
        }
        if (!this.handleFormValidation("Step 7")) {
            this.setState({ errorInSynchrony: true });
        }
        if (!this.handleFormValidation("Step 8") || (await this.validateABA() === false)) {
            this.setState({ erronInProgressive: true });
        }
        if (!this.handleFormValidation("Step 9")) {
            this.setState({ errorInUown: true });
        }
        if (!this.handleFormValidation("Step 10")) {
            this.setState({ errorInAutoPay: true });
        }
        if (this.handleFormValidation("Step 1") && this.handleFormValidation("Step 2") && this.handleFormValidation("Step 3") && this.handleFormValidation("Step 4") && this.handleFormValidation("Step 5") && this.handleFormValidation("Step 6") && this.handleFormValidation("Step 7") && await this.validateABA() && this.handleFormValidation("Step 8") && this.handleFormValidation("Step 9") && this.handleFormValidation("Step 10") && this.handleFormValidation("Step 11")) {
            this.setState({ step11: true, isStep11Complete: true, step12: true }, () => {
                if (this.state.synchronyCredit) {
                    document.getElementById("chkSynchronyDisclosure")?.focus();
                }
                else if (this.state.fortivaCredit) {
                    document.getElementById("chkFortivaElecDisclosure")?.focus();
                }
                else if (this.state.danielsCredit) {
                    document.getElementById("chkDanielsDisclosure")?.focus();
                }
                else if (this.state.progressiveLeasing) {
                    document.getElementById("chkProgressiveDisclosure")?.focus();
                }
                else if (this.state.UOwnLeasing) {
                    document.getElementById("chkUOwnDisclosure")?.focus();
                }
            });
        }
        this.trackChanges();
    }

    fortiva_syncDisclosure() {
        let sync = '<h4><b>Synchrony Bank Credit</b></h4>' +
            '<p><b>SYNCHRONY BANK APPLICANT: We need your signature below.</b></p>' +
            '<p>I ask Synchrony Bank (“SYNCB”) to issue me a SYNCB Credit Card (the “Card”) and I agree:</p>' +
            '<ul>' +
            '<li>To the SYNCB Credit Card agreement (“Agreement”).</li>' +
            '<li>I am providing the information in this application to SYNCB and to dealers/merchants/retailers that accept the Card and program sponsors (and their respective affiliates), and I consent to SYNCB’s providing information about me to dealers/merchants/retailers that accept the Card and program sponsors (and their respective affiliates) for their own business purposes.</li>' +
            '<li>SYNCB may obtain credit reports and other information, including employment and income, about me to evaluate my application and for other purposes.</li>' +
            '<li>SYNCB, and any other owner or servicer of my account, may contact me about my account, including through text messages, automatic telephone dialing systems and/or artificial or prerecorded voice calls for informational, servicing or collection related communications, as provided in the Address/Phone Change and Consent To Communications provisions of the Agreement. I also agree to update my contact information.</li>' +
            '<li>The Agreement will govern my account and includes: <b>(1) a resolving a dispute with arbitration provision that limits my rights unless: (a) I reject the provision by following the provision’s instructions or (b) I am covered by the Notice for Active Duty Military Members and their Dependents set forth in the Agreement;</b> and (2) makes each applicant responsible for paying the entire amount of credit extended.</li>' +
            '<li><b>Authorization for the Social Security Administration to Disclose Your Social Security Number Verification.</b> I authorize the Social Security Administration (SSA) to verify and disclose to SYNCB for the purpose of this transaction whether the name, Social Security Number (SSN) and date of birth I have submitted matches information in SSA records. My consent is for a one-time validation within the next 90 days.</li>' +
            '</ul>' +
            '<p><b>Federal law requires Synchrony Bank to obtain, verify, and record information that identifies you when you open an account.  Synchrony Bank will use your name, address, date of birth, and other information for this purpose.</b></p>' +
            '<p>PLEASE READ THE SYNCB CREDIT CARD AGREEMENT FOR RATES, FEES, AND OTHER COST INFORMATION BEFORE SIGNING THIS APPLICATION.</p>' +
            '<p><b>By checking this box, I agree that I want to apply for a Synchrony Bank Credit Card, that I have received a paper copy of the credit terms, that I have read and agree to the credit terms and application disclosures provided above, and that selecting “Submit Application” below constitutes my electronic signature.</b></p>';
        let fortiva1 = '<h4><b>Fortiva Retail Credit</b></h4>' +
            '<h4><b>About Procedures for Opening a New Account</b></h4>';
        let fortiva2 = '<p><b>If your application is declined by Synchrony Bank (“SYNCB”), you direct SYNCB to share all of your application information, on your behalf, with The Bank of Missouri (“TBOM”) to see if you prequalify for a Fortiva Retail Line of Credit. The rates, fees, and other credit terms provided by SYNCB may differ from the terms of the Fortiva Retail Line of Credit.​</b></p>' +
            '<p>By signing below, you also agree that if you are not approved for a SYNCB account, you are providing “written instructions” to TBOM, its successors, assigns and agents, specifically including, on behalf of TBOM and at its express direction, the Fortiva Retail Credit program manager (collectively, the “Lender”) to obtain a credit report from a consumer reporting agency in accordance with the federal Fair Credit Reporting Act.  You authorize Lender to obtain such information solely to conduct an initial pre-qualification review. Then, if you select a prequalified offer, you authorize Lender to investigate your creditworthiness and specifically authorize the release of further information to Lender.  A full credit report (a hard inquiry) will be requested in connection with your acceptance of an offer.​</p>' +
            '<p><b>Consent to Electronic Disclosures</b>: By checking the box at the left, you certify that you have read, retained and agree to the <u style="color:#5C068C"><b>Consent to Electronic Disclosures.</b></u> and understand that this constitutes your electronic signature authorizing us to process this form on your behalf.</p>';
        let fortiva3 = '<p><b>Consent to Electronic Disclosures</b>: By checking the box at the left, you certify that you have read, retained and agree to the <u style="color:#5C068C"><b>Consent to Electronic Disclosures.</b></u> and understand that this constitutes your electronic signature authorizing us to process this form on your behalf.</p>' +
            '<p><u style="color:#5C068C"><b>Application Disclosures</b></u>: By checking the box at the left you certify that you have read and agree to the Application Disclosures.</p>' +
            '<p>By clicking Submit, you are providing “written instructions” to The Bank of Missouri, its successors, assigns and agents, specifically including, on behalf of The Bank of Missouri and at its express direction, the Fortiva Retail Credit program manager (collectively, the “Lender”) to obtain a credit report from a consumer reporting agency in accordance with the federal Fair Credit Reporting Act. You authorize the Lender to obtain such information solely to conduct an initial pre-qualification review.</p>';
        if (this.state.synchronyCredit && this.state.fortivaCredit)
            return sync + fortiva2;
        else if (this.state.fortivaCredit)
            return fortiva1 + fortiva3;
        else return "";
    }

    async submitStep12(event) {
        event.preventDefault();
        this.setState({ isAPIError: false });
        localStorage.removeItem("fortivaAPIErrorMsg");
        this.setState({ showSubmitConfirmation: !this.state.showSubmitConfirmation });
        this.setState({ showAppInProgress: !this.state.showAppInProgress });
        if (this.handleFormValidation("Step 1") && this.handleFormValidation("Step 2")
            && this.handleFormValidation("Step 3") && this.handleFormValidation("Step 4")
            && this.handleFormValidation("Step 5") && this.handleFormValidation("Step 6")
            && this.handleFormValidation("Step 7") && await this.validateABA() && this.handleFormValidation("Step 8")
            && this.handleFormValidation("Step 9") && this.handleFormValidation("Step 10") && this.handleFormValidation("Step 11") && this.handleFormValidation("Step 12") && this.handleFormValidation("employee validation")) {
            let synchMobileNo = "";
            synchMobileNo = this.state.formObj.mobileNo.slice(0, 3) + this.state.formObj.mobileNo.slice(4, 7) + this.state.formObj.mobileNo.slice(8, 12);
            let synObjStore = this.state.storesList.find(item => { return item.code === this.state.formObj.storeCode });

            // if(this.state.formObj.account !== "" && this.state.formObj.account!==null){
            //     if(this.state.formObj.account.includes("-")){
            //         let accountNo=this.state.formObj.account.split("-");
            //         this.state.formObj.account = accountNo[0];
            //       }
            // }
            let progUownApplications = JSON.parse(sessionStorage.getItem("progUownApplications"));
            let waterfall_check = "";
            if (progUownApplications) {
                if (progUownApplications == true) {
                    waterfall_check = "Yes"
                }
            }
            sessionStorage.removeItem("progUownApplications");
            //New mobile number text verification logic
            let previousMobileNo = "";
            let isMobileNoUpdated = false;
            if (this.state.previousMobileNo !== "") {
                if (!this.state.isSMSOverride) {
                    if (formatPhoneNumber(this.state.formObj.mobileNo) !== formatPhoneNumber(this.state.previousMobileNo)) {
                        isMobileNoUpdated = true;
                        previousMobileNo = formatPhoneNumber(this.state.previousMobileNo);
                    }
                }
                //To store previous number even it not verified
                else if (formatPhoneNumber(this.state.formObj.mobileNo) !== formatPhoneNumber(this.state.previousMobileNo)) {
                    previousMobileNo = formatPhoneNumber(this.state.previousMobileNo);
                }
            }
            let obj1 = {
                "customerId": (sessionStorage.getItem("isNewApplication") == "false" ? (this.state.formObj.account == "" || this.state.formObj.account == null ? 0 : this.state.formObj.account) : (this.state.formObj.customerNo == "NEW" ? 0 : (this.state.formObj.account == "" || this.state.formObj.account == null ? 0 : this.state.formObj.account))),
                "isDaniel": this.state.danielsCredit,
                "isSynchrony": this.state.synchronyCredit,
                "isProgressive": this.state.progressiveLeasing,
                "isUown": this.state.UOwnLeasing,
                "isFortiva": this.state.fortivaCredit,
                "store_Id": sessionStorage.getItem("SMSLink") || this.state.thirdPartySessionLink ? "0" : this.state.formObj.storeCode,
                "homeStore": JSON.parse(localStorage.getItem("associateStores")),
                "firstName": this.state.formObj.firstName,
                "middleName": this.state.formObj.middleName,
                "lastName": this.state.formObj.lastName,
                "suffix_Id": ((this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit)) ? (parseInt(this.state.formObj.suffix) > 0) ? parseInt(this.state.formObj.suffix) : null : null),
                "address": this.state.formObj.mailingAdr,
                "city": this.state.formObj.city,
                "state_Id": (parseInt(this.state.formObj.state) > 0) ? parseInt(this.state.formObj.state) : null,
                "state_Id_Code": (parseInt(this.state.formObj.state) > 0) ? this.state.formObj.lstState.find(obj => obj.id == this.state.formObj.state)?.code : "",
                "zipCode": this.state.formObj.zipCode,
                "apt": this.state.formObj.aptUnit,
                "emailAddress": this.state.formObj.emailAdr,
                "birthDate": GetDateFromMMDDYYYY(this.state.formObj.dob),
                "mobileNo": this.state.synchronyCredit ? synchMobileNo : this.state.formObj.mobileNo,
                "secondaryPhone": (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit)) ? this.state.formObj.secPhone === "" ? null : this.state.formObj.secPhone : null,
                "empName": (this.state.danielsCredit || this.state.UOwnLeasing) ? this.state.formObj.empName : null,
                "empPhone": (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit)) ? this.state.formObj.empPhoneNo : null,
                "howLong": this.state.danielsCredit ? GetDateFromMMYYYY(this.state.formObj.empStartDate) : null,
                "monthlyIncome": parseInt(this.state.formObj.netIncome),
                "workJob": this.state.danielsCredit ? this.state.formObj.duties : null,
                "housingInfo_Id": (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit)) ? parseInt(this.state.formObj.housingInfo) : null,
                "createdBy_Associate": (this.state.thirdPartySessionLink || this.state.SMSLink) ? "" : localStorage.getItem('loggedUserEmail'),
                //"credit_Id": this.state.formObj.frKeyCredit_Id
                "ssn": this.state.formObj.ssn,
                "primaryTypeId": (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit)) ? (parseInt(this.state.formObj.primaryIdType) > 0) ? parseInt(this.state.formObj.primaryIdType) : null : null,
                "primaryTypeId_Code": (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit)) ? (parseInt(this.state.formObj.primaryIdType) > 0) ? this.state.formObj.lstPrimaryIdType.find(obj => obj.id == this.state.formObj.primaryIdType)?.code : "" : "",
                "idNumber": (this.state.danielsCredit || this.state.progressiveLeasing || (this.state.nonSynchronyCD && this.state.synchronyCredit)) ? this.state.formObj.primaryIdNo : null,
                "primaryStateId": (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit)) ? (parseInt(this.state.formObj.primaryIdState) > 0) ? parseInt(this.state.formObj.primaryIdState) : null : null,
                "primaryStateId_Code": (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit)) ? (parseInt(this.state.formObj.primaryIdState) > 0) ? this.state.formObj.lstPrimaryIdState.find(obj => obj.id == this.state.formObj.primaryIdState)?.code : "" : "",
                "relativeName": this.state.danielsCredit ? this.state.formObj.relativeName : null,
                "relativePhone": this.state.danielsCredit ? this.state.formObj.relativePhone : null,
                "relativeRelationship": this.state.danielsCredit ? this.state.formObj.relativeRelation : null,
                "isMobileNoVerified": this.state.isSMSOverride ? false : true,
                "isSMSCodeSent": this.state.SMSCodeSent ? true : false,
                "isSMSOverride": this.state.isSMSOverride,
                "magix_Id": (JSON.parse(sessionStorage.getItem("thirdPartyLink")) === true) ? "" : (localStorage.getItem("magix_account_no") === "" ? null : localStorage.getItem("magix_account_no")),
                "isDanielDisclosures": this.state.danielsCredit ? this.state.danielsDisclosure : false,
                "dateLived": GetDateFromMMYYYY(Moment().format("MM/YYYY")),
                "monthlyPayment": false,
                "bankC": this.state.synchronyCredit ? (this.state.synchronyDisclosure ? "N" : "") : "",
                "bankS": this.state.synchronyCredit ? (this.state.synchronyDisclosure ? "N" : "") : "",
                "initialSale": this.state.synchronyCredit ? (this.state.synchronyDisclosure ? 3000 : 0) : 0,
                "isUownDisclosures": this.state.UOwnLeasing ? this.state.UOwnDisclosure : false,
                "isProgressiveDisclosures": this.state.progressiveLeasing ? this.state.progressiveDisclosure : false,
                "howOftenPaidId": (this.state.progressiveLeasing || this.state.UOwnLeasing) ? (parseInt(this.state.formObj.oftenPaid) > 0) ? parseInt(this.state.formObj.oftenPaid) : null : null,
                "howOftenPaidId_Code": (this.state.progressiveLeasing || this.state.UOwnLeasing) ? (parseInt(this.state.formObj.oftenPaid) > 0) ? this.state.formObj.lstOftenPaid.find(obj => obj.id == this.state.formObj.oftenPaid)?.code : "" : "",
                "lastPayDay": (this.state.progressiveLeasing || this.state.UOwnLeasing) ? (parseInt(this.state.formObj.oftenPaid) > 0) ? GetDateFromMMDDYYYY(this.state.formObj.lastPayDay) : null : null,
                "nextPayDay": (this.state.progressiveLeasing || this.state.UOwnLeasing) ? GetDateFromMMDDYYYY(this.state.formObj.nextPayDay) : null,
                "primaryIncomeId": (this.state.progressiveLeasing) ? parseInt(this.state.formObj.primarySourceIncome) : null,
                "bankRoutingNo": (this.state.progressiveLeasing) ? this.state.formObj.bankRouteNo : null,
                "checkingAccountNo": (this.state.progressiveLeasing) ? this.state.formObj.checkAccNo : null,
                "creditCardBin": (this.state.progressiveLeasing) ? this.state.formObj.cc : null,
                "creditCardExpDate": (this.state.progressiveLeasing) ? GetDateFromMMYYYY(this.state.formObj.ccExpiryDate) : null,
                "nameOnCreditCard": (this.state.progressiveLeasing) ? this.state.formObj.ccName : null,
                "creditCardHomeAddress": (this.state.progressiveLeasing) ? (this.state.formObj.creditCardBillingAddress ? true : false) : null,
                "progressiveMarketInOptin": this.state.progressiveLeasing ? (this.state.progressiveSMS) ? true : false : false,
                "ccAddress": (this.state.progressiveLeasing && !this.state.formObj.creditCardBillingAddress) ? this.state.formObj.ccmailingAdr : "",
                "ccApt": (this.state.progressiveLeasing && !this.state.formObj.creditCardBillingAddress) ? this.state.formObj.ccaptUnit === "" ? null : this.state.formObj.ccaptUnit : null,
                "ccCity": (this.state.progressiveLeasing && !this.state.formObj.creditCardBillingAddress) ? this.state.formObj.cccity : "",
                "ccStateId": (this.state.progressiveLeasing && !this.state.formObj.creditCardBillingAddress) ? (parseInt(this.state.formObj.ccstate) > 0) ? parseInt(this.state.formObj.ccstate) : null : null,
                "ccStateId_Code": (this.state.progressiveLeasing && !this.state.formObj.creditCardBillingAddress) ? (parseInt(this.state.formObj.ccstate) > 0) ? this.state.formObj.lstState.find(obj => obj.id == this.state.formObj.ccstate)?.code : "" : "",
                "ccZipCode": (this.state.progressiveLeasing && !this.state.formObj.creditCardBillingAddress) ? this.state.formObj.cczipCode : "",
                "modifiedBy_Associate": (this.state.thirdPartySessionLink || this.state.SMSLink) ? "" : localStorage.getItem('loggedUserEmail'),
                "isSynchronyDisclosures": this.state.synchronyCredit ? this.state.synchronyDisclosure : false,
                "isFortivaDisclosures": this.state.fortivaCredit ? this.state.fortivaDisclosure : false,
                "isElectronicDisclosure": this.state.fortivaCredit ? this.state.fortivaElecDisclosure : false,
                "isWrittenInstruction": this.state.fortivaCredit ? this.state.fortivaWrittenInstr : false,
                "associateEmpNo": this.state.formObj.associateEmployeeNo,
                "isAssociateVerified": this.state.captchaVerified ? false : true,
                "primaryIdExpDate": (this.state.nonSynchronyCD && this.state.synchronyCredit) ? GetDateFromMMYYYY(this.state.formObj.primaryIdExpiryDate) : null,
                "secondIdType_Id": (this.state.nonSynchronyCD && this.state.synchronyCredit) ? parseInt(this.state.formObj.secondIdType) : null,
                "secondIdIssuedBy_Id": (this.state.nonSynchronyCD && this.state.synchronyCredit) ? this.state.formObj.secondIdIssuedBy : null,
                "secondIdExpDate": (this.state.nonSynchronyCD && this.state.synchronyCredit) ? GetDateFromMMYYYY(this.state.formObj.secondIdExpiryDate) : null,
                "applicantIdMatch": (this.state.nonSynchronyCD && this.state.synchronyCredit) ? this.state.synchronyDisclosure ? this.state.applicantIdMatch : false : false,
                "isSynchronyAgreement": (this.state.nonSynchronyCD && this.state.synchronyCredit) ? this.state.synchronyDisclosure ? this.state.synchronyAgreementGiven : false : false,
                "url": window.location.href,
                "ipAddress": sessionStorage.getItem('ipAddress'),
                "applicationVersion": "application.Version.0.0.1",
                "isAutoPay": (this.state.danielsCredit) ? this.state.autoPay : false,
                "custIdEnt": this.state.custIdEnt,
                "autoPayStatus": (this.state.danielsCredit) ? this.state.autoPayStatus : "",
                "type": this.state.thirdPartyLink ? "daniels_only" : "all",
                "magixStoreCode": (JSON.parse(sessionStorage.getItem("thirdPartyLink")) === true) ? "" : ((localStorage.getItem("magix_account_no") === "") ? null : localStorage.getItem('storeCode')),
                "isSynchronyCD": synObjStore?.isSynchronyCD,
                "isReapply": this.state.fortivaCredit ? sessionStorage.getItem("isNewApplication") == "true" ? false : true : false,
                "associateId": this.state.fortivaCredit ? localStorage.getItem('loggedUserEmail') : "",
                "isSendEmail_Synchrony": this.state.isSynchronySendEmail,
                "isNewApplication": sessionStorage.getItem("isNewApplication") == "true" ? true : false,
                "waterfall_check": waterfall_check,
                "emailContent":
                    '<h2>CUSTOMER INFORMATION - CREDIT APPLICATION</h2>' +
                    '<h5>Mobile Information</h5>' +
                    '<hr>' +
                    '<b>Mobile Number : </b>' + (this.state.formObj.mobileNo) +
                    '<br>' +
                    '<br>' +
                    '<h5>Personal Information</h5>' +
                    '<hr>' +
                    '<b>Store Code : </b>' + ((this.state.thirdPartySessionLink || this.state.SMSLink) ? "100" : (this.state.formObj.storeCode)) +
                    '<br>' +
                    '<b>Social Security Number/ITIN# : </b>XXX-XX-' + (this.state.formObj.ssn.slice(-4)) +
                    '<br>' +
                    '<b>Date of Birth (MM/DD/YYYY) : </b>' + (Moment(this.state.formObj.dob).format("MM/DD/YYYY")) +
                    '<br>' +
                    '<b>First Name : </b>' + (this.state.formObj.firstName) +
                    '<br>' +
                    '<b>Middle Name : </b>' + (this.state.formObj.middleName) +
                    '<br>' +
                    '<b>Last Name : </b>' + (this.state.formObj.lastName) +
                    '<br>' +
                    (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) ?
                        '<b>Suffix : </b>' + ((parseInt(this.state.formObj.suffix) > 0) ? this.state.formObj.lstSuffix.find((suffix) => this.state.formObj.suffix == suffix.id)?.description : "") +
                        '<br>'
                        : "") +
                    '<b>Mailing Address : </b>' + (this.state.formObj.mailingAdr) +
                    '<br>' +
                    '<b>Apt/Unit (As Needed) : </b>' + (this.state.formObj.aptUnit) +
                    '<br>' +
                    '<b>City : </b>' + (this.state.formObj.city) +
                    '<br>' +
                    '<b>State : </b>' + ((parseInt(this.state.formObj.state) > 0) ? this.state.formObj.lstState.find(obj => obj.id == this.state.formObj.state)?.description : "") +
                    '<br>' +
                    '<b>Zip Code : </b>' + (this.state.formObj.zipCode) +
                    '<br>' +
                    (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) ?
                        '<b>Housing Information : </b>' + (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) ? this.state.formObj.lstHousingInfo?.find((housingInfo) => this.state.formObj.housingInfo == housingInfo.id)?.description : "") +
                        '<br>'
                        : "") +
                    (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) ?
                        '<b>Secondary Phone : </b>' + (this.state.formObj.secPhone === "" ? "" : this.state.formObj.secPhone) +
                        '<br>'
                        : "") +
                    '<b>Email Address : </b>' + (this.state.formObj.emailAdr) +
                    '<br>' +
                    '<br>' +
                    '<h5>Employment</h5>' +
                    '<hr>' +
                    (this.state.danielsCredit || this.state.UOwnLeasing ?
                        '<b>Employer Name : </b>' + (this.state.formObj.empName) +
                        '<br>'
                        : "") +
                    (this.state.danielsCredit ?
                        '<b>Type of Work/Job Duties : </b>' + (this.state.formObj.duties) +
                        '<br>'
                        : "") +
                    (this.state.danielsCredit ?
                        '<b>Employment Start Date (MM/YYYY) : </b>' + (this.state.danielsCredit ? Moment(GetDateFromMMYYYY(this.state.formObj.empStartDate)).format("MM/YYYY") : "") +
                        '<br>'
                        : "") +
                    (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) ?
                        '<b>Employer Phone Number : </b>' + (this.state.formObj.empPhoneNo) +
                        '<br>'
                        : "") +
                    '<b>Monthly Net Income(from all sources) : </b>' + (parseInt(this.state.formObj.netIncome)) +
                    '<br>' +
                    '<br>' +
                    (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) || this.state.progressiveLeasing ?
                        '<h5>Identification</h5>' +
                        '<hr>'
                        : "") +
                    (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) ?
                        '<b>Primary ID Type : </b>' + ((parseInt(this.state.formObj.primaryIdType) > 0) ? this.state.formObj.lstPrimaryIdType.find(obj => obj.id == this.state.formObj.primaryIdType)?.description : "") +
                        '<br>'
                        : "") +
                    (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) || this.state.progressiveLeasing ?
                        '<b>Primary ID Number : </b>XXX-XX-' + (this.state.formObj.primaryIdNo.slice(-3)) +
                        '<br>'
                        : "") +
                    (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) ?
                        '<b>Primary ID State : </b>' + ((parseInt(this.state.formObj.primaryIdState) > 0) ? this.state.formObj.lstPrimaryIdState.find(obj => obj.id == this.state.formObj.primaryIdState)?.description : "") +
                        '<br>'
                        : "") +
                    (this.state.danielsCredit ?
                        '<br>' +
                        '<h5>Daniels Required Fields</h5>' +
                        '<hr>' +
                        '<b>Nearest Relative Name : </b>' + (this.state.formObj.relativeName) +
                        '<br>' +
                        '<b>Nearest Relative Phone : </b>' + (this.state.formObj.relativePhone) +
                        '<br>' +
                        '<b>Nearest Relative Relationship : </b>' + (this.state.formObj.relativeRelation) +
                        '<br>' +
                        '<br>'
                        : "") +
                    '<table>' +
                    '<tr>' +
                    '<td>               </td>' +
                    '<td>               </td>' +
                    '<td>               </td>' +
                    '<td><br>' + (new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles', })) + '</td>' +
                    '</tr>' +
                    '</table>',
                fortAppDisclosure: this.fortiva_syncDisclosure(),
                isDanielEStatementDisclosure: this.state.danielsCredit ? this.state.isDanielEStatementDisclosure : false,
                danielEStatementMailDisclosure: this.state.danielsCredit && this.state.isDanielEStatementDisclosure ? this.state.eStatementContent : "",
                notify_me_via_text_at: (this.state.danielsCredit && this.state.isDanielEStatementDisclosure) ? (this.state.notify_me_via_text_at) ? true : false : false,
                notify_me_via_email_at: (this.state.danielsCredit && this.state.isDanielEStatementDisclosure) ? (this.state.notify_me_via_email_at) ? true : false : false,
                isMobileNoUpdated: isMobileNoUpdated,
                previousMobileNo: previousMobileNo,
                reOpen: (this.state.isDanielsApplicationFlowChanges && this.state.danielsCredit) ? sessionStorage.getItem("reOpen") == "true" ? true : false : false,
                addOnwithoutchanges: (this.state.isDanielsApplicationFlowChanges && this.state.danielsCredit) ? this.state.addOnwithOutchanges : false,
                addOnwithchanges: (this.state.isDanielsApplicationFlowChanges && this.state.danielsCredit) ? this.state.addOnWithChange : false,
                isMagix_NewAccount: this.state.isDanielsApplicationFlowChanges ? sessionStorage.getItem("newApplication") == "true" ? true : false : false,
                //Need to check with sivakumari - isMagix_NewAccount is for Daniels or not?
                existing_Customer: (JSON.parse(sessionStorage.getItem("thirdPartyLink")) === true) ? false : (localStorage.getItem("magix_account_no") === "" ? false : true),
            }
            let obj2 = {
                SessionId: this.state.thirdPartySessionLink ? this.state.sessionId : "",
                associateEmail: this.state.thirdPartyLink && this.state.sessionId === "" ? localStorage.getItem("loggedUserEmail") : ""
            }
            sessionStorage.setItem("selectedUserPhone", this.state.formObj.mobileNo);
            sessionStorage.setItem("selectedUserEmail", this.state.formObj.emailAdr);
            trackPromise(
                this.props.actions.creditSubmit(obj1, obj2).then(
                    response => {
                        if (response) {
                            this.setState({ isAPIError: false, isAPIErrorMsg: '' });
                            if (response.errorMessage.length > 0) {
                                this.setState({ showAppInProgress: !this.state.showAppInProgress });
                                this.setState({ isStep11Complete: true, step12: true });
                                this.setState({ isAPIError: true });
                                let error_ssn = response.errorMessage.replace('Applicant.SSN', 'SSN')
                                let error_HomePhone = error_ssn.replace('Applicant.HomePhone', 'Mobile Number')
                                let error_HomePhone_1 = error_HomePhone.replace('Applicant.CellPhone', 'Secondary Phone ')
                                this.setState({ isAPIErrorMsg: this.state.isAPIErrorMsg.concat(error_HomePhone_1) })

                            }
                            else {
                                this.setState({
                                    submissionStatus: {
                                        ...this.state.submissionStatus,
                                        synchrony: this.state.synchronyCredit,
                                        fortiva: this.state.fortivaCredit,
                                        daniels: this.state.danielsCredit,
                                        progressive: this.state.progressiveLeasing,
                                        uown: this.state.UOwnLeasing,
                                    }
                                });
                                this.updateState("txtCustomerNo", response.customer.customer_Id?.split("-")[0]);
                                localStorage.setItem("applicationId", response.customer.application_id);
                                localStorage.setItem("magixassociateId", null);
                                localStorage.setItem("customerId", response.customer.customer_Id?.split("-")[0]);
                                localStorage.setItem("creditappEmailAddr", response.customer.emailAddress);
                                sessionStorage.setItem("ssn&dob", this.state.formObj.ssn + "&" + this.state.formObj.dob);
                                localStorage.setItem("isSynchronyCD", !this.state.nonSynchronyCD);
                                localStorage.setItem("danielAppId", response.customer.danielAppId);
                                localStorage.setItem("progressiveAppId", response.customer.progressiveAppId);
                                localStorage.setItem("uownAppId", response.customer.uownAppId);
                                localStorage.setItem("synchronyAppId", response.customer.synchronyAppId);
                                localStorage.setItem("fortivaAppId", response.customer.fortivaAppId);
                                sessionStorage.setItem("credit_Id", response.credit.credit_Id);
                                if (this.state.isDanielsApplicationFlowChanges) {
                                    sessionStorage.setItem("addOn", false);
                                    sessionStorage.setItem("reOpen", false);
                                    sessionStorage.setItem("newApplication", false);
                                }
                                if (sessionStorage.getItem("logout/continue") == "true") {
                                    sessionStorage.setItem("firstTimeFromApplyNow", false);
                                }
                                else {
                                    sessionStorage.setItem("firstTimeFromApplyNow", true);
                                }
                                if (sessionStorage.getItem("isNewApplication") == "true") {
                                    sessionStorage.setItem("ssn&zipcode", this.state.formObj.ssn + "," + this.state.formObj.zipCode);
                                    sessionStorage.setItem("synchronyStoreCode", JSON.parse(localStorage.getItem("associateStores")));
                                    let selectedUserName = "";

                                    if (this.state.formObj.firstName) {
                                        selectedUserName = this.state.formObj.firstName;
                                    }
                                    if (this.state.formObj.middleName) {
                                        selectedUserName = selectedUserName + " " + this.state.formObj.middleName;
                                    }
                                    if (this.state.formObj.lastName) {
                                        selectedUserName = selectedUserName + " " + this.state.formObj.lastName;
                                    }
                                    localStorage.setItem('selectedUserName', selectedUserName);
                                }
                                else if (sessionStorage.getItem("existingSyncApplication") == "false" && this.state.synchronyCredit) {
                                    sessionStorage.setItem("ssn&zipcode", this.state.formObj.ssn + "," + this.state.formObj.zipCode);
                                    sessionStorage.setItem("synchronyStoreCode", JSON.parse(localStorage.getItem("associateStores")));
                                    sessionStorage.setItem("existingSyncApplication", true);
                                }
                                localStorage.setItem('lastName', this.state.formObj.lastName);
                                //if(sessionStorage.getItem("logout/continue") != "true") {
                                sessionStorage.setItem("isNewApplication", "false");
                                //}
                                localStorage.setItem('storeCode', response.customer.magixStoreCode);
                                sessionStorage.setItem("magixInstoreData", response.customer.magixStoreCode);
                                localStorage.setItem('selectedCustomer', response.customer.customer_Id?.split("-")[0]);
                                var date = new Date(response.customer.createdDate);
                                sessionStorage.setItem("isDaniel", this.state.danielsCredit);
                                sessionStorage.setItem("isSynchrony", this.state.synchronyCredit);
                                sessionStorage.setItem("isFortiva", this.state.fortivaCredit);
                                if (obj1.isSynchrony && obj1.isFortiva) {
                                    localStorage.setItem('submitforFortiva', true);
                                }
                                else {
                                    localStorage.setItem('submitforFortiva', false);
                                }
                                sessionStorage.setItem("isProgressive", this.state.progressiveLeasing);
                                sessionStorage.setItem("isUown", this.state.UOwnLeasing);
                                this.setState({
                                    waterfallObj: {
                                        ...this.state.waterfallObj,
                                        customerId: response.customer.customer_Id?.split("-")[0],
                                        applicationId: response.customer.application_id,
                                        creditId: response.credit.credit_Id,
                                        isDaniel: this.state.danielsCredit
                                    }
                                });
                                date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
                                sessionStorage.setItem("createdDate", date.toLocaleString("en-US", { timeZone: "America/Los_Angeles" }));
                                this.setState({ showAppInProgress: !this.state.showAppInProgress });
                                this.setState({ showSubmittedAlert: !this.state.showSubmittedAlert });
                                if (this.state.sessionId.length > 0) {
                                    let djoURL = window.env.LINKS_DJOURL;
                                    const winmessage = JSON.stringify({
                                        applicationId: response.credit.credit_Id,
                                        primaryId: this.state.formObj.primaryIdNo,
                                        url: djoURL
                                    });
                                    window.parent.postMessage(winmessage, '*');
                                    window.close();
                                }

                                if (this.state.SMSLink) {
                                    this.setState({
                                        step1: true,
                                        isStep1Complete: false,
                                        step2: false,
                                        toggled: false,
                                        isStep2Complete: false,
                                        step3: false,
                                        isStep3Complete: false,
                                        step4: false,
                                        isStep4Complete: false,
                                        step5: false,
                                        isStep5Complete: false,
                                        step7: false,
                                        isStep7Complete: false,
                                        step8: false,
                                        isStep8Complete: false,
                                        step9: false,
                                        isStep9Complete: false,
                                        step10: false,
                                        isStep10Complete: false,
                                        step11: false,
                                        isStep11Complete: false,
                                        step12: false,
                                        isStep12Complete: false,
                                        progressiveLeasing: true,
                                        UOwnLeasing: true,
                                        danielsDisclosure: false,
                                        synchronyDisclosure: false,
                                        verifyPassword: false,
                                        showPopup: false,
                                        customerInfo: [],
                                        progressiveDisclosure: false,
                                        progressiveSMS: false,
                                        UOwnDisclosure: false,
                                        showSubmitConfirmation: false,
                                        isAgreed: false,
                                        djoSubmitted: true,
                                    })
                                    this.setState({
                                        formObj: {
                                            ...this.state.formObj,
                                            credit_Id: 0,
                                            customerNo: "NEW",
                                            account: "",
                                            storeCode: "0",
                                            suffix: "0",
                                            firstName: "",
                                            middleName: "",
                                            lastName: "",
                                            mailingAdr: "",
                                            emailAdr: "",
                                            aptUnit: "",
                                            dob: "",
                                            city: "",
                                            mobileNo: "",
                                            state: "0",
                                            secPhone: "",
                                            zipCode: "",
                                            empName: "",
                                            empStartDate: "",
                                            empPhoneNo: "",
                                            netIncome: "",
                                            duties: "",
                                            housingInfo: "0",
                                            ssn: "",
                                            primaryIdType: "0",
                                            primaryIdNo: "",
                                            primaryIdState: "0",
                                            relativeName: "",
                                            relativePhone: "",
                                            relativeRelation: "",
                                            verificationCode: "",
                                            oftenPaid: "0",
                                            cc: "",
                                            lastPayDay: "",
                                            ccExpiryDate: "",
                                            nextPayDay: "",
                                            ccName: "",
                                            primarySourceIncome: "0",
                                            creditCardBillingAddress: false,
                                            ccmailingAdr: "",
                                            ccaptUnit: "",
                                            cccity: "",
                                            ccstate: "0",
                                            cczipCode: "",
                                            bankRouteNo: "",
                                            checkAccNo: "",
                                            bankAccountDuration: "0",
                                            associateEmployeeNo: "",
                                            associatePassword: "",
                                            rdApply: "DS",
                                            lstSuffix: [],
                                            lstState: [],
                                            lstHousingInfo: [],
                                            lstPrimaryIdType: [],
                                            lstPrimaryIdState: [],
                                            lstOftenPaid: [],
                                            lstPrimarySourceIncome: [],
                                            lstBankAccountDuration: [],
                                            lstSecondIdType: [],
                                            lstStoreCode: []
                                        }
                                    });
                                    if (!this.state.thirdPartySessionLink) {
                                        setTimeout(() => {
                                            window.location.replace("https://www.danielsjewelers.com/");
                                        }, 1000)
                                    }
                                }
                            }

                        }
                    }
                ).catch(err => {
                    APIFailedMessage.displayError(err);
                })
            )
        }
    }


    BypassSMS(event) {
        event.preventDefault();
        try {
            if (this.handleFormValidation("mobileNo")) {
                this.props.authActions.login().then(
                    response => {
                        if (response) {
                            this.setState({ isSMSError: false, isSMSErrorMsg: '', isSMSOverride: true, step2: true, isStep2Complete: true, step3: true });
                            setTimeout(() => {
                                document.getElementById("txtFirstName")?.focus();
                            }, 200);
                        }
                    }
                )
            }
        }
        catch (error) {
            APIFailedMessage.displayError(error);
        }
    }

    thirdPartySMSByPass(event) {
        event.preventDefault();
        this.setState({ showTempCode: !this.state.showTempCode });
        this.handleFormValidation("empty");
        this.txtVerificationCode.focus();
    }

    associateLogin = async () => {
        try {
            let res = await this.props.authActions.login();
            if (res) {
                this.setState({ isVerifyPassword: true }, () => {
                    let formErrors = this.disclosureValidation();
                    this.gayOutSubmit(formErrors);
                });
            }
            else {
                this.handleFormValidation("Authentication Failed");
                this.setState({ isVerifyPassword: false });
            }
        }
        catch (error) {
            APIFailedMessage.displayError(error);
        }
    }

    verifyPassword(event) {
        event.preventDefault();
        this.associateLogin();
    }

    cancelSession() {
        trackPromise(
            this.props.actions.cancelSessionLink(this.state.sessionId).then(
                response => {
                    //this.setState({ autoPayModal: !this.state.autoPayModal });
                    if (response.errorMessage === "Session Expired") {
                        this.setState({
                            step1: true,
                            isStep1Complete: false,
                            step2: false,
                            toggled: false,
                            isStep2Complete: false,
                            step3: false,
                            isStep3Complete: false,
                            step4: false,
                            isStep4Complete: false,
                            step5: false,
                            isStep5Complete: false,
                            step7: false,
                            isStep7Complete: false,
                            step8: false,
                            isStep8Complete: false,
                            step9: false,
                            isStep9Complete: false,
                            step10: false,
                            isStep10Complete: false,
                            progressiveLeasing: true,
                            UOwnLeasing: true,
                            danielsDisclosure: false,
                            synchronyDisclosure: false,
                            verifyPassword: false,
                            showPopup: false,
                            customerInfo: [],
                            progressiveDisclosure: false,
                            progressiveSMS: false,
                            UOwnDisclosure: false,
                            showSubmitConfirmation: false,
                            isAgreed: false,
                        })
                        this.setState({
                            formObj: {
                                ...this.state.formObj,
                                credit_Id: 0,
                                customerNo: "NEW",
                                account: "",
                                storeCode: "0",
                                suffix: "0",
                                firstName: "",
                                middleName: "",
                                lastName: "",
                                mailingAdr: "",
                                emailAdr: "",
                                aptUnit: "",
                                dob: "",
                                city: "",
                                mobileNo: "",
                                state: "0",
                                secPhone: "",
                                zipCode: "",
                                empName: "",
                                empStartDate: "",
                                empPhoneNo: "",
                                netIncome: "",
                                duties: "",
                                housingInfo: "0",
                                ssn: "",
                                primaryIdType: "0",
                                primaryIdNo: "",
                                primaryIdState: "0",
                                primaryIdExpiryDate: "",
                                relativeName: "",
                                relativePhone: "",
                                relativeRelation: "",
                                verificationCode: "",
                                oftenPaid: "0",
                                cc: "",
                                lastPayDay: "",
                                ccExpiryDate: "",
                                nextPayDay: "",
                                ccName: "",
                                primarySourceIncome: "0",
                                creditCardBillingAddress: false,
                                ccmailingAdr: "",
                                ccaptUnit: "",
                                cccity: "",
                                ccstate: "0",
                                cczipCode: "",
                                bankRouteNo: "",
                                checkAccNo: "",
                                bankAccountDuration: "0",
                                associateEmployeeNo: "",
                                associatePassword: "",
                                rdApply: "DS",
                                lstSuffix: [],
                                lstState: [],
                                lstHousingInfo: [],
                                lstPrimaryIdType: [],
                                lstPrimaryIdState: [],
                                lstOftenPaid: [],
                                lstPrimarySourceIncome: [],
                                lstBankAccountDuration: [],
                                lstSecondIdType: [],
                                lstStoreCode: []
                            }
                        });
                    }

                    if (this.state.sessionId.length > 0) {
                        const winmessage = JSON.stringify({
                            applicationId: '0',
                            primaryId: '0'
                        });
                        window.parent.postMessage(winmessage, '*');
                        window.close();
                    }
                    window.location.replace("https://www.danielsjewelers.com/");
                }
            ).catch(err => {
                APIFailedMessage.displayError(err);
            })
        )
    }

    cancelSessionLink = (event, from) => {
        event.preventDefault();
        let fortivaAPIErrorMsg = this.state.fortivaAppErrMsg;
        if (this.state.thirdPartySessionLink) {
            this.cancelSession();
        }
        else if (from === "progressUownpage" && fortivaAPIErrorMsg) {
            sessionStorage.removeItem("progUownApplications");
            //localStorage.setItem("fortivaAPIErrorMsg",fortivaAPIErrorMsg);
            this.setState({ isAPIError: true, fortivaCredit: true, danielsCredit: false, synchronyCredit: false, UOwnLeasing: false, progressiveLeasing: false, isAPIErrorMsg: this.state.fortivaAppErrMsgDesc });
            this.setState({
                step1: true,
                isStep1Complete: false,
                step2: false,
                toggled: false,
                isStep2Complete: false,
                step3: false,
                isStep3Complete: false,
                step4: false,
                isStep4Complete: false,
                step5: false,
                isStep5Complete: false,
                step7: false,
                isStep7Complete: false,
                step8: false,
                isStep8Complete: false,
                step9: false,
                isStep9Complete: false,
                step10: false,
                isStep10Complete: false,
                step11: false,
                isStep11Complete: false,
                danielsDisclosure: false,
                synchronyDisclosure: false,
                verifyPassword: false,
                showPopup: false,
                progressiveDisclosure: false,
                progressiveSMS: false,
                UOwnDisclosure: false,
                showSubmitConfirmation: false,
                isAgreed: false,
                isSMSOverride: false,
                isSMSVerified: false,
                fortivaElecDisclosure: false,
                formObj: { ...this.state.formObj, verificationCode: "" }
            });
            this.validateMobileVerification(this.state.formObj?.mobileNo);
        }
        else if (sessionStorage.getItem("logout/continue") == "true") {
            sessionStorage.removeItem("progUownApplications");
            window.location.replace("https://www.danielsjewelers.com/");
        }
        else {
            let progApp = sessionStorage.getItem("progUownApplications");
            if (progApp || ((this.state.submissionStatus.synchrony || this.state.submissionStatus.daniels) && fortivaAPIErrorMsg))
                this.props.history.push("/view-offers");
            else
                this.props.history.push(`/customer-lookup`);
        }
    }

    async ErrorInSections() {
        if (!this.handleFormValidation("Step 1")) {
            this.setState({ errorInActVerification: true });
        }
        if (!this.handleFormValidation("Step 2")) {
            this.setState({ errorInMobileInfo: true });
        }
        if (!this.handleFormValidation("Step 3")) {
            this.setState({ errorInPersonalInfo: true });
        }
        if (!this.handleFormValidation("Step 4")) {
            this.setState({ errorInEmployment: true });
        }
        if (!this.handleFormValidation("Step 5")) {
            this.setState({ errorInIdentification: true });
        }
        if (!this.handleFormValidation("Step 6")) {
            this.setState({ errorInDaniels: true });
        }
        if (!this.handleFormValidation("Step 7")) {
            this.setState({ errorInSynchrony: true });
        }
        if (!this.handleFormValidation("Step 8") || (await this.validateABA() === false)) {
            this.setState({ erronInProgressive: true });
        }
        if (!this.handleFormValidation("Step 9")) {
            this.setState({ errorInUown: true });
        }
        if (!this.handleFormValidation("Step 10")) {
            this.setState({ errorInAutoPay: true });
        }
        if (!this.handleFormValidation("Step 12")) {
            this.setState({ errorInDisclosure: true });
        }
    }

    async handleFormValidationOnSubmit(event) {
        event.preventDefault();
        if (this.state.step1 === false) {
            this.setState({ step1: true });
        }
        if (this.state.step2 === false) {
            this.setState({ step2: true });
        }
        if (this.state.step3 === false) {
            this.setState({ step3: true });
        }
        if (this.state.step4 === false) {
            this.setState({ step4: true });
        }
        if (this.state.step5 === false) {
            this.setState({ step5: true });
        }
        if (this.state.step7 === false) {
            this.setState({ step7: true });
        }
        if (this.state.step8 === false) {
            this.setState({ step8: true });
        }
        if (this.state.step9 === false) {
            this.setState({ step9: true });
        }
        if (this.state.step10 === false) {
            this.setState({ step10: true });
        }
        if (this.state.step11 === false) {
            this.setState({ step11: true });
        }
        this.setState({ isStep11Complete: false, step12: false });
        this.setState({ showAppInProgress: !this.state.showAppInProgress }, () => {
            setTimeout(() => {
                this.handleValidation(event);
            }, this.state.setTimerForAppDelay);
        });
    }
    async handleValidation(event) {
        this.ErrorInSections();
        if (this.handleFormValidation("Step 1") && this.handleFormValidation("Step 2")
            && this.handleFormValidation("Step 3") && this.handleFormValidation("Step 4")
            && this.handleFormValidation("Step 5") && this.handleFormValidation("Step 6")
            && this.handleFormValidation("Step 7") && await this.validateABA() && this.handleFormValidation("Step 8")
            && this.handleFormValidation("Step 9") && this.handleFormValidation("Step 10") && this.handleFormValidation("Step 11") && this.handleFormValidation("Step 12") && this.handleFormValidation("employee validation")) {
            //    if((localStorage.getItem("magix_account_no") != "null" && localStorage.getItem("magix_account_no") != "")){
            //     if(this.state.danielsCredit)
            //         this.setState({ magixPopupShow: !this.state.magixPopupShow});
            //     else
            //     {
            //         this.setState({selectedMagixAccount:"",selectedMagixStoreId:""})
            //         this.handleSubmitConfirmationModal(event);
            //     }
            // }else
            this.setState({ showAppInProgress: !this.state.showAppInProgress });
            this.handleSubmitConfirmationModal(event);

        } else {
            this.setState({ showAppInProgress: !this.state.showAppInProgress });
            this.setState({ isStep11Complete: true, step12: true });
        }

    }
    handleSubmitConfirmationModal(event) {
        event.preventDefault();
        this.setState({ showSubmitConfirmation: !this.state.showSubmitConfirmation });
        //this.setState({ showSubmitConfirmation: !this.state.showSubmitConfirmation,selectedMagixAccount:"",selectedMagixStoreId:"" });
    }
    handleSubmitModalCancel(event) {
        event.preventDefault();
        this.setState({ showSubmitConfirmation: !this.state.showSubmitConfirmation });
        this.setState({ isStep11Complete: true, step12: true });
    }
    // ConfirmationMagixModal(event) {
    //     event.preventDefault();
    //     this.setState({ showSubmitConfirmation: !this.state.showSubmitConfirmation });
    //     document.getElementById("confirmStep12").disabled=false;
    // }

    onDOBChange(event) {
        if (event === null) {
            this.setState({
                formObj: { ...this.state.formObj, dob: "" },
            });
        }
        else {
            this.setState({
                formObj: { ...this.state.formObj, dob: Moment(event).format("MM/DD/YYYY") },
            });
        }
    }
    onStartDateChange(event) {
        if (event === null) {
            this.setState({
                formObj: { ...this.state.formObj, empStartDate: "" }
            }, () => { this.trackChanges(); });
        }
        else {
            this.setState({
                formObj: { ...this.state.formObj, empStartDate: Moment(event).format("MM/YYYY") },
            }, () => { this.trackChanges(); });
        }
    }
    onLastPayDayChange(event) {
        if (event === null) {
            this.setState({
                formObj: { ...this.state.formObj, lastPayDay: "" },
            });
        }
        else {
            this.setState({
                formObj: { ...this.state.formObj, lastPayDay: Moment(event).format("MM/DD/YYYY") },
            });
        }
    }
    onCCExpiryDateChange(event) {
        if (event === null) {
            this.setState({
                formObj: { ...this.state.formObj, ccExpiryDate: "" },
            });
        }
        else {
            this.setState({
                formObj: { ...this.state.formObj, ccExpiryDate: Moment(event).format("MM/YYYY") },
            });
        }
    }
    onNextPayDayChange(event) {
        if (event === null) {
            this.setState({
                formObj: { ...this.state.formObj, nextPayDay: "" },
            });
        }
        else {
            this.setState({
                formObj: { ...this.state.formObj, nextPayDay: Moment(event).format("MM/DD/YYYY") },
            });
        }
    }

    onPrimaryIdExpiryDateChange(event) {
        if (event === null) {
            this.setState({
                formObj: { ...this.state.formObj, primaryIdExpiryDate: "" },
            });
        }
        else {
            this.setState({
                formObj: { ...this.state.formObj, primaryIdExpiryDate: Moment(event).format("MM/YYYY") },
            });
        }
    }
    onSecondIdExpiryDateChange(event) {
        if (event === null) {
            this.setState({
                formObj: { ...this.state.formObj, secondIdExpiryDate: "" },
            });
        }
        else {
            this.setState({
                formObj: { ...this.state.formObj, secondIdExpiryDate: Moment(event).format("MM/YYYY") },
            });
        }
    }

    onNetIncomeChangeChange(value, name) {
        this.setState({
            formObj: { ...this.state.formObj, netIncome: value },
        });
    }

    updateState(controlId, controlValue) {
        if (controlId === "rdDanielsAndSync") {
            this.setState({
                formObj: { ...this.state.formObj, rdApply: controlValue },
            });
        } else if (controlId === "rdDanielsOnly") {
            this.setState({
                formObj: { ...this.state.formObj, rdApply: controlValue },
            });
        }
        else if (controlId === "rdSyncOnly") {
            this.setState({
                formObj: { ...this.state.formObj, rdApply: controlValue },
            });
        }
        else if (controlId === "frKeyCredit_Id") {
            this.setState({
                formObj: { ...this.state.formObj, credit_Id: controlValue },
            });
        }
        else if (controlId === "cmbSuffix") {
            this.setState({
                formObj: { ...this.state.formObj, suffix: controlValue },
            });
        }
        else if (controlId === "txtCustomerNo") {
            this.setState({
                formObj: { ...this.state.formObj, customerNo: controlValue },
            });
        }
        else if (controlId === "cmbStoreCode") {
            this.setState({
                formObj: { ...this.state.formObj, storeCode: controlValue },
            });
            let CDstore = this.state.storesList?.find((val) => val.code == controlValue);
            //send synchrony app to the synchrony or credit director(old synchrony) based on store enable
            if (CDstore?.isSynchronyCD == true)
                this.setState({ nonSynchronyCD: false });
            else
                this.setState({ nonSynchronyCD: true });

            //Enable or disable fortiva for specific store.  
            if (CDstore?.isFortiva === true) {
                this.setState({ fortivaApp: true });
                // if(this.state.isWaterFallEnable){
                //     let progUownApplications=JSON.parse(sessionStorage.getItem("progUownApplications"));
                //     if(progUownApplications){
                //         if(progUownApplications===true){
                //             this.setState({fortivaCredit:false,danielsCredit:false,synchronyCredit:false});
                //         }
                //     }
                //     else if(!this.state.progressiveLeasing && !this.state.UOwnLeasing){
                //         this.setState({fortivaCredit:true});
                //     }
                // }
                // else{
                //     this.setState({fortivaCredit:false});
                // }
                let fortivaAPIErrorMsg = localStorage.getItem("fortivaAPIErrorMsg");
                if (fortivaAPIErrorMsg) {
                    this.setState({ fortivaCredit: true, danielsCredit: false, synchronyCredit: false, progressiveLeasing: false, UOwnLeasing: false });
                }
            }
            else {
                this.setState({ fortivaApp: false, fortivaCredit: false });
            }
            if (CDstore?.isDaniels === true) this.setState({ danielsApp: true })
            else this.setState({ danielsApp: false })
            if (CDstore?.isProgressive === true) this.setState({ progressiveApp: true })
            else this.setState({ progressiveApp: false })
            if (CDstore?.isUown === true) this.setState({ uownApp: true })
            else this.setState({ uownApp: false })
        }
        else if (controlId === "txtFirstName") {
            controlValue = controlValue.replace(",", "");
            const re = /^(?!\s)[-a-zA-Z ]*$/;
            if (controlValue === '' || re.test(controlValue)) {
                this.setState({
                    formObj: { ...this.state.formObj, firstName: controlValue },
                });
            }
        }
        else if (controlId === "txtMiddleName") {
            controlValue = controlValue.replace(",", "");
            const re = /^(?!\s)[-a-zA-Z ]*$/;
            if (controlValue === '' || re.test(controlValue)) {
                this.setState({
                    formObj: { ...this.state.formObj, middleName: controlValue },
                });
            }
        }
        else if (controlId === "txtLastName") {
            controlValue = controlValue.replace(",", "");
            const re = /^(?!\s)[-a-zA-Z ]*$/;
            if (controlValue === '' || re.test(controlValue)) {
                this.setState({
                    formObj: { ...this.state.formObj, lastName: controlValue },
                });
            }

        }
        else if (controlId === "txtMailingAdr") {
            this.setState({
                formObj: { ...this.state.formObj, mailingAdr: controlValue },
            }, () => {
                this.trackChanges();
            });
        }
        else if (controlId === "txtEmailAdr") {
            this.setState({
                formObj: { ...this.state.formObj, emailAdr: controlValue },
            }, () => {
                this.trackChanges();
            });
        }
        else if (controlId === "txtAptUnit") {
            this.setState({
                formObj: { ...this.state.formObj, aptUnit: controlValue },
            }, () => {
                this.trackChanges();
            });
        }
        else if (controlId === "txtCity") {
            controlValue = controlValue.replace(",", "");
            const re = /^(?!\s)[-a-zA-Z ]*$/;
            if (controlValue === '' || re.test(controlValue)) {
                this.setState({
                    formObj: { ...this.state.formObj, city: controlValue },
                }, () => {
                    this.trackChanges();
                });
            }
        }
        else if (controlId === "txtMobileNo") {
            this.setState({
                formObj: { ...this.state.formObj, mobileNo: formatPhoneNumber(controlValue) },
            }, () => {
                this.validateMobileVerification(this.state.formObj?.mobileNo);
                this.trackChanges();
            });
        }
        else if (controlId === "cmbState") {
            this.setState({
                formObj: { ...this.state.formObj, state: controlValue },
            }, () => {
                this.trackChanges();
            });
        }
        else if (controlId === "txtSecPhone") {
            this.setState({
                formObj: { ...this.state.formObj, secPhone: formatPhoneNumber(controlValue) },
            });
        }
        else if (controlId === "txtZipCode") {
            const re = /^[0-9\b]+$/;
            if (controlValue === '' || re.test(controlValue)) {
                this.setState({
                    formObj: { ...this.state.formObj, zipCode: controlValue },
                }, () => {
                    this.trackChanges();
                });
            }
        }
        else if (controlId === "txtEmpName") {
            // controlValue = controlValue.replace(",","");
            // const re = /^(?!\s)[-a-zA-Z ]*$/;
            // if (controlValue === '' || re.test(controlValue)) {
            //     this.setState({
            //         formObj: { ...this.state.formObj, empName: controlValue },
            //     });
            // }
            this.setState({
                formObj: { ...this.state.formObj, empName: controlValue },
            }, () => {
                this.trackChanges();
            });
        }
        else if (controlId === "txtEmpPhoneNo") {
            this.setState({
                formObj: { ...this.state.formObj, empPhoneNo: formatPhoneNumber(controlValue) },
            }, () => {
                this.trackChanges();
            });
        }
        else if (controlId === "txtNetIncome") {
            const re = /^[0-9\b]+$/;
            if (controlValue === '' || re.test(controlValue)) {
                this.setState({
                    formObj: { ...this.state.formObj, netIncome: controlValue },
                }, () => {
                    this.trackChanges();
                });
            }
        }
        else if (controlId === "txtDuties") {
            controlValue = controlValue.replace(",", "");
            const re = /^(?!\s)[-a-zA-Z ]*$/;
            if (controlValue === '' || re.test(controlValue)) {
                this.setState({
                    formObj: { ...this.state.formObj, duties: controlValue },
                }, () => {
                    this.trackChanges();
                });
            }
        }
        else if (controlId === "cmbHousingInfo") {
            this.setState({
                formObj: { ...this.state.formObj, housingInfo: controlValue },
            }, () => {
                this.trackChanges();
            });
        }
        else if (controlId === "txtSSN") {
            this.setState({
                formObj: { ...this.state.formObj, ssn: controlValue },
            });
        }
        else if (controlId === "cmbPrimaryIdType") {
            this.setState({
                formObj: { ...this.state.formObj, primaryIdType: controlValue },
            }, () => {
                this.trackChanges();
            });
        }
        else if (controlId === "txtPrimaryIdNo") {
            this.setState({
                formObj: { ...this.state.formObj, primaryIdNo: controlValue },
            }, () => {
                this.trackChanges();
            });
        }
        else if (controlId === "cmbPrimaryIdState") {
            this.setState({
                formObj: { ...this.state.formObj, primaryIdState: controlValue },
            }, () => {
                this.trackChanges();
            });
        }
        else if (controlId === "txtRelativeName") {
            controlValue = controlValue.replace(",", "");
            const re = /^(?!\s)[-a-zA-Z ]*$/;
            if (controlValue === '' || re.test(controlValue)) {
                this.setState({
                    formObj: { ...this.state.formObj, relativeName: controlValue },
                }, () => {
                    this.trackChanges();
                });
            }
        }
        else if (controlId === "txtRelativePhone") {
            this.setState({
                formObj: { ...this.state.formObj, relativePhone: formatPhoneNumber(controlValue) },
            }, () => {
                this.trackChanges();
            });
        }
        else if (controlId === "txtRelativeRelation") {
            controlValue = controlValue.replace(",", "");
            const re = /^(?!\s)[-a-zA-Z ]*$/;
            if (controlValue === '' || re.test(controlValue)) {
                this.setState({
                    formObj: { ...this.state.formObj, relativeRelation: controlValue },
                }, () => {
                    this.trackChanges();
                });
            }
        }
        else if (controlId === "txtVerificationCode") {
            const re = /^[0-9\b]+$/;
            if (controlValue === '' || re.test(controlValue)) {
                this.setState({
                    formObj: { ...this.state.formObj, verificationCode: controlValue },
                });
            }
        }
        else if (controlId === "cmbOftenPaid") {
            this.setState({
                formObj: { ...this.state.formObj, oftenPaid: controlValue },
            });
        }
        else if (controlId === "txtCC") {
            //const re = /^[0-9\b]+$/;
            //if (controlValue === '' || re.test(controlValue)) {

            //}
            this.setState({
                formObj: { ...this.state.formObj, cc: formatCC(controlValue) },
            });
        }
        else if (controlId === "txtLastPayDay") {
            this.setState({
                formObj: { ...this.state.formObj, lastPayDay: controlValue },
            });
        }
        else if (controlId === "txtCCExpiryDate") {
            this.setState({
                formObj: { ...this.state.formObj, ccExpiryDate: controlValue },
            });
        }
        else if (controlId === "txtNextPayDay") {
            this.setState({
                formObj: { ...this.state.formObj, nextPayDay: controlValue },
            });
        }
        else if (controlId === "txtCCName") {
            controlValue = controlValue.replace(",", "");
            const re = /^(?!\s)[-a-zA-Z ]*$/;
            if (controlValue === '' || re.test(controlValue)) {
                this.setState({
                    formObj: { ...this.state.formObj, ccName: controlValue },
                });
            }
        }
        else if (controlId === "cmbPrimarySourceIncome") {
            this.setState({
                formObj: { ...this.state.formObj, primarySourceIncome: controlValue },
            });
        }
        //else if (controlId === "cmbCreditCardBillingAddress") {
        //    this.setState({
        //        formObj: { ...this.state.formObj, creditCardBillingAddress: controlValue },
        //    });
        //}
        else if (controlId === "txtCCMailingAdr") {
            this.setState({
                formObj: { ...this.state.formObj, ccmailingAdr: controlValue },
            });
        }
        else if (controlId === "txtCCAptUnit") {
            this.setState({
                formObj: { ...this.state.formObj, ccaptUnit: controlValue },
            });
        }
        else if (controlId === "txtCCCity") {
            controlValue = controlValue.replace(",", "");
            const re = /^(?!\s)[-a-zA-Z ]*$/;
            if (controlValue === '' || re.test(controlValue)) {
                this.setState({
                    formObj: { ...this.state.formObj, cccity: controlValue },
                });
            }
        }
        else if (controlId === "cmbCCState") {
            this.setState({
                formObj: { ...this.state.formObj, ccstate: controlValue },
            });
        }
        else if (controlId === "txtCCZipCode") {
            const re = /^[0-9\b]+$/;
            if (controlValue === '' || re.test(controlValue)) {
                this.setState({
                    formObj: { ...this.state.formObj, cczipCode: controlValue },
                });
            }
        }
        else if (controlId === "txtBankRouteNo") {
            const re = /^[0-9\b]+$/;
            if (controlValue === '' || re.test(controlValue)) {
                this.setState({
                    formObj: { ...this.state.formObj, bankRouteNo: controlValue }, ABAError: undefined, ABAChanged: true
                });
            }
        }
        else if (controlId === "txtCheckAccNo") {
            this.setState({
                formObj: { ...this.state.formObj, checkAccNo: controlValue },
            });
        }
        else if (controlId === "cmbBankAccountDuration") {
            this.setState({
                formObj: { ...this.state.formObj, bankAccountDuration: controlValue },
            });
        }
        else if (controlId === "txtAssociateEmployeeNo") {
            this.setState({
                formObj: { ...this.state.formObj, associateEmployeeNo: controlValue },
            });
        }
        else if (controlId === "txtAssociatePassword") {
            this.setState({
                formObj: { ...this.state.formObj, associatePassword: controlValue },
            });
        }
        else if (controlId === "cmbSecondIdType") {
            this.setState({
                formObj: { ...this.state.formObj, secondIdType: controlValue },
            });
        }
        else if (controlId === "txtSecondIdIssuedBy") {
            this.setState({
                formObj: { ...this.state.formObj, secondIdIssuedBy: controlValue },
            });
        }
        else if (controlId === "UECaptcha") {
            this.setState({ UECaptcha: controlValue });
        }
        else if (controlId === "exitingId") {
            this.setState({ djoIdError: "" });
            this.setState({ djoId: controlValue });
        }
    }
    onSSNChange(value, mask) {
        this.setState({
            formObj: { ...this.state.formObj, ssn: value },
        });
    }
    onChange(event) {
        this.updateState(event.target.id, event.target.value);
    }
    getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    loadData(data) {
        const winmessage = JSON.stringify({
            applicationId: data.lastDraftCreditId,
            primaryId: data.idNumber
        });
        window.parent.postMessage(winmessage, '*');
        window.close();
        window.location.replace("https://www.danielsjewelers.com/");
        //localStorage.setItem("associateId", data.id);
        //this.setState({
        //    formObj: {
        //        ...this.state.formObj,
        //        credit_Id: data.LastDraftCreditId,
        //        customerNo: data.id,
        //        suffix: (data.suffix_Id === null ? "0" : data.suffix_Id),
        //        firstName: (data.firstName === null ? "" : data.firstName.replace(",","")),
        //        middleName: (data.middleName === null ? "" : data.middleName.replace(",","")),
        //        lastName: (data.lastName === null ? "" : data.lastName.replace(",","")),
        //        mailingAdr: (data.address === null ? "" : data.address),
        //        emailAdr: (data.emailAddress === null ? "" : data.emailAddress),
        //        aptUnit: (data.apt === null ? "" : data.apt),
        //        dob: (data.birthDate === null ? "" : Moment(data.birthDate).format("MM/DD/YYYY")),
        //        city: (data.city === null ? "" : data.city.replace(",","")),
        //        mobileNo: (data.mobileNo === null ? "" : formatPhoneNumber(data.mobileNo)),
        //        state: (data.state_Id === null ? "0" : data.state_Id),
        //        secPhone: (data.secondaryPhone === null ? "" : formatPhoneNumber(data.secondaryPhone)),
        //        zipCode: (data.zipCode === null ? "" : data.zipCode),
        //        empName: (data.empName === null ? "" : data.empName),
        //        empStartDate: (data.howLong === null ? "" : Moment(data.howLong).format("MM/YYYY")),
        //        empPhoneNo: (data.empPhone === null ? "" : formatPhoneNumber(data.empPhone)),
        //        netIncome: (data.monthlyIncome === null ? "" : data.monthlyIncome),
        //        duties: (data.workJob === null ? "" : data.workJob.replace(",","")),
        //        housingInfo: (data.housingInfo_Id === null ? "0" : data.housingInfo_Id),
        //        ssn: (data.ssn === null ? "" : data.ssn),
        //        primaryIdType: (data.primaryType_Id === null ? "0" : data.primaryType_Id),
        //        primaryIdNo: (data.idNumber === null ? "" : data.idNumber),
        //        primaryIdState: (data.primaryState_Id === null ? "0" : data.primaryState_Id),
        //        relativeName: (data.relativeName === null ? "" : data.relativeName.replace(",","")),
        //        relativePhone: (data.relativePhone === null ? "" : formatPhoneNumber(data.relativePhone)),
        //        relativeRelation: (data.relativeRelationship === null ? "" : data.relativeRelationship.replace(",","")),
        //        oftenPaid: (data.howOftenPaid_Id === null ? "0" : data.howOftenPaid_Id),
        //        cc: (data.creditCardBin === null ? "" : data.creditCardBin),
        //        lastPayDay: (data.lastPayDay === null ? "" : Moment(data.lastPayDay).format("MM/DD/YYYY")),
        //        ccExpiryDate: (data.creditCardExpDate === null ? "" : Moment(data.creditCardExpDate).format("MM/YYYY")),
        //        nextPayDay: (data.nextPayDay === null ? "" : Moment(data.nextPayDay).format("MM/DD/YYYY")),
        //        ccName: (data.nameOnCreditCard === null ? "" : data.nameOnCreditCard.replace(",","")),
        //        creditCardBillingAddress: data.creditCardHomeAddress,
        //        ccmailingAdr: (data.ccAddress === null ? "" : data.ccAddress),
        //        ccaptUnit: (data.ccApt === null ? "" : data.ccApt),
        //        cccity: (data.ccCity === null ? "" : data.ccCity.replace(",","")),
        //        ccstate: (data.ccState_Id === null ? "0" : data.ccState_Id),
        //        cczipCode: (data.ccZipCode === null ? "" : data.ccZipCode),
        //        bankRouteNo: (data.bankRoutingNo === null ? "" : data.bankRoutingNo),
        //        checkAccNo: (data.checkingAccountNo === null ? "" : data.checkingAccountNo),
        //        primaryIdExpiryDate: (data.primaryIdExpDate === null ? "" : Moment(data.primaryIdExpDate).format("MM/YYYY")),
        //        secondIdType: (data.secondIdType_Id === null ? "0" : data.secondIdType_Id),
        //        secondIdIssuedBy: (data.secondIdIssuedBy_Id === null ? "" : data.secondIdIssuedBy_Id),
        //        secondIdExpiryDate: (data.secondIdExpDate === null ? "" : Moment(data.secondIdExpDate).format("MM/YYYY")),
        //    }, verificationBox :false})
    }

    // duplicateDJOApplication(type) {
    //     if(type === "verify") {
    //         this.setState({djoIdError : "Searching. Please wait..."});
    //         this.setState({djoIdConfirm : false, verificationBox : true});
    //         if(this.state.djoId?.toLowerCase() === this.state.customerInfo?.customer?.idNumber?.toLowerCase()) {
    //             this.loadData(this.state.customerInfo.customer);
    //         }
    //         else {
    //             let obj ={
    //                 "phone": "",
    //                 "name": "",
    //                 "address": "",
    //                 "homeStore": "",
    //                 "accountId": "",
    //                 "id": this.state.djoId,
    //                 "ssn": "",
    //                 "balanceDue": "",
    //                 "lastActivity": "",
    //                 "email": "",
    //                 "session": this.state.sessionId,
    //                 "pageIndex": 0,
    //                 "pageSize": 0,
    //                 "sortBy": "",
    //                 "sortOrder": ""
    //             };
    //             trackPromise(
    //                 this.props.actions.djoMatchFoundValidate(obj).then(
    //                     response => {
    //                         if(response.length == 0) {
    //                             this.setState({djoIdError : "ID does not match"});
    //                         }     
    //                         else {
    //                             this.loadData(response[0]);
    //                         }
    //                     }
    //                 ).catch(err => {
    //                     APIFailedMessage.displayError(err);
    //                 })
    //             )           
    //         }
    //     }
    //     else if(type === "continue"){
    //         this.setState({
    //             formObj: {
    //                 ...this.state.formObj,
    //                 firstName: (this.state.customerInfo.data.firstname === null ? "" : this.state.customerInfo.data.firstname),
    //                 middleName: (this.state.customerInfo.data.middleName === null ? "" : this.state.customerInfo.data.middleName),
    //                 lastName: (this.state.customerInfo.data.lastName === null ? "" : this.state.customerInfo.data.lastName),
    //                 mailingAdr: (this.state.customerInfo.data.address === null ? "" : this.state.customerInfo.data.address),
    //                 emailAdr: (this.state.customerInfo.data.emailAddress === null ? "" : this.state.customerInfo.data.emailAddress),
    //                 aptUnit: (this.state.customerInfo.data.apt === null ? "" : this.state.customerInfo.data.apt),
    //                 city: (this.state.customerInfo.data.city === null ? "" : this.state.customerInfo.data.city),
    //                 mobileNo: (this.state.customerInfo.data.mobileNumber === null ? "" : formatPhoneNumber(this.state.customerInfo.data.mobileNumber)),
    //                 zipCode: (this.state.customerInfo.data.zipcode === null ? "" : this.state.customerInfo.data.zipcode),
    //                 state: this.state.customerInfo?.data.state?.trim(),
    //         },thirdPartySessionLink: true, cartId: this.state.customerInfo?.data.cartId, sessionId: this.state.customerInfo?.sessionId, isAutoPayRequired: this.state.customerInfo?.data.isAutoPay, verificationBox: false})
    //     }        
    // }

    loadAddress(obj) {
        this.handleFormValidation("revertDJOaddressVerify");
        if (obj === "") {
            this.setState({ formObj: { ...this.state.formObj, mailingAdr: "", aptUnit: "", city: "", zipCode: "", state: '0' }, allAptUnit: [] });
        }
        else {
            this.loadAllAddresses(obj);
        }
    }

    autoFill(val) {
        let mailingAddress = val;
        let data = this.state.allAddress?.find((val) => val.AddressKey == mailingAddress);
        this.setState({ allAptUnit: (data?.SuiteName !== "") ? data?.SuiteList : [] });
        if ((sessionStorage.getItem("SMSLink") == "true") || (this.state.thirdPartySessionLink ? (this.state.cartId == "" || this.state.cartId == "0") : false)) {
            let state = this.state.formObj?.lstState.find((val) => val.code == data?.State);
            if (state === undefined) {
                this.setState({ formObj: { ...this.state.formObj, mailingAdr: "", city: "", zipCode: "", state: '0' } });
                this.handleFormValidation("DJOaddressVerify");
            }
            else {
                this.setState({ formObj: { ...this.state.formObj, mailingAdr: data?.AddressLine1, city: data?.City, zipCode: data?.PostalCode.split("-")[0], state: state?.id } });
            }
        }
        else {
            let state = this.state.formObj?.lstState.find((val) => val.code == data?.State);
            this.setState({ formObj: { ...this.state.formObj, mailingAdr: data?.AddressLine1, aptUnit: "", city: data?.City, zipCode: data?.PostalCode.split("-")[0], state: state?.id } });
            if (data?.SuiteName !== "") {
                document.getElementById("txtAptUnit").focus();
            }
        }
    }

    updateDropDowns() {
        this.loadDropDowns("Suffix");
        this.loadDropDowns("HousingInfo");
        this.loadDropDowns("PrimaryIdType");
        this.loadDropDowns("State_Credit");
        this.loadDropDowns("State");
        this.loadDropDowns("OftenPaid");
        this.loadDropDowns("SecondIdType");
    }

    loadAdminSettings() {
        trackPromise(
            this.props.adminActions.getSignOutTime().then(
                response => {
                    if (response) {
                        this.setState({
                            isAutoPayEnabled: response.isAutoPayEnabled,
                            isSynchronySendEmail: response.isSendEmail_Synchrony,
                            addressAutoFillEnable: response.isAddressAutoComplete,
                            isWaterFallEnable: response.isWaterFallEnable,
                            isEstatementEnable: response.isEstatementEnable,
                            isDanielsApplicationFlowChanges: response.isDanielsApplicationFlowChanges,
                            isAssociateStore_IP: response.isAssociateStore_IP,
                            setTimerForAppDelay: response.timervalue
                        });
                        if (!response.isAssociateStore_IP) {
                            if (this.state.associateStoreId)
                                localStorage.setItem('associateStores', this.state.associateStoreId)
                        }
                        let progUownApplications = JSON.parse(sessionStorage.getItem("progUownApplications"));
                        let fortivaAPIErrorMsg = localStorage.getItem("fortivaAPIErrorMsg");
                        if (response.isWaterFallEnable) {
                            if (progUownApplications) {
                                if (progUownApplications == true) {
                                    this.setState({ danielsCredit: false, synchronyCredit: false, fortivaCredit: false })
                                    if (this.state.progressiveLeasing && this.state.progressiveApp) {
                                        this.setState({ progressiveLeasing: true });
                                    }
                                    else if (this.state.UOwnLeasing && this.state.uownApp) {
                                        this.setState({ UOwnLeasing: true });
                                    }
                                }
                            }
                            else if (fortivaAPIErrorMsg) {
                                this.setState({ fortivaCredit: true, danielsCredit: false, synchronyCredit: false });
                            }
                            else {
                                if (sessionStorage.getItem("isNewApplication") == "false") {
                                    let financialPartner = sessionStorage.getItem("selectedPartner");
                                    if (financialPartner == "Daniel" && this.state.danielsApp) {
                                        this.setState({ danielsCredit: true, fortivaCredit: false, synchronyCredit: false })
                                    } else if (financialPartner == "Fortiva" && this.state.fortivaApp) {
                                        this.setState({ danielsCredit: false, fortivaCredit: true, synchronyCredit: false })
                                    } else if (financialPartner == "Synchrony") {
                                        this.setState({ danielsCredit: false, fortivaCredit: false, synchronyCredit: true })
                                    } else if (financialPartner == "Progressive" && this.state.progressiveApp) {
                                        this.setState({ progressiveLeasing: true, danielsCredit: false, fortivaCredit: false, synchronyCredit: false, UOwnLeasing: false })
                                    } else {
                                        if (this.state.uownApp)
                                            this.setState({ UOwnLeasing: true, danielsCredit: false, fortivaCredit: false, synchronyCredit: false, progressiveLeasing: false })
                                    }
                                }
                                else {
                                    if (!this.state.fortivaApp && !this.state.danielsApp) {
                                        this.setState({ danielsCredit: false, fortivaCredit: false, synchronyCredit: true });
                                    } else if (this.state.fortivaApp && !this.state.danielsApp) {
                                        this.setState({ danielsCredit: false, fortivaCredit: true, synchronyCredit: true });
                                    } else if (!this.state.fortivaApp && this.state.danielsApp) {
                                        this.setState({ danielsCredit: true, fortivaCredit: false, synchronyCredit: true });
                                    } else {
                                        this.setState({ danielsCredit: true, fortivaCredit: true, synchronyCredit: true });
                                    }
                                }
                            }
                        }
                        else {
                            this.setState({ danielsCredit: false, fortivaCredit: false, synchronyCredit: false });
                        }
                    }
                }
            ).catch(err => {
                APIFailedMessage.displayError(err);
            })
        )
    }

    async componentDidMount() {
        const params = this.props.history.location.search;
        if (params) {
            this.setState({ isDanielsApp: true });
        }
        else {
            this.setState({ isDanielsApp: false });
        }
        //auto pay enroll
        let _applyNowSelf = this;
        window.addEventListener('message', function (e) {
            // Get the sent data
            const data = e.data;
            if (typeof data === 'string' || data instanceof String) {
                if (data === 'ENROLLED' || data === 'ENROL' || data === 'ENROLL' || data === 'CANCELLED' || data === 'CANCEL') {
                    if (data === 'CANCELLED' || data === 'CANCEL') {
                        if (_applyNowSelf.state.isAutoPayRequired) {
                            _applyNowSelf.cancelSession();
                        }
                    }
                    else {
                        _applyNowSelf.setState({ autoPaySubmitted: true });
                        _applyNowSelf.setState({ autoPayStatus: e.data });
                    }
                }

            }

        });
        sessionStorage.setItem("updated_fortiva_response", null);
        let progUownApplications = JSON.parse(sessionStorage.getItem("progUownApplications"));
        if (progUownApplications) {
            if (progUownApplications == true) {
                this.setState({ danielsCredit: false, synchronyCredit: false, fortivaCredit: false });
            }
        }
        if (JSON.parse(sessionStorage.getItem('isLoggedIn'))) {
            await trackPromise(
                this.props.adminActions.getallstoredetails()
                    .then((res) => {
                        this.setState({ storesList: res });
                        this.updateState("cmbStoreCode", JSON.parse(localStorage.getItem("associateStores")));
                        let associatedSore = res.find(item => item.code === JSON.parse(localStorage.getItem("associateStores")));
                        if (associatedSore?.isFortiva) this.setState({ fortivaApp: true });
                        else this.setState({ fortivaApp: false });
                        if (associatedSore?.isDaniels === true) this.setState({ danielsApp: true })
                        else this.setState({ danielsApp: false })
                        if (associatedSore?.isProgressive === true) this.setState({ progressiveApp: true })
                        else this.setState({ progressiveApp: false, waterfallObj: { ...this.state.waterfallObj, isProgChecked: false } })
                        if (associatedSore?.isUown === true) this.setState({ uownApp: true })
                        else this.setState({ uownApp: false, waterfallObj: { ...this.state.waterfallObj, isUownChecked: false } })
                    })
                    .catch((err) => {
                        APIFailedMessage.displayError(err);
                    })
            )

            let securityKey = window.env.KEYS_SECURITY_KEY;
            const CryptoJS = require('crypto-js');
            let params = window.location.href.split("now?")[1];
            if (params !== undefined) {
                params = CryptoJS.AES.decrypt(params, securityKey).toString(CryptoJS.enc.Utf8);
            }
            //stay in and continue 
            if (params === securityKey) {
                this.setState({ isDanielsApp: false });
                this.setState({ thirdPartyLink: false });
                this.props.actions.getIpAddressNew().then(
                    res => {
                        this.updateState("cmbStoreCode", JSON.parse(localStorage.getItem("associateStores")));
                        sessionStorage.setItem("ipAddress", res);
                    }).catch(err => {
                        APIFailedMessage.displayError(err);
                    }
                    )
                sessionStorage.setItem("thirdPartyLink", false);
                this.updateDropDowns();
                this.loadAdminSettings();
                let storageAssociateStores = sessionStorage.getItem("storeList");
                this.setState({
                    formObj: { ...this.state.formObj, lstStoreCode: JSON.parse(storageAssociateStores) },
                });
                this.updateState("txtAssociateEmployeeNo", JSON.parse(sessionStorage.getItem('userStoresInfo') ?? "")?.associateEmpNo);
                if (sessionStorage.getItem("isNewApplication") === "false") {
                    this.loadCustomer();
                    // let fortivaAPIErrorMsg=localStorage.getItem("fortivaAPIErrorMsg");
                    // if(fortivaAPIErrorMsg){
                    //     this.setState({ isAPIError: true,fortivaCredit:true,isAPIErrorMsg:fortivaAPIErrorMsg,danielsCredit:false,synchronyCredit:false });
                    // }
                }
                if (sessionStorage.getItem("isNewApplication") === "true") {
                    localStorage.setItem("applicationId", null);
                    localStorage.setItem("magixassociateId", null);
                }
                this.loadAutoPay();
                trackPromise(
                    this.props.userRightsactions.getUserRights().then(
                        response => {
                            if (response) {
                                this.setState({
                                    roles: response.roles,
                                    site_page_details: response.sitePageDetails,
                                    sitePages: response.sitePages,
                                    userRights: response.userRights
                                });
                                this.getPermissions()
                            }
                        }).catch(err => {
                            APIFailedMessage.displayError(err);
                        }),
                    this.props.actions.getPopUpMessage("ApplyNow").then(res => {
                        if (res) {
                            res.map(item => {
                                return item.description = item.description?.replaceAll("*^*", "'");
                            })
                            this.setState({ alterPopupmessage: res });
                        }
                    }).catch(err => {
                        APIFailedMessage.displayError(err);
                    })
                )
            }
            // already in apply now page ,but if user wants to apply through apply url
            else if (window.location.href.split('/').pop() === "apply-now") {
                sessionStorage.clear();
                window.location.reload();
                this.setState({ SMSLink: true });
                this.setState({ siteKey: window.env.KEYS_SITE_KEY });

                await trackPromise(
                    this.props.actionStore.getCreditToken("09E1919E-CF29-4831-A663-7878F0CF0366").then(
                        response => {
                            if (response.token !== null) {
                                localStorage.setItem('token', response.token);
                                sessionStorage.setItem("SMSLink", "true");
                                sessionStorage.setItem("isNewApplication", "true");
                                sessionStorage.setItem("thirdPartyLink", "true");
                                this.setState({ thirdPartyLink: true, synchronyCredit: false, progressiveLeasing: false, UOwnLeasing: false, fortivaCredit: false, danielsCredit: true });
                                this.updateDropDowns();
                                this.loadAutoPay();
                                this.updateState("txtAssociateEmployeeNo", "");
                            }
                            else {
                                this.setState({ smsURLError: true });
                            }
                        }
                    )
                )
                await this.props.actions.getIpAddressNew().then(
                    res => {
                        sessionStorage.setItem("ipAddress", res);
                    }).catch(err => {
                        APIFailedMessage.displayError(err);
                    }
                    )
            }
            else {
                sessionStorage.clear();
                this.props.history.push("/");
            }
        }
        // apply url
        else if (window.location.href.split('/').pop() === "apply-now") {
            this.setState({ SMSLink: true });
            this.setState({ siteKey: window.env.KEYS_SITE_KEY });
            await trackPromise(
                this.props.actionStore.getCreditToken("09E1919E-CF29-4831-A663-7878F0CF0366").then(
                    response => {
                        if (response.token !== null) {
                            localStorage.setItem('token', response.token);
                            sessionStorage.setItem("SMSLink", "true");
                            sessionStorage.setItem("isNewApplication", "true");
                            sessionStorage.setItem("thirdPartyLink", "true");
                            this.setState({ thirdPartyLink: true, synchronyCredit: false, progressiveLeasing: false, UOwnLeasing: false, fortivaCredit: false, danielsCredit: true });
                            this.updateDropDowns();
                            this.loadAutoPay();
                            this.updateState("txtAssociateEmployeeNo", "");
                        }
                        else {
                            this.setState({ smsURLError: true });
                        }
                    }
                )
            )
            await this.props.actions.getIpAddressNew().then(
                res => {
                    sessionStorage.setItem("ipAddress", res);
                }).catch(err => {
                    APIFailedMessage.displayError(err);
                }
                )
        }
        else if (window.location.href.split('now?')[1] !== undefined) {
            //djo
            if (window.location.href.split('now?')[1].slice(0, 9) === "SessionId") {
                var obj = window.location.href.split("SessionId=")[1];
                this.setState({ siteKey: window.env.KEYS_SITE_KEY });
                await trackPromise(
                    this.props.actions.sessionIdVerification(obj).then(
                        response => {
                            if (response.requestStatus === undefined) {
                                localStorage.setItem("token", response.token);
                                // if( response.customer !== null ) {
                                //     this.setState({verificationBox : true});
                                //     this.setState({ customerInfo: response });
                                //     this.setState({
                                //         thirdPartySessionLink: true, cartId: response.data.cartId, sessionId: response.sessionId, isAutoPayRequired: response.data.isAutoPay
                                //     });
                                // }
                                // else {
                                this.updateState("txtFirstName", (response.data.firstname === null ? "" : response.data.firstname));
                                this.updateState("txtMiddleName", (response.data.middleName === null ? "" : response.data.middleName));
                                this.updateState("txtLastName", (response.data.lastName === null ? "" : response.data.lastName));
                                this.updateState("txtMailingAdr", (response.data.address === null ? "" : response.data.address));
                                this.updateState("txtEmailAdr", (response.data.emailAddress === null ? "" : response.data.emailAddress));
                                this.updateState("txtAptUnit", (response.data.apt === null ? "" : response.data.apt));
                                this.updateState("txtCity", (response.data.city === null ? "" : response.data.city));
                                this.updateState("txtMobileNo", (response.data.mobileNumber === null ? "" : response.data.mobileNumber));
                                this.updateState("txtZipCode", (response.data.zipcode === null ? "" : response.data.zipcode));
                                this.setState({
                                    formObj: {
                                        ...this.state.formObj,
                                        state: response.data.state?.trim(),
                                    }, thirdPartySessionLink: true, cartId: response.data.cartId, sessionId: response.sessionId, isAutoPayRequired: response.data.isAutoPay
                                });
                                this.loadAllAddresses(this.state.formObj.mailingAdr);
                                // }
                                sessionStorage.setItem("isNewApplication", "true");
                                if (sessionStorage.getItem("isNewApplication") === "true") {
                                    localStorage.setItem("applicationId", null);
                                    localStorage.setItem("magixassociateId", null);
                                }
                                sessionStorage.setItem("thirdPartyLink", "true");
                                //this.props.actions.loadAutoPay().then(
                                //    response => {
                                //        if (response) {
                                //            this.setState({ isIframeError: false, isIframeErrorMsg: '' });
                                //            this.setState({ iframeUrl: response.iframeUrl });
                                //            this.setState({ custIdEnt: response.custIdEnt });
                                //        }

                                //    }
                                //)
                                if (response.data.cartId.length > 0 && response.data.cartId !== "0") {
                                    if (response.data.isAutoPay) {
                                        this.setState({ autoPay: true });
                                    }
                                }
                                this.setState({ thirdPartyLink: true, synchronyCredit: false, progressiveLeasing: false, UOwnLeasing: false, fortivaCredit: false, danielsCredit: true });
                                this.updateDropDowns();
                                this.loadAutoPay();
                            }
                            else
                                this.setState({ sessionIdVerificationRes: true });
                        }).catch(err => {
                            APIFailedMessage.displayError(err);
                        })
                );
                await this.props.actions.getIpAddressNew().then(
                    res => {
                        sessionStorage.setItem("ipAddress", res);
                    }).catch(err => {
                        APIFailedMessage.displayError(err);
                    }
                    )
            }
            //logout and continue
            else {
                const CryptoJS = require('crypto-js');
                var url = window.location.href.split('now?')[1];
                this.setState({ siteKey: window.env.KEYS_SITE_KEY });
                let securityKey = window.env.KEYS_SECURITY_KEY;
                url = CryptoJS.AES.decrypt(url, securityKey).toString(CryptoJS.enc.Utf8);
                if (url.slice(0, 14) === "associateEmail") {
                    var decryptedBytes = url.split("Email=")[1].split("&token=")[0];
                    localStorage.setItem('loggedUserEmail', decryptedBytes);
                    localStorage.setItem('token', url.split("token=")[1].split("&type=")[0]);
                    var decryptedType = url.split("type=")[1].split("&")[0];
                    var decryptedCus_Id = url.split("customerId=")[1];
                    var decryptedMag_Id = url.split("accountId=")[1];
                    let searchFilter = {
                        Filter1_AssociateEmail: decryptedBytes,
                        Filter2_AssociateObject: " ",
                    }
                    let districtList = {};
                    let distrobj = [];
                    await trackPromise(
                        this.props.actionStore.getStoreDetails(searchFilter).then(
                            response => {
                                if (response.stores.data.length > 0) {
                                    localStorage.setItem('hasAdminAccess', JSON.stringify(response.hasAdminAccess));
                                    localStorage.setItem('hasPortalAccess', JSON.stringify(response.hasPortalAccess));
                                    localStorage.setItem('role_name', response.roleName);
                                    this.setState({ associateStoreId: JSON.stringify(response.stores.data[0].code) });
                                }
                            }
                        )
                    )
                    await trackPromise(
                        this.props.userRightsactions.getUserRights().then(
                            response => {
                                if (response) {
                                    this.setState({
                                        roles: response.roles,
                                        site_page_details: response.sitePageDetails,
                                        sitePages: response.sitePages,
                                        userRights: response.userRights
                                    });
                                    this.getPermissions()
                                }
                            }).catch(err => {
                                APIFailedMessage.displayError(err);
                            }),
                        this.props.actions.getPopUpMessage("ApplyNow").then(res => {
                            if (res) {
                                res.map(item => {
                                    return item.description = item.description?.replaceAll("*^*", "'");
                                })
                                this.setState({ alterPopupmessage: res });
                            }
                        }).catch(err => {
                            APIFailedMessage.displayError(err);
                        })
                    )
                    await trackPromise(
                        this.props.userListactions.getDistricts().then(
                            response => {
                                if (response) {
                                    districtList = response.data;
                                }
                            }
                        ).catch(err => {
                            APIFailedMessage.displayError(err);
                        })
                    );
                    await trackPromise(
                        this.props.userListactions.getUser(localStorage.getItem("loggedUserEmail")).then(
                            response => {
                                if (response) {
                                    let associatedistrict = response.district?.toLowerCase()?.split(",");
                                    distrobj = districtList?.filter(item => { return associatedistrict?.includes(item.name.toLowerCase()) });
                                    distrobj = distrobj?.map((val) => { return val.id });
                                    this.updateState("txtAssociateEmployeeNo", response.associateEmpNo);
                                }
                            }
                        ).catch(err => {
                            APIFailedMessage.displayError(err);
                        })
                    )
                    if (distrobj) {
                        await this.props.userListactions.getStoresByMultipleDistrictId(distrobj).then(
                            response => {
                                if (response) {
                                    sessionStorage.setItem("storeList", JSON.stringify(response.data));
                                    this.setState({
                                        storesList: response.data,
                                        formObj: { ...this.state.formObj, lstStoreCode: JSON.parse(sessionStorage.getItem("storeList")) },
                                    });
                                    this.updateState("cmbStoreCode", JSON.parse(localStorage.getItem("associateStores")));
                                }
                            }
                        ).catch(err => {
                            APIFailedMessage.displayError(err);
                        })
                    }
                    this.setState({ thirdPartyLink: false });
                    await this.props.actions.getIpAddressNew().then(
                        res => {
                            sessionStorage.setItem("ipAddress", res);
                        }).catch(err => {
                            APIFailedMessage.displayError(err);
                        }
                        )
                    sessionStorage.setItem("thirdPartyLink", false);
                    sessionStorage.setItem("logout/continue", true);
                    this.updateDropDowns();
                    this.loadAdminSettings();
                    sessionStorage.setItem("isNewApplication", "true");
                    if (decryptedCus_Id) {
                        localStorage.setItem("applicationId", decryptedCus_Id);
                        localStorage.setItem("customerId", "");
                        sessionStorage.setItem("isNewApplication", "false");
                        this.loadCustomer();
                    }
                    else if (decryptedMag_Id) {
                        localStorage.setItem("customerId", decryptedMag_Id);
                        localStorage.setItem("applicationId", null);
                        sessionStorage.setItem("isNewApplication", "false");
                        this.loadCustomer();
                    }
                    this.loadAutoPay();
                }
                else {
                    sessionStorage.clear();
                    this.props.history.push("/");
                }
            }
        }
        else {
            sessionStorage.clear();
            this.props.history.push("/");
        }
    }
    componentWillUnmount() {
        localStorage.removeItem("fortivaAPIErrorMsg");
        sessionStorage.removeItem("progUownApplications");
    }

    getPermissions() {
        let role_name = localStorage.getItem('role_name'), page_name = 'Add-On/Re-Open/Apply'
        const getsitepages = this.state.sitePages.filter((site_pages) => { return site_pages.name === 'Portal Page' })
        const getSitepagedetails = this.state.site_page_details.filter((site_page_details) => { return site_page_details.sitePage_id === getsitepages[0].id && (site_page_details.name === page_name) })
        const getRole = this.state.roles.filter((roles) => { return roles.name.toLowerCase() === role_name.toLowerCase() });
        let role_id = getRole[0].id;
        const role_permission_check = this.state.userRights.filter((user_rights) => { return user_rights.sitePageDetail_id === getSitepagedetails[0].id && user_rights.role_id === role_id });
        this.setState({ permission_status: role_permission_check[0] })
    }

    loadAutoPay() {
        if (sessionStorage.getItem("isNewApplication") === "true") {
            trackPromise(
                this.props.actions.loadAutoPay().then(
                    response => {
                        if (response) {
                            this.setState({ isIframeError: false, isIframeErrorMsg: '' });
                            this.setState({ iframeUrl: response.iframeUrl });
                            this.setState({ custIdEnt: response.custIdEnt });
                        }

                    }
                ).catch(err => {
                    APIFailedMessage.displayError(err);
                })
            )
        }
    }

    loadCustomer() {
        if (localStorage.getItem("applicationId") !== "null" && localStorage.getItem("applicationId") !== "0" && localStorage.getItem("applicationId") !== "") {
            let obj = localStorage.getItem("applicationId");
            if (parseInt(obj) > 0) {
                trackPromise(
                    this.props.customerDetailsActions.getApplicationDetails(obj).then(
                        response => {
                            this.setState({ customerInfo: response[0] });
                            this.setState({ formObj: { ...this.state.formObj, applicationId: response[0].application_id } });
                            this.updateState("frKeyCredit_Id", response[0].LastDraftCreditId);
                            this.updateState("cmbSuffix", (response[0].suffix_Id === null ? "0" : response[0].suffix_Id));
                            this.updateState("txtCustomerNo", response[0].customer_Id);
                            this.updateState("txtFirstName", (response[0].firstName === null ? "" : response[0].firstName));
                            this.updateState("txtMiddleName", (response[0].middleName === null ? "" : response[0].middleName));
                            this.updateState("txtLastName", (response[0].lastName === null ? "" : response[0].lastName));
                            this.updateState("txtMailingAdr", (response[0].address === null ? "" : response[0].address));
                            this.updateState("txtEmailAdr", (response[0].emailAddress === null ? "" : response[0].emailAddress));
                            this.updateState("txtAptUnit", (response[0].apt === null ? "" : response[0].apt));
                            this.updateState("txtCity", (response[0].city === null ? "" : response[0].city));
                            this.setState({
                                formObj: { ...this.state.formObj, dob: (response[0].birthDate === null ? "" : Moment(response[0].birthDate).format("MM/DD/YYYY")) },
                            });
                            this.loadAllAddresses(this.state.formObj.mailingAdr);
                            this.setState({ formObj: { ...this.state.formObj, account: response[0].customer_Id } });
                            this.updateState("txtMobileNo", (response[0].mobileNo === null ? "" : response[0].mobileNo));
                            this.setState({ previousMobileNo: response[0].mobileNo === null ? "" : response[0].mobileNo });
                            if (response[0].state_Id) {
                                let state = this.state.limitedState?.find((val) => val.id === response[0].state_Id);
                                if (state) {
                                    state = this.state.formObj.lstState?.find((val) => { if (val.description?.toLowerCase() === state.description?.toLowerCase(0)) { return val.id } });
                                    this.updateState("cmbState", (state?.id === null || state?.id === undefined ? "0" : state?.id));
                                }
                                else {
                                    this.updateState("cmbState", (response[0].state_Id === null ? "0" : response[0].state_Id));
                                }
                            }
                            this.updateState("txtSecPhone", (response[0].secondaryPhone === null ? "" : response[0].secondaryPhone));
                            this.updateState("txtZipCode", (response[0].zipCode === null ? "" : response[0].zipCode));
                            this.updateState("txtEmpName", (response[0].empName === null ? "" : response[0].empName));
                            this.updateState("txtEmpPhoneNo", (response[0].empPhone === null ? "" : response[0].empPhone));
                            this.updateState("txtNetIncome", (response[0].monthlyIncome === null ? "" : response[0].monthlyIncome));
                            this.updateState("txtDuties", (response[0].workJob === null ? "" : response[0].workJob));
                            this.setState({
                                formObj: { ...this.state.formObj, empStartDate: (response[0].howLong === null ? "" : Moment(response[0].howLong).format("MM/YYYY")) },
                            });
                            this.updateState("cmbHousingInfo", (response[0].housingInfo_Id === null ? "0" : response[0].housingInfo_Id));
                            this.updateState("txtSSN", (response[0].ssn === null ? "" : response[0].ssn));
                            this.updateState("cmbPrimaryIdType", (response[0].primaryType_Id === null ? "0" : response[0].primaryType_Id));
                            this.updateState("txtPrimaryIdNo", (response[0].idNumber === null ? "" : response[0].idNumber));
                            this.updateState("cmbPrimaryIdState", (response[0].primaryState_Id === null ? "0" : response[0].primaryState_Id));
                            this.updateState("txtRelativeName", (response[0].relativeName === null ? "" : response[0].relativeName));
                            this.updateState("txtRelativePhone", (response[0].relativePhone === null ? "" : response[0].relativePhone));
                            this.updateState("txtRelativeRelation", (response[0].relativeRelationship === null ? "" : response[0].relativeRelationship));
                            this.setState({
                                formObj: { ...this.state.formObj, primaryIdExpiryDate: (response[0].primaryIdExpDate === null ? "" : Moment(response[0].primaryIdExpDate).format("MM/YYYY")) },
                            });
                            this.updateState("cmbSecondIdType", (response[0].secondIdType_Id === null ? "0" : response[0].secondIdType_Id));
                            this.updateState("txtSecondIdIssuedBy", (response[0].secondIdIssuedBy_Id === null ? "" : response[0].secondIdIssuedBy_Id));
                            this.setState({
                                formObj: { ...this.state.formObj, secondIdExpiryDate: (response[0].secondIdExpDate === null ? "" : Moment(response[0].secondIdExpDate).format("MM/YYYY")) },
                            });
                            this.updateState("cmbOftenPaid", (response[0].howOftenPaid_Id === null ? "0" : response[0].howOftenPaid_Id));
                            this.setState({
                                formObj: { ...this.state.formObj, lastPayDay: (response[0].lastPayDay === null ? "" : Moment(response[0].lastPayDay).format("MM/DD/YYYY")) },
                            });
                            this.setState({
                                formObj: { ...this.state.formObj, nextPayDay: (response[0].nextPayDay === null ? "" : Moment(response[0].nextPayDay).format("MM/DD/YYYY")) },
                            });

                            this.updateState("txtBankRouteNo", (response[0].bankRoutingNo === null ? "" : response[0].bankRoutingNo));
                            this.updateState("txtCheckAccNo", (response[0].checkingAccountNo === null ? "" : response[0].checkingAccountNo));
                            this.updateState("txtCC", (response[0].creditCardBin === null ? "" : response[0].creditCardBin));
                            this.setState({
                                formObj: { ...this.state.formObj, ccExpiryDate: (response[0].creditCardExpDate === null ? "" : Moment(response[0].creditCardExpDate).format("MM/YYYY")) },
                            });
                            this.updateState("txtCCName", (response[0].nameOnCreditCard === null ? "" : response[0].nameOnCreditCard));

                            this.setState({
                                formObj: { ...this.state.formObj, creditCardBillingAddress: response[0].creditCardHomeAddress },
                            });

                            this.updateState("txtCCMailingAdr", (response[0].ccAddress === null ? "" : response[0].ccAddress));
                            this.updateState("txtCCAptUnit", (response[0].ccApt === null ? "" : response[0].ccApt));
                            this.updateState("txtCCCity", (response[0].ccCity === null ? "" : response[0].ccCity));
                            this.updateState("cmbCCState", (response[0].ccState_Id === null ? "0" : response[0].ccState_Id));
                            this.updateState("txtCCZipCode", (response[0].ccZipCode === null ? "" : response[0].ccZipCode));

                            this.setState({ isIframeError: false, isIframeErrorMsg: '' });
                            this.setState({ iframeUrl: response[0].infinityAutoPayResponse.iframeUrl });
                            this.setState({ custIdEnt: response[0].infinityAutoPayResponse.custIdEnt });
                            //   //track water fall check
                            // let progUownApplications=JSON.parse(sessionStorage.getItem("progUownApplications"));
                            // if(progUownApplications){
                            //     if(progUownApplications==true){
                            //         this.trackWaterfall(response[0].application_id);

                            //     }
                            // }
                            //this.loadMultipleMagixAccountID(response[0])
                        }
                    ).catch(err => {
                        APIFailedMessage.displayError(err);
                    })
                )
            }
        }
        else {
            let obj = localStorage.getItem("customerId");
            if (parseInt(obj) > 0 && localStorage.getItem('apply_now') === 'true') {
                trackPromise(
                    this.props.customerDetailsActions.getCustomerDetails_new(obj).then(
                        response => {
                            if (response) {
                                for (const item in response[0]) {
                                    if (response[0][item] === "(null)") {
                                        response[0][item] = null;
                                    }
                                }
                                this.setState({ customerInfo: response[0] });
                                this.setState({ formObj: { ...this.state.formObj, applicationId: response[0].application_id } });
                                this.updateState("frKeyCredit_Id", response[0].LastDraftCreditId);
                                this.updateState("cmbSuffix", (response[0].suffix_Id === null ? "0" : response[0].suffix_Id));
                                this.updateState("txtCustomerNo", response[0].customer_Id);
                                this.updateState("txtFirstName", (response[0].firstName === null ? "" : response[0].firstName));
                                this.updateState("txtMiddleName", (response[0].middleName === null ? "" : response[0].middleName));
                                this.updateState("txtLastName", (response[0].lastName === null ? "" : response[0].lastName));
                                this.updateState("txtMailingAdr", (response[0].address === null ? "" : response[0].address));
                                this.updateState("txtEmailAdr", (response[0].emailAddress === null ? "" : response[0].emailAddress));
                                this.updateState("txtAptUnit", (response[0].apt === null ? "" : response[0].apt));
                                this.updateState("txtCity", (response[0].city === null ? "" : response[0].city));
                                this.setState({
                                    formObj: { ...this.state.formObj, dob: (response[0].birthDate === null ? "" : Moment(response[0].birthDate).format("MM/DD/YYYY")) },
                                });
                                this.loadAllAddresses(this.state.formObj.mailingAdr);
                                this.setState({ formObj: { ...this.state.formObj, account: response[0].customer_Id } });
                                this.updateState("txtMobileNo", (response[0].mobileNo === null ? "" : response[0].mobileNo));
                                this.setState({ previousMobileNo: response[0].mobileNo === null ? "" : response[0].mobileNo });
                                if (response[0].state_Id) {
                                    let state = this.state.limitedState?.find((val) => val.id === response[0].state_Id);
                                    if (state) {
                                        state = this.state.formObj.lstState?.find((val) => { if (val.description?.toLowerCase() === state.description?.toLowerCase(0)) { return val.id } });
                                        this.updateState("cmbState", (state?.id === null || state?.id === undefined ? "0" : state?.id));
                                    }
                                    else {
                                        this.updateState("cmbState", (response[0].state_Id === null ? "0" : response[0].state_Id));
                                    }
                                }
                                this.updateState("txtSecPhone", (response[0].secondaryPhone === null ? "" : response[0].secondaryPhone));
                                this.updateState("txtZipCode", (response[0].zipCode === null ? "" : response[0].zipCode));
                                this.updateState("txtEmpName", (response[0].empName === null ? "" : response[0].empName));
                                this.updateState("txtEmpPhoneNo", (response[0].empPhone === null ? "" : response[0].empPhone));
                                this.updateState("txtNetIncome", (response[0].monthlyIncome === null ? "" : response[0].monthlyIncome));
                                this.updateState("txtDuties", (response[0].workJob === null ? "" : response[0].workJob));
                                this.setState({
                                    formObj: { ...this.state.formObj, empStartDate: (response[0].howLong === null ? "" : Moment(response[0].howLong).format("MM/YYYY")) },
                                });
                                this.updateState("cmbHousingInfo", (response[0].housingInfo_Id === null ? "0" : response[0].housingInfo_Id));
                                this.updateState("txtSSN", (response[0].ssn === null ? "" : response[0].ssn));
                                this.updateState("cmbPrimaryIdType", (response[0].primaryType_Id === null ? "0" : response[0].primaryType_Id));
                                this.updateState("txtPrimaryIdNo", (response[0].idNumber === null ? "" : response[0].idNumber));
                                this.updateState("cmbPrimaryIdState", (response[0].primaryState_Id === null ? "0" : response[0].primaryState_Id));
                                this.updateState("txtRelativeName", (response[0].relativeName === null ? "" : response[0].relativeName));
                                this.updateState("txtRelativePhone", (response[0].relativePhone === null ? "" : response[0].relativePhone));
                                this.updateState("txtRelativeRelation", (response[0].relativeRelationship === null ? "" : response[0].relativeRelationship));
                                this.setState({
                                    formObj: { ...this.state.formObj, primaryIdExpiryDate: (response[0].primaryIdExpDate === null ? "" : Moment(response[0].primaryIdExpDate).format("MM/YYYY")) },
                                });
                                this.updateState("cmbSecondIdType", (response[0].secondIdType_Id === null ? "0" : response[0].secondIdType_Id));
                                this.updateState("txtSecondIdIssuedBy", (response[0].secondIdIssuedBy_Id === null ? "" : response[0].secondIdIssuedBy_Id));
                                this.setState({
                                    formObj: { ...this.state.formObj, secondIdExpiryDate: (response[0].secondIdExpDate === null ? "" : Moment(response[0].secondIdExpDate).format("MM/YYYY")) },
                                });
                                this.updateState("cmbOftenPaid", (response[0].howOftenPaid_Id === null ? "0" : response[0].howOftenPaid_Id));
                                this.setState({
                                    formObj: { ...this.state.formObj, lastPayDay: (response[0].lastPayDay === null ? "" : Moment(response[0].lastPayDay).format("MM/DD/YYYY")) },
                                });
                                this.setState({
                                    formObj: { ...this.state.formObj, nextPayDay: (response[0].nextPayDay === null ? "" : Moment(response[0].nextPayDay).format("MM/DD/YYYY")) },
                                });

                                this.updateState("txtBankRouteNo", (response[0].bankRoutingNo === null ? "" : response[0].bankRoutingNo));
                                this.updateState("txtCheckAccNo", (response[0].checkingAccountNo === null ? "" : response[0].checkingAccountNo));
                                this.updateState("txtCC", (response[0].creditCardBin === null ? "" : response[0].creditCardBin));
                                this.setState({
                                    formObj: { ...this.state.formObj, ccExpiryDate: (response[0].creditCardExpDate === null ? "" : Moment(response[0].creditCardExpDate).format("MM/YYYY")) },
                                });
                                this.updateState("txtCCName", (response[0].nameOnCreditCard === null ? "" : response[0].nameOnCreditCard));

                                this.setState({
                                    formObj: { ...this.state.formObj, creditCardBillingAddress: response[0].creditCardHomeAddress },
                                });

                                this.updateState("txtCCMailingAdr", (response[0].ccAddress === null ? "" : response[0].ccAddress));
                                this.updateState("txtCCAptUnit", (response[0].ccApt === null ? "" : response[0].ccApt));
                                this.updateState("txtCCCity", (response[0].ccCity === null ? "" : response[0].ccCity));
                                this.updateState("cmbCCState", (response[0].ccState_Id === null ? "0" : response[0].ccState_Id));
                                this.updateState("txtCCZipCode", (response[0].ccZipCode === null ? "" : response[0].ccZipCode));

                                this.setState({ isIframeError: false, isIframeErrorMsg: '' });
                                this.setState({ iframeUrl: response[0].infinityAutoPayResponse.iframeUrl });
                                this.setState({ custIdEnt: response[0].infinityAutoPayResponse.custIdEnt });
                                //this.loadMultipleMagixAccountID(response[0])
                            }
                        }
                    )
                )
                    .catch(err => {
                        APIFailedMessage.displayError(err);
                    })
            }
            // let obj = {associateId:localStorage.getItem("magixassociateId"),storecode: localStorage.getItem('storeCode')};
            // if (localStorage.getItem('apply_now') === 'true') {
            //     trackPromise(
            //         this.props.customerDetailsActions.getMagixCustomerDetails(obj).then(
            //             response => {
            //                 this.setState({ customerInfo: response[0] });
            //                 this.updateState("frKeyCredit_Id", response[0].LastDraftCreditId);
            //                 this.updateState("cmbSuffix", (response[0].suffix_Id === null ? "0" : response[0].suffix_Id));
            //                 this.updateState("txtCustomerNo", response[0].id);
            //                 this.updateState("txtFirstName", (response[0].firstName === null ? "" : response[0].firstName));
            //                 this.updateState("txtMiddleName", (response[0].middleName === null ? "" : response[0].middleName));
            //                 this.updateState("txtLastName", (response[0].lastName === null ? "" : response[0].lastName));
            //                 this.updateState("txtMailingAdr", (response[0].address === null ? "" : response[0].address));
            //                 this.updateState("txtEmailAdr", (response[0].emailAddress === null ? "" : response[0].emailAddress));
            //                 this.updateState("txtAptUnit", (response[0].apt === null ? "" : response[0].apt));
            //                 this.updateState("txtCity", (response[0].city === null ? "" : response[0].city));
            //                 this.setState({
            //                     formObj: { ...this.state.formObj, dob: (response[0].birthDate === null ? "" : Moment(response[0].birthDate).format("MM/DD/YYYY")) },
            //                 });
            //                 this.updateState("txtMobileNo", (response[0].mobileNo === null ? "" : response[0].mobileNo));
            //                 this.updateState("cmbState", (response[0].state_Id === null ? "0" : response[0].state_Id));
            //                 this.updateState("txtSecPhone", (response[0].secondaryPhone === null ? "" : response[0].secondaryPhone));
            //                 this.updateState("txtZipCode", (response[0].zipCode === null ? "" : response[0].zipCode));
            //                 this.updateState("txtEmpName", (response[0].empName === null ? "" : response[0].empName));
            //                 this.updateState("txtEmpPhoneNo", (response[0].empPhone === null ? "" : response[0].empPhone));
            //                 this.updateState("txtNetIncome", (response[0].monthlyIncome === null ? "" : response[0].monthlyIncome));
            //                 this.updateState("txtDuties", (response[0].workJob === null ? "" : response[0].workJob));
            //                 this.setState({
            //                     formObj: { ...this.state.formObj, empStartDate: (response[0].howLong === null ? "" : Moment(response[0].howLong).format("MM/YYYY")) },
            //                 });
            //                 this.updateState("cmbHousingInfo", (response[0].housingInfo_Id === null ? "0" : response[0].housingInfo_Id));
            //                 this.updateState("txtSSN", (response[0].ssn === null ? "" : response[0].ssn));
            //                 this.updateState("cmbPrimaryIdType", (response[0].primaryType_Id === null ? "0" : response[0].primaryType_Id));
            //                 this.updateState("txtPrimaryIdNo", (response[0].idNumber === null ? "" : response[0].idNumber));
            //                 this.updateState("cmbPrimaryIdState", (response[0].primaryState_Id === null ? "0" : response[0].primaryState_Id));
            //                 this.updateState("txtRelativeName", (response[0].relativeName === null ? "" : response[0].relativeName));
            //                 this.updateState("txtRelativePhone", (response[0].relativePhone === null ? "" : response[0].relativePhone));
            //                 this.updateState("txtRelativeRelation", (response[0].relativeRelationship === null ? "" : response[0].relativeRelationship));
            //                 this.setState({
            //                     formObj: { ...this.state.formObj, primaryIdExpiryDate: (response[0].primaryIdExpDate === null ? "" : Moment(response[0].primaryIdExpDate).format("MM/YYYY")) },
            //                 });
            //                 this.updateState("cmbSecondIdType", (response[0].secondIdType_Id === null ? "0" : response[0].secondIdType_Id));
            //                 this.updateState("txtSecondIdIssuedBy", (response[0].secondIdIssuedBy_Id === null ? "" : response[0].secondIdIssuedBy_Id));
            //                 this.setState({
            //                     formObj: { ...this.state.formObj, secondIdExpiryDate: (response[0].secondIdExpDate === null ? "" : Moment(response[0].secondIdExpDate).format("MM/YYYY")) },
            //                 });
            //                 this.updateState("cmbOftenPaid", (response[0].howOftenPaid_Id === null ? "0" : response[0].howOftenPaid_Id));
            //                 this.setState({
            //                     formObj: { ...this.state.formObj, lastPayDay: (response[0].lastPayDay === null ? "" : Moment(response[0].lastPayDay).format("MM/DD/YYYY")) },
            //                 });
            //                 this.setState({
            //                     formObj: { ...this.state.formObj, nextPayDay: (response[0].nextPayDay === null ? "" : Moment(response[0].nextPayDay).format("MM/DD/YYYY")) },
            //                 });

            //                 this.updateState("txtBankRouteNo", (response[0].bankRoutingNo === null ? "" : response[0].bankRoutingNo));
            //                 this.updateState("txtCheckAccNo", (response[0].checkingAccountNo === null ? "" : response[0].checkingAccountNo));
            //                 this.updateState("txtCC", (response[0].creditCardBin === null ? "" : response[0].creditCardBin));
            //                 this.setState({
            //                     formObj: { ...this.state.formObj, ccExpiryDate: (response[0].creditCardExpDate === null ? "" : Moment(response[0].creditCardExpDate).format("MM/YYYY")) },
            //                 });
            //                 this.updateState("txtCCName", (response[0].nameOnCreditCard === null ? "" : response[0].nameOnCreditCard));

            //                 this.setState({
            //                     formObj: { ...this.state.formObj, creditCardBillingAddress: response[0].creditCardHomeAddress },
            //                 });

            //                 this.updateState("txtCCMailingAdr", (response[0].ccAddress === null ? "" : response[0].ccAddress));
            //                 this.updateState("txtCCAptUnit", (response[0].ccApt === null ? "" : response[0].ccApt));
            //                 this.updateState("txtCCCity", (response[0].ccCity === null ? "" : response[0].ccCity));
            //                 this.updateState("cmbCCState", (response[0].ccState_Id === null ? "0" : response[0].ccState_Id));
            //                 this.updateState("txtCCZipCode", (response[0].ccZipCode === null ? "" : response[0].ccZipCode));
            //             }
            //         ).catch(err => {
            //             APIFailedMessage.displayError(err);
            //         })
            //     )

            //     trackPromise(
            //         this.props.actions.loadAutoPay().then(
            //             response => {
            //                 if (response) {
            //                     this.setState({ isIframeError: false, isIframeErrorMsg: '' });
            //                     this.setState({ iframeUrl: response.iframeUrl });
            //                     this.setState({ custIdEnt: response.custIdEnt });
            //                 }

            //             }
            //         )
            //     )
            // } else if (localStorage.getItem('apply_now') === 'false' && parseInt(obj) > 0 && sessionStorage.getItem("isNewApplication") === "false") {
            //     window.location = '/view_offer'
            // }
        }
    }

    // loadMultipleMagixAccountID(res) {
    //     let obj={
    //         ssn:res?.ssn,
    //         dob:Moment(res?.birthDate).format("MM/DD/YYYY")
    //     }
    //         trackPromise(
    //         this.props.customerDetailsActions.getAllMagixAccountNumbers(obj).then(response => {
    //             if(response) {
    //                 if(response?.length > 0) {
    //                     response?.map((val) => {
    //                         if(val.firstChgDate)
    //                             val.firstChgDate=Moment(val.firstChgDate).format("MM/DD/YYYY");
    //                         if(val.lastChgDate)
    //                             val.lastChgDate=Moment(val.lastChgDate).format("MM/DD/YYYY");
    //                     });

    //                     this.setState({magixAcctList:response});
    //                     if(response?.length==1){
    //                         this.setState({selectedMagixAccount:response[0].magix_Id,selectedMagixStoreId:response[0].magixStoreCode});
    //                     }
    //                 }
    //             }
    //         }));
    // }

    trackChanges() {
        if (this.state.danielsCredit && sessionStorage.getItem("addOn") == "true") {
            let customerInfo = this.state.customerInfo;
            let formObj = this.state.formObj;
            //Tracking daniels field only
            if (customerInfo?.mobileNo?.replace(/-/g, "") != formObj?.mobileNo?.replace(/-/g, "") ||
                customerInfo?.address?.toLowerCase() != formObj?.mailingAdr?.toLowerCase() ||
                customerInfo?.apt?.toLowerCase() != formObj?.aptUnit?.toLowerCase() ||
                customerInfo?.city?.toLowerCase() != formObj?.city?.toLowerCase() ||
                customerInfo?.state_Id != formObj?.state ||
                customerInfo?.zipCode != formObj?.zipCode ||
                customerInfo?.housingInfo_Id != formObj?.housingInfo ||
                customerInfo?.emailAddress?.toLowerCase() != formObj?.emailAdr?.toLowerCase() ||
                customerInfo?.empName?.toLowerCase() != formObj?.empName?.toLowerCase() ||
                customerInfo?.workJob?.toLowerCase() != formObj?.duties?.toLowerCase() ||
                Moment(customerInfo?.howLong).format("MM/YYYY") != formObj?.empStartDate ||
                customerInfo?.empPhone?.replace(/-/g, "") != formObj?.empPhoneNo?.replace(/-/g, "") ||
                customerInfo?.monthlyIncome != formObj?.netIncome ||
                customerInfo?.primaryType_Id != formObj?.primaryIdType ||
                customerInfo?.idNumber?.toLowerCase() != formObj?.primaryIdNo?.toLowerCase() ||
                customerInfo?.primaryState_Id != formObj?.primaryIdState ||
                customerInfo?.relativeName?.toLowerCase() != formObj?.relativeName?.toLowerCase() ||
                customerInfo?.relativePhone?.replace(/-/g, "") != formObj?.relativePhone?.replace(/-/g, "") ||
                customerInfo?.relativeRelationship?.toLowerCase() != formObj?.relativeRelation?.toLowerCase()) {
                this.setState({ addOnWithChange: true, addOnwithOutchanges: false });
            }
            else {
                this.setState({ addOnWithChange: false, addOnwithOutchanges: true });
            }
        }
    }

    validateMobileVerification(mobileNo) {
        if (!this.state.thirdPartyLink) {
            if (mobileNo?.replaceAll('-', '')?.length === 10 && this.handleFormValidation("mobileNo")) {
                trackPromise(
                    this.props.actions.checkIsMobileVerifiedSameDay(mobileNo).then((res) => {
                        if (res === true) {
                            this.setState({
                                isMobileNoVerifiedOnSameDay: res,
                                isSMSError: false,
                                isSMSErrorMsg: '',
                                SMSCodeSent: true,
                            });
                        }
                        else {
                            this.setState({ isMobileNoVerifiedOnSameDay: false, SMSCodeSent: false });
                        }
                    }
                    ).catch((err) => APIFailedMessage.displayError(err))
                );
            }
        }
    }

    skipMobileVerification() {
        if (this.handleFormValidation("mobileNo")) {
            if (this.state.isMobileNoVerifiedOnSameDay === true) {
                this.setState({
                    isSMSError: false,
                    isSMSErrorMsg: '',
                    isSMSVerified: true,
                    step2: true,
                    isStep2Complete: true,
                    step3: true,
                    formObj: {
                        ...this.state.formObj, verificationCode: "000000"
                    },
                    isMobileNoVerifiedOnSameDay: false,
                }, () => {
                    document.getElementById("txtFirstName")?.focus();
                });
            }
        }
    }

    loadDropDowns(type) {
        let obj = {
            "type": type
        }
        trackPromise(
            this.props.actions.getCodeMaster(obj).then(
                response => {
                    if (response) {

                        if (type === "Suffix") {
                            this.setState({
                                formObj: { ...this.state.formObj, lstSuffix: response.data },
                            });
                        }
                        else if (type === "State_Credit") {
                            this.setState({ limitedState: response.data });
                            if ((sessionStorage.getItem("SMSLink") == "true") || (this.state.thirdPartySessionLink ? (this.state.cartId == "" || this.state.cartId == "0") : false)) {
                                let limitedState = ["georgia", "new york", "north carolina", "south carolina", "virginia", "ohio", "pennsylvania", "michigan"];
                                let data = response?.data?.filter((val) => { return !limitedState?.includes(val?.description?.toLowerCase()) });
                                this.setState({
                                    formObj: { ...this.state.formObj, lstState: data },
                                });
                                // if(this.state.formObj?.mailingAdr !== "") {
                                //     this.loadAddress(this.state.formObj?.mailingAdr);
                                //     this.autoFill(this.state.formObj?.mailingAdr);
                                // } else {
                                //     this.loadAddress('10');
                                // }
                            }
                            else if (this.state.thirdPartySessionLink) {
                                this.setState({
                                    formObj: { ...this.state.formObj, lstState: response.data },
                                });
                                // if(this.state.formObj?.mailingAdr !== "") {
                                //     this.loadAddress(this.state.formObj?.mailingAdr);
                                //     this.autoFill(this.state.formObj?.mailingAdr);
                                // } else {
                                //     this.loadAddress('10');
                                // }
                            }
                        }
                        else if (type === "HousingInfo") {
                            this.setState({
                                formObj: { ...this.state.formObj, lstHousingInfo: response.data },
                            });
                        }
                        else if (type === "PrimaryIdType") {
                            this.setState({
                                formObj: { ...this.state.formObj, lstPrimaryIdType: response.data },
                            });
                        }
                        else if (type === "State") {
                            this.setState({
                                formObj: { ...this.state.formObj, lstPrimaryIdState: response.data },
                            });
                            if (!JSON.parse(sessionStorage.getItem("thirdPartyLink"))) {
                                this.setState({
                                    formObj: { ...this.state.formObj, lstState: response.data },
                                });
                            }
                            this.setState({
                                formObj: { ...this.state.formObj, lstCCState: response.data },
                            });
                        }
                        else if (type === "OftenPaid") {
                            this.setState({
                                formObj: { ...this.state.formObj, lstOftenPaid: response.data },
                            });
                        }
                        else if (type === "PrimarySourceIncome") {
                            this.setState({
                                formObj: { ...this.state.formObj, lstPrimarySourceIncome: response.data },
                            });
                        }
                        else if (type === "BankAccountDuration") {
                            this.setState({
                                formObj: { ...this.state.formObj, lstBankAccountDuration: response.data },
                            });
                        }
                        else if (type === "SecondIdType") {
                            this.setState({
                                formObj: { ...this.state.formObj, lstSecondIdType: response.data },
                            });
                        }
                    }
                }
            ).catch(err => {
                APIFailedMessage.displayError(err);
            })
        )
    }
    onElectronicDisclosure = (event) => {
        event.preventDefault();
        //electronic disclosures
        let electronicConsentDisclosure = {
            documentCode: "8",
            fortivaDocResponse: "",
            applicationId: 0,
            isSubmitApp: true
        };
        trackPromise(
            this.props.actions.fortivaDisclosures(electronicConsentDisclosure)
                .then((res) => {
                    this.setState({ fortivaElectronicDisMsg: res.documentsImageHtml, isElectronicDisclosure: !this.state.isElectronicDisclosure });
                })
                .catch((err) => {
                    APIFailedMessage.displayError(err);
                })
        )

    }

    onApplicationDis = (event) => {
        event.preventDefault();
        //this.setState({isApplicationDisclosure:!this.state.isApplicationDisclosure});
        //fortiva application disclosures
        let applicationDisclosure = {
            documentCode: "9",
            fortivaDocResponse: "",
            applicationId: 0,
            isSubmitApp: true
        };
        trackPromise(
            this.props.actions.fortivaDisclosures(applicationDisclosure)
                .then((res) => {
                    this.setState({ fortivaDisMsg: res.documentsImageHtml, isApplicationDisclosure: !this.state.isApplicationDisclosure });
                })
                .catch((err) => {
                    APIFailedMessage.displayError(err);
                })
        )
    }
    handleDuplicateCust = (event) => {
        event.preventDefault();
        if (this.state.duplicateCustData.existing_Customer === false && this.state.magixDuplicateCustData?.data?.length > 0) {
            this.setState({ isDuplicateCustomer: !this.state.isDuplicateCustomer, isMagixDuplicateCustomer: !this.state.isMagixDuplicateCustomer });
        }
        else {
            this.setState({ isDuplicateCustomer: !this.state.isDuplicateCustomer });
            sessionStorage.setItem("fromInstoreDuplicatePopup", true);
            if (sessionStorage.getItem("logout/continue") != "true")
                this.redirectCustomerDetail();
            else
                this.userReLogin("redirectToCustDetils");
        }
    }
    redirectCustomerDetail() {
        let customerId = this.state.duplicateCustData.customer_id;
        localStorage.setItem("customerId", customerId);
        localStorage.setItem('selectedCustomer', customerId);
        let selectedUserName = "";
        if (this.state.duplicateCustData.firstName) {
            selectedUserName = this.state.duplicateCustData.firstName;
        }
        if (this.state.duplicateCustData.middleName) {
            selectedUserName = selectedUserName + " " + this.state.duplicateCustData.middleName;
        }
        if (this.state.duplicateCustData.lastName) {
            selectedUserName = selectedUserName + " " + this.state.duplicateCustData.lastName;
        }
        localStorage.setItem('selectedUserName', selectedUserName);
        sessionStorage.setItem("isNewApplication", "false");
        this.props.history.push(`/customer-details/${customerId}`);
    }

    handleDuplicateMagixCust = (customerId) => {
        this.setState({ isMagixDuplicateCustomer: !this.state.isMagixDuplicateCustomer });
        if (sessionStorage.getItem("logout/continue") != "true")
            this.redirectMagixToCustomerDetail(customerId);
        else
            this.userReLogin("redirectToCustDetils");
    }
    redirectMagixToCustomerDetail(customerId) {
        localStorage.setItem("customerId", customerId);
        localStorage.setItem('selectedCustomer', customerId);
        let selectedUserName = "";
        if (this.state.selectedDuplicateMagixRecord.firstName) {
            selectedUserName = this.state.selectedDuplicateMagixRecord.firstName;
        }
        if (this.state.selectedDuplicateMagixRecord.middleName) {
            selectedUserName = selectedUserName + " " + this.state.selectedDuplicateMagixRecord.middleName;
        }
        if (this.state.selectedDuplicateMagixRecord.lastName) {
            selectedUserName = selectedUserName + " " + this.state.selectedDuplicateMagixRecord.lastName;
        }
        localStorage.setItem('selectedUserName', selectedUserName);
        sessionStorage.setItem("isNewApplication", "false");
        sessionStorage.setItem("createdDate", "");
        sessionStorage.setItem("selectedUserPhone", this.state.selectedDuplicateMagixRecord?.mobileNo == null ? "" : this.state.selectedDuplicateMagixRecord?.mobileNo);
        sessionStorage.setItem("selectedUserEmail", this.state.selectedDuplicateMagixRecord?.emailAddress == null ? "" : this.state.selectedDuplicateMagixRecord?.emailAddress);
        this.props.history.push(`/customer-details/${customerId}`);
    }

    handleDuplicateCustCancel = (event) => {
        event.preventDefault();
        this.setState({ isDuplicateCustomer: false, isMagixDuplicateCustomer: false });
        if (sessionStorage.getItem("logout/continue") != "true")
            this.redirectCustomerLookup();
        else
            this.userReLogin("redirectToCustLookUp");
    }
    redirectCustomerLookup() {
        sessionStorage.setItem("isNewApplication", "false");
        this.props.history.push("/customer-lookup");
    }

    async userReLogin(redirect) {
        let searchFilter = {
            Filter1_AssociateEmail: localStorage.getItem('loggedUserEmail'),
            Filter2_AssociateObject: localStorage.getItem('loggedUserObjectId')
        }
        await trackPromise(
            this.props.actionStore.getStoreDetails(searchFilter).then(
                response => {
                    if (response.status.toLowerCase() === "active") {
                        localStorage.removeItem("loggedUserObjectId");
                        let access = response.portalAccessAllowed?.split(",");
                        let url = window.location.href.split("-")[1];
                        let statingURL = window.location.href.split('/')[2];
                        let productionURL = window.location.href.split('/')[2];
                        let localhost = window.location.href.slice(7, 16);
                        let prodEnvAccess = access?.find((val) => { return val.toLowerCase() === "prod" });
                        let stageEnvAccess = access?.find((val) => { return val.toLowerCase() === "stage" });
                        access = access?.filter((val) => { return val.toLowerCase() === url?.toLowerCase() });
                        if ((access.length > 0 && access !== undefined) || (localhost === "localhost") ||
                            (prodEnvAccess === "Prod" && productionURL === "storeportal.danielsjewelers.com") ||
                            (stageEnvAccess === "Stage" && statingURL === "storeportalstaging.danielsjewelers.com")) {
                            if (response.stores.data.length > 0) {
                                if (!this.state.isAssociateStore_IP) {
                                    localStorage.setItem('associateStores', JSON.stringify(response.stores.data[0].code));
                                }
                                localStorage.setItem('hasAdminAccess', JSON.stringify(response.hasAdminAccess));
                                localStorage.setItem('hasPortalAccess', JSON.stringify(response.hasPortalAccess));
                                localStorage.setItem('role_name', response.roleName);
                                sessionStorage.setItem('isLoggedIn', true);
                                localStorage.setItem("token", response.token);
                            }
                            else {
                                this.setState({ noStoreAssign: true });
                            }
                        }
                        else {
                            this.setState({ accessModal: true });
                        }
                    }
                    else {
                        this.setState({ userStatus: true });
                    }
                }
            )
        )
        if (!this.state.noStoreAssign && !this.state.accessModal && !this.state.userStatus) {
            await trackPromise(
                this.props.adminActions.getSignOutTime()
                    .then(res => {
                        if (res) {
                            localStorage.setItem("signOutInMins", res.signOutInMins);
                        }
                    })
                    .catch(error => {
                        APIFailedMessage.displayError(error);
                    })
            )
        }
        if (redirect == "redirectToCustLookUp") {
            this.redirectCustomerLookup();
        }
        else {
            sessionStorage.setItem("fortivaOffer_Accepted", undefined);
            sessionStorage.setItem("updated_fortiva_response", null);
            localStorage.removeItem("fortivaAPIErrorMsg");
            let hasPortalAccess = localStorage.getItem("hasPortalAccess");
            hasPortalAccess = JSON.parse(hasPortalAccess);
            if (hasPortalAccess) {
                await trackPromise(
                    this.props.userRightsactions
                        .getUserRights()
                        .then((response) => {
                            if (response) {
                                this.setState({
                                    roles: response.roles,
                                    site_page_details: response.sitePageDetails,
                                    sitePages: response.sitePages,
                                    userRights: response.userRights,
                                });
                            }
                        })
                        .catch((err) => {
                            APIFailedMessage.displayError(err);
                        })
                );
                let role_name = localStorage.getItem("role_name");
                const getPageDetailsArray =
                    this.state.sitePages.length > 0
                        ? this.state.sitePages.map((data) => {
                            return this.state.site_page_details.filter((site_page_details) => {
                                return site_page_details.sitePage_id === data.id;
                            });
                        })
                        : [];
                let role_permissions = await Promise.all(getPageDetailsArray);
                const getSitepagedetails = [...role_permissions[0], ...role_permissions[1]];
                const getRole = this.state.roles.filter((roles) => {
                    return roles.name.toLowerCase() === role_name.toLowerCase();
                });
                let role_id = getRole[0].id;
                let permisson_roles = {
                    admin_settings: false,
                    user_list: false,
                    user_role: false,
                    user_rights: false,
                    customer_details: false,
                    account_summary: false,
                    account_summary_synchrony: false,
                    account_summary_progressive: false,
                    account_summary_uown: false,
                    account_summary_fortiva: false,
                    view_offer: false,
                    apply_now: false,
                    credit_application: false,
                    application_history: false,
                    transaction_history: false,
                    store_list: false,
                };
                const role_permissions_check_1 =
                    getSitepagedetails.length > 0 &&
                    getSitepagedetails.map((data) => {
                        const role_permission_check = this.state.userRights.filter(
                            (user_rights) => {
                                return (
                                    user_rights.sitePageDetail_id === data.id &&
                                    user_rights.role_id === role_id
                                );
                            }
                        );
                        if (data.name === "User List") {
                            permisson_roles.user_list = role_permission_check[0]?.canView;
                            sessionStorage.setItem(
                                "user_list_permission",
                                role_permission_check[0]?.canView
                            );
                        } else if (data.name === "User Role") {
                            permisson_roles.user_role = role_permission_check[0]?.canView;
                            sessionStorage.setItem(
                                "user_role_permission",
                                role_permission_check[0]?.canView
                            );
                        } else if (data.name === "User Rights") {
                            permisson_roles.user_rights = role_permission_check[0]?.canView;
                            sessionStorage.setItem(
                                "user_rights_permission",
                                role_permission_check[0]?.canView
                            );
                        } else if (data.name === "Admin Settings") {
                            permisson_roles.admin_settings = role_permission_check[0]?.canView;
                            sessionStorage.setItem(
                                "admin_settings_permission",
                                role_permission_check[0]?.canView
                            );
                        } else if (data.name === "Customer Details") {
                            permisson_roles.customer_details = role_permission_check[0]?.canView;
                            sessionStorage.setItem(
                                "customer_details_permission",
                                role_permission_check[0]?.canView
                            );
                        } else if (data.name === "Account Summary") {
                            permisson_roles.account_summary = role_permission_check[0]?.canView;
                            sessionStorage.setItem(
                                "account_summary_permission",
                                role_permission_check[0]?.canView
                            );
                        } else if (data.name === "View Offers") {
                            permisson_roles.view_offer = role_permission_check[0]?.canView;
                            sessionStorage.setItem(
                                "view_offer_permission",
                                role_permission_check[0]?.canView
                            );
                        } else if (data.name === "Add-On/Re-Open/Apply") {
                            localStorage.setItem("apply_now", role_permission_check[0]?.canView);
                            sessionStorage.setItem(
                                "apply_now_permission",
                                role_permission_check[0]?.canView
                            );
                            permisson_roles.apply_now = role_permission_check[0]?.canView;
                        } else if (data.name === "Credit Application") {
                            sessionStorage.setItem(
                                "user_creditApp_permission",
                                role_permission_check[0]?.canView
                            );
                            permisson_roles.credit_application =
                                role_permission_check[0]?.canView;
                        } else if (data.name === "Application History") {
                            sessionStorage.setItem(
                                "apphistory_permission",
                                role_permission_check[0]?.canView
                            );
                            permisson_roles.application_history =
                                role_permission_check[0]?.canView;
                        } else if (data.name === "Transaction History") {
                            sessionStorage.setItem(
                                "transhistory_permission",
                                role_permission_check[0]?.canView
                            );
                            permisson_roles.transaction_history =
                                role_permission_check[0]?.canView;
                        } else if (data.name === "Store List") {
                            sessionStorage.setItem(
                                "store_list",
                                role_permission_check[0]?.canView
                            );
                            permisson_roles.store_list = role_permission_check[0]?.canView;
                        } else if (data.name === "Account Summary Synchrony") {
                            sessionStorage.setItem(
                                "account_summary_synchrony",
                                role_permission_check[0]?.canView
                            );
                            permisson_roles.account_summary_synchrony =
                                role_permission_check[0]?.canView;
                        } else if (data.name === "Account Summary Progressive") {
                            sessionStorage.setItem(
                                "account_summary_progressive",
                                role_permission_check[0]?.canView
                            );
                            permisson_roles.account_summary_progressive =
                                role_permission_check[0]?.canView;
                        } else if (data.name === "Account Summary Uown") {
                            sessionStorage.setItem(
                                "account_summary_uown",
                                role_permission_check[0]?.canView
                            );
                            permisson_roles.account_summary_uown =
                                role_permission_check[0]?.canView;
                        } else if (data.name === "Account Summary Fortiva") {
                            sessionStorage.setItem(
                                "account_summary_fortiva",
                                role_permission_check[0]?.canView
                            );
                            permisson_roles.account_summary_fortiva =
                                role_permission_check[0]?.canView;
                        }
                    });
                let districtList = {};
                await trackPromise(
                    this.props.userListactions
                        .getDistricts()
                        .then((response) => {
                            if (response) {
                                districtList = response.data;
                            }
                        })
                        .catch((err) => {
                            APIFailedMessage.displayError(err);
                        })
                )
                let district = [];
                await trackPromise(
                    this.props.userListactions
                        .getUser(localStorage.getItem("loggedUserEmail"))
                        .then((response) => {
                            if (response) {
                                sessionStorage.setItem(
                                    "userStoresInfo",
                                    JSON.stringify(response)
                                );
                                let userObj = {
                                    id: response.id,
                                    associateEmail: response.associateEmail,
                                    userName: response.displayName,
                                    userId: response.userId,
                                    userRole: response.roleName,
                                    district: response.district,
                                    status: response.status,
                                    homeStore: response.storeCode,
                                    createdBy: response.createdBy,
                                    effectiveDate: response.effectiveDate,
                                    allowPortalAccess: response.allowPortalAccess,
                                    lastActivity: Moment(new Date()).format("MM/DD/YYYY"),
                                };
                                this.props.userListactions
                                    .editUser(userObj, true)
                                    .then((response) => { })
                                    .catch((err) => {
                                        APIFailedMessage.displayError(err);
                                    });
                                district = response.district?.split(",");
                            }
                        })
                        .catch((err) => {
                            APIFailedMessage.displayError(err);
                        })
                )
                district = district.map((val) => { return val.toLowerCase(); });
                let distrobj = districtList.filter((item) => { return district?.includes(item.name.toLowerCase()); });
                distrobj = distrobj.map((val) => { return val.id; });
                if (distrobj) {
                    await trackPromise(
                        this.props.userListactions
                            .getStoresByMultipleDistrictId(distrobj)
                            .then((response) => {
                                if (response) {
                                    sessionStorage.setItem(
                                        "storeList",
                                        JSON.stringify(response.data)
                                    );
                                }
                            }
                            ).catch((err) => {
                                APIFailedMessage.displayError(err);
                            })
                    )
                }
                sessionStorage.setItem("createdDate", "");
                let customerId = "";
                if ((this.state.duplicateCustData.existing_Customer === false && this.state.duplicateCustData.customer_id === 0) && this.state.magixDuplicateCustData?.data?.length > 0) {
                    customerId = this.state.selectedDuplicateMagixRecord.newCustomerId;
                }
                else {
                    customerId = this.state.duplicateCustData.customer_id;
                }
                localStorage.setItem("customerId", customerId);
                localStorage.setItem('selectedCustomer', customerId);
                sessionStorage.setItem("isNewApplication", "false");
                sessionStorage.setItem("thirdPartyLink", "false");
                await this.props.history.push(`/customer-details/${customerId}`);
            }
        }
    }

    async createCustomer(data) {
        if ((this.state.duplicateCustData.existing_Customer === false && this.state.duplicateCustData.customer_id !== 0) && this.state.magixDuplicateCustData?.data?.length > 0) {
            let obj = {
                customer_id: this.state.duplicateCustData.customer_id,
                firstName: "",
                middleName: "",
                lastName: "",
                mobileNo: "",
                emailAddress: "",
                address: "",
                apt: "",
                city: "",
                state_id: 0,
                zipcode: "",
                modifiedAssociate: localStorage.getItem("loggedUserEmail"),
                modifiedValues: "",
                magix_Id: this.state.selectedDuplicateMagixRecord?.customer_Id,
                magixStoreCode: this.state.selectedDuplicateMagixRecord.store_code,
                ismagixMapping: true
            };
            trackPromise(
                this.props.customerUpdation
                    .updateMasterCustomer_Record(obj)
                    .then((res) => {
                        if (res) {
                            if (res.isSuccess === true) {
                                this.setState({ isMagixDuplicateCustomer: !this.state.isMagixDuplicateCustomer });
                                sessionStorage.setItem("fromInstoreDuplicatePopup", true);
                                if (sessionStorage.getItem("logout/continue") != "true") {
                                    this.redirectCustomerDetail();
                                }
                                else
                                    this.userReLogin("redirectToCustDetils");
                            } else {
                                this.handleDuplicateCustCancel();
                            }
                        }
                    })
                    .catch((err) => {
                        APIFailedMessage.displayError(err);
                    })
            );
        }
        else {
            let customerInfo = {}
            if (data === undefined) {
                customerInfo = {
                    application_id: 0,
                    firstName: this.state.formObj.firstName,
                    middleName: this.state.formObj.middleName,
                    lastName: this.state.formObj.lastName,
                    suffix_Id: ((this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit)) ? (parseInt(this.state.formObj.suffix) > 0) ? parseInt(this.state.formObj.suffix) : null : null),
                    address: this.state.formObj.mailingAdr,
                    city: this.state.formObj.city,
                    state_Id: (parseInt(this.state.formObj.state) > 0) ? parseInt(this.state.formObj.state) : null,
                    zipCode: this.state.formObj.zipCode,
                    apt: this.state.formObj.aptUnit,
                    emailAddress: this.state.formObj.emailAdr,
                    customer_Id: "",
                    portalStatus: "",
                    mobileNo: this.state.formObj.mobileNo,
                    secondaryPhone: (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit)) ? this.state.formObj.secPhone === "" ? null : this.state.formObj.secPhone : null,
                    idNumber: "",
                    ssn: this.state.formObj.ssn,
                    status_Id: 0,
                    balanceDue: 0,
                    strbalanceDue: "",
                    birthDate: GetDateFromMMDDYYYY(this.state.formObj.dob),
                    empName: "",
                    empPhone: "",
                    howLong: null,
                    workJob: null,
                    monthlyIncome: 0,
                    housingInfo_Id: (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit)) ? parseInt(this.state.formObj.housingInfo) : null,
                    primaryType_Id: 0,
                    primaryState_Id: 0,
                    relativeName: "",
                    relativePhone: "",
                    relativeRelationship: "",
                    createdDate: new Date(),
                    createdBy_Associate: (this.state.thirdPartySessionLink || this.state.SMSLink) ? "" : localStorage.getItem('loggedUserEmail'),
                    modifiedBy_Associate: (this.state.thirdPartySessionLink || this.state.SMSLink) ? "" : localStorage.getItem('loggedUserEmail'),
                    modifiedDate: new Date(),
                    store_Id: sessionStorage.getItem("SMSLink") || this.state.thirdPartySessionLink ? "0" : this.state.formObj.storeCode,
                    store_code: "",
                    store_name: "",
                    lastDraftCreditId: 0,
                    primaryIdExpDate: new Date(),
                    secondIdType_Id: 0,
                    secondIdIssuedBy_Id: "",
                    secondIdExpDate: new Date(),
                    howOftenPaid_Id: 0,
                    lastPayDay: new Date(),
                    nextPayDay: new Date(),
                    primaryIncome_Id: 0,
                    bankRoutingNo: "",
                    checkingAccountNo: "",
                    creditCardBin: "",
                    creditCardExpDate: new Date(),
                    nameOnCreditCard: "",
                    creditCardHomeAddress: false,
                    ccAddress: "",
                    ccApt: "",
                    ccCity: "",
                    ccState_Id: 0,
                    ccZipCode: "",
                    responseSource: "",
                    title_code: "",
                    notesModifiedDate: new Date(),
                    suffix_Code: "",
                    state_Code: "",
                    magixStoreCode: "",
                    magix_Id: "",
                    isMobileNoVerified: this.state.isSMSOverride ? false : true,
                    isSMSCodeSent: this.state.SMSCodeSent ? true : false,
                    isSMSOverride: this.state.isSMSOverride,
                    poBox: "",
                    printContent: "",
                    totalPrint: 0,
                    fortivaResponse_Id: 0,
                    isDaniel: false,
                    isProgressive: false,
                    isUown: false,
                    application_Type: "",
                    uownStatus: "",
                    progressiveStatus: "",
                    synchronyStatus: "",
                    fortivaStatus: "",
                    maxCustBal: 0,
                    strmaxCustBal: "",
                    custAcctStat: "",
                    isSynchrony: false,
                    isSynchronyCD: false,
                    isFortiva: false,
                    danielAppId: "",
                    synchronyAppId: "",
                    progressiveAppId: "",
                    uownAppId: "",
                    fortivaAppId: ""
                }
                trackPromise(
                    this.props.actions.createCustomer(customerInfo).then(
                        response => {
                            if (response) {
                                this.updateState("txtCustomerNo", response.customer_id);
                                this.setState({ formObj: { ...this.state.formObj, account: response.customer_id } });
                            }
                        }
                    ).catch(err => {
                        APIFailedMessage.displayError(err);
                    })
                )
            }
            else {
                let selectedRow = data;
                if (selectedRow.ssn && selectedRow.birthDate) {
                    //validating ssn having 9 digits or not by removing - from ssn data
                    if (selectedRow.ssn.replace(/-/g, "")?.length === 9 && selectedRow.ssn.replace(/-/g, "") != "000000000") {
                        //let birthDate="2008-05-31T00:00:00";
                        let birthDate = selectedRow.birthDate;
                        //validating the age is greater than 18 or not
                        if (parseInt(birthDate?.split('-')[0]) < 1900) {
                            this.setState({ validateMagix: true });
                        }
                        else if (birthDate?.length !== 0) {
                            var today = new Date();
                            let birthDateFormatted = new Date(birthDate);
                            var age = today.getFullYear() - birthDateFormatted.getFullYear();
                            var m = today.getMonth() - birthDateFormatted.getMonth();
                            if (m < 0 || (m === 0 && today.getDate() < birthDateFormatted.getDate())) {
                                age--;
                            }
                            if (age < 18) {
                                this.setState({ validateMagix: true });
                            }
                            else {
                                //creating customer from magix data if both ssn and birth date are valid
                                let selectedRow = data;
                                let name = selectedRow.firstName.split(",");
                                if (selectedRow.state_Code) {
                                    let result = await this.state.formObj.lstState.filter((data) => {
                                        return data.code?.toLowerCase() === selectedRow.state_Code?.toLowerCase();
                                    });
                                    selectedRow.state_Id = result[0]?.id;
                                }
                                if (selectedRow.suffix_Code) {
                                    let result = await this.state.formObj.lstSuffix.filter((data) => {
                                        return data.code?.toLowerCase() === selectedRow.suffix_Code?.toLowerCase();
                                    });
                                    selectedRow.suffix_Id = result[0]?.id;
                                }
                                customerInfo = {
                                    application_id: 0,
                                    firstName: name[1].trim(""),
                                    middleName: selectedRow.middleName,
                                    lastName: name[0],
                                    suffix_Id: selectedRow.suffix_Id,
                                    address: selectedRow.address,
                                    city: selectedRow.city,
                                    state_Id: selectedRow.state_Id,
                                    zipCode: selectedRow.zipCode,
                                    apt: selectedRow.apt,
                                    emailAddress: selectedRow.emailAddress,
                                    customer_Id: "",
                                    portalStatus: "",
                                    mobileNo: selectedRow.mobileNo,
                                    secondaryPhone: selectedRow.secondaryPhone === "" ? null : selectedRow.secondaryPhone,
                                    idNumber: "",
                                    ssn: selectedRow.ssn,
                                    status_Id: 0,
                                    balanceDue: 0,
                                    strbalanceDue: "",
                                    birthDate: Moment(selectedRow.birthDate).format("YYYY-MM-DD"),
                                    empName: "",
                                    empPhone: "",
                                    howLong: null,
                                    workJob: null,
                                    monthlyIncome: 0,
                                    housingInfo_Id: parseInt(selectedRow.housingInfo_Id),
                                    primaryType_Id: 0,
                                    primaryState_Id: 0,
                                    relativeName: "",
                                    relativePhone: "",
                                    relativeRelationship: "",
                                    createdDate: new Date(),
                                    createdBy_Associate: localStorage.getItem('loggedUserEmail'),
                                    modifiedBy_Associate: localStorage.getItem('loggedUserEmail'),
                                    modifiedDate: new Date(),
                                    store_Id: JSON.parse(localStorage.getItem("associateStores")),
                                    store_code: "",
                                    store_name: "",
                                    lastDraftCreditId: 0,
                                    primaryIdExpDate: new Date(),
                                    secondIdType_Id: 0,
                                    secondIdIssuedBy_Id: "",
                                    secondIdExpDate: new Date(),
                                    howOftenPaid_Id: 0,
                                    lastPayDay: new Date(),
                                    nextPayDay: new Date(),
                                    primaryIncome_Id: 0,
                                    bankRoutingNo: "",
                                    checkingAccountNo: "",
                                    creditCardBin: "",
                                    creditCardExpDate: new Date(),
                                    nameOnCreditCard: "",
                                    creditCardHomeAddress: false,
                                    ccAddress: "",
                                    ccApt: "",
                                    ccCity: "",
                                    ccState_Id: 0,
                                    ccZipCode: "",
                                    responseSource: "",
                                    title_code: "",
                                    notesModifiedDate: new Date(),
                                    suffix_Code: "",
                                    state_Code: "",
                                    magixStoreCode: selectedRow.store_code,
                                    magix_Id: selectedRow.customer_Id,
                                    isMobileNoVerified: false,
                                    isSMSCodeSent: false,
                                    isSMSOverride: false,
                                    poBox: "",
                                    printContent: "",
                                    totalPrint: 0,
                                    fortivaResponse_Id: 0,
                                    isDaniel: false,
                                    isProgressive: false,
                                    isUown: false,
                                    application_Type: "",
                                    uownStatus: "",
                                    progressiveStatus: "",
                                    synchronyStatus: "",
                                    fortivaStatus: "",
                                    maxCustBal: 0,
                                    strmaxCustBal: "",
                                    custAcctStat: "",
                                    isSynchrony: false,
                                    isSynchronyCD: false,
                                    isFortiva: false,
                                    danielAppId: "",
                                    synchronyAppId: "",
                                    progressiveAppId: "",
                                    uownAppId: "",
                                    fortivaAppId: ""
                                }
                                trackPromise(
                                    this.props.actions.createCustomer(customerInfo).then(
                                        response => {
                                            if (response) {
                                                sessionStorage.setItem("fromInstoreDuplicatePopup", true);
                                                let data = this.state.selectedDuplicateMagixRecord;
                                                data.newCustomerId = response.customer_id;
                                                this.setState({ selectedDuplicateMagixRecord: data });
                                                this.handleDuplicateMagixCust(response.customer_id);
                                            }
                                        }
                                    ).catch(err => {
                                        APIFailedMessage.displayError(err);
                                    })
                                )
                            }
                        }
                        else this.setState({ validateMagix: true });
                    }
                    else this.setState({ validateMagix: true });
                }
                else this.setState({ validateMagix: true });
            }
        }
    }

    // waterfall methods
    cancelProgUownApplication = (event) => {
        event.preventDefault();
        let fortivaAPIErrorMsg = this.state.fortivaAppErrMsg;
        this.setState({ waterfallObj: { ...this.state.waterfallObj, showProgUown: false } });
        if (fortivaAPIErrorMsg) {
            this.setState({ isAPIError: true, fortivaCredit: true, danielsCredit: false, synchronyCredit: false, UOwnLeasing: false, progressiveLeasing: false, isAPIErrorMsg: this.state.fortivaAppErrMsgDesc });
            this.setState({
                step1: true,
                isStep1Complete: false,
                step2: false,
                toggled: false,
                isStep2Complete: false,
                step3: false,
                isStep3Complete: false,
                step4: false,
                isStep4Complete: false,
                step5: false,
                isStep5Complete: false,
                step7: false,
                isStep7Complete: false,
                step8: false,
                isStep8Complete: false,
                step9: false,
                isStep9Complete: false,
                step10: false,
                isStep10Complete: false,
                step11: false,
                isStep11Complete: false,
                danielsDisclosure: false,
                synchronyDisclosure: false,
                verifyPassword: false,
                showPopup: false,
                progressiveDisclosure: false,
                progressiveSMS: false,
                UOwnDisclosure: false,
                showSubmitConfirmation: false,
                isAgreed: false,
                isSMSOverride: false,
                isSMSVerified: false,
                fortivaElecDisclosure: false,
                formObj: { ...this.state.formObj, verificationCode: "" }
            });
            this.validateMobileVerification(this.state.formObj?.mobileNo);
        }
        else {
            this.redirectToViewOffers();
        }
    }
    redirectProgUownApplication = (event) => {
        event.preventDefault();
        this.setState({ waterfallObj: { ...this.state.waterfallObj, showProgUown: false } });
        sessionStorage.setItem("progUownApplications", true);
        // if(this.state.waterfallObj.isProgChecked && this.state.progressiveApp){
        //     this.setState({progressiveLeasing:true,UOwnLeasing:true})
        // }
        // else{
        //     this.setState({progressiveLeasing:false})
        // }
        // if(this.state.waterfallObj.isUownChecked && this.state.uownApp){
        //     this.setState({UOwnLeasing:true})
        // }
        // else{
        //     this.setState({UOwnLeasing:false})
        // }
    }
    synchronyOffers(isSynchronyOnly) {
        let synchronyAppId = localStorage.getItem("synchronyAppId") == null ? localStorage.getItem("magixassociateId") : localStorage.getItem("synchronyAppId");
        let homeStore = localStorage.getItem("associateStores") !== "null" ? JSON.parse(localStorage.getItem("associateStores")) : "";
        if (synchronyAppId != "null" && synchronyAppId != "undefined") {
            trackPromise(
                this.props.customerDetailsActions.getSynchronyViewOffers(GetInfo.getCustomerId(), synchronyAppId, homeStore).then(
                    response => {
                        if (response) {
                            let isSynchrony = sessionStorage.getItem("isSynchrony");
                            let isDaniels = sessionStorage.getItem("isDaniel");
                            let isFortiva = sessionStorage.getItem("isFortiva");
                            this.setState({ waterfallObj: { ...this.state.waterfallObj, synchronyOffer: response } });
                            let submitforFortiva = localStorage.getItem('submitforFortiva');
                            if (isSynchronyOnly) {
                                this.setState({ waterfallObj: { ...this.state.waterfallObj, waterFallStatus: true } });
                            }
                            else {
                                if (response.status?.toLowerCase() === "approved" && submitforFortiva == "true") {
                                    localStorage.setItem('submitforFortiva', false);
                                    this.setState({ showFortiva: true });
                                }
                                else if (response.status?.toLowerCase() === "declined" && submitforFortiva == "true" && isSynchrony == "true" && isFortiva == "true") {
                                    this.setState({ synchronyDeclined: !this.state.synchronyDeclined });
                                }
                                else if (response.status?.toLowerCase() === "pending" && submitforFortiva == "true" && isSynchrony == "true" && isFortiva == "true") {
                                    let pending = true;
                                    this.rejectFortiva(pending);
                                    this.setState({ synchronyPending: !this.state.synchronyPending });
                                }
                                else if (isSynchrony == "true" && isDaniels == "true") {
                                    this.setState({ waterfallObj: { ...this.state.waterfallObj, waterFallStatus: true } });
                                }
                            }
                        }

                    }).catch(err => {
                        APIFailedMessage.displayError(err);
                    })
            )
        }
    }
    fortivaOffers() {
        let cust_Id = localStorage.getItem("customerId");
        cust_Id = (cust_Id == "null" || cust_Id == "undefined" || cust_Id === null || cust_Id === undefined) ? 0 : cust_Id;
        if (cust_Id) {
            trackPromise(
                this.props.customerDetailsActions.getViewOfferFortiva(cust_Id).then(
                    response => {
                        if (response) {
                            let fortivaOffer = response.data?.filter((val) => { return val.fpType?.toLowerCase() === "fortiva" })[0];
                            sessionStorage.setItem("updated_fortiva_response", JSON.stringify(response));
                            if (fortivaOffer) {
                                if (
                                    fortivaOffer.applicationStatus?.toLowerCase() === "d" ||
                                    fortivaOffer.applicationStatus?.toLowerCase() === "ec" ||
                                    fortivaOffer.applicationStatus?.toLowerCase() === "cr" ||
                                    fortivaOffer.applicationStatus?.toLowerCase() === "r"
                                ) {
                                    this.setState({ waterfallObj: { ...this.state.waterfallObj, waterFallStatus: true, fortivaOffer: fortivaOffer } });
                                }
                                else {
                                    this.props.history.push("/view-offers");
                                }
                            }
                        }
                    }
                ).catch(err => {
                    APIFailedMessage.displayError(err);
                })
            )
        }
    }
    synchronPendingModal = () => {
        this.setState({ synchronyPending: !this.state.synchronyPending });
    }
    synchronPendingOk = () => {
        localStorage.setItem('submitforFortiva', false);
        this.setState({ waterfallObj: { ...this.state.waterfallObj, waterFallStatus: true }, synchronyPending: !this.state.synchronyPending });
    }
    synchronDeclinedOk = (event) => {
        event.preventDefault();
        localStorage.setItem('submitforFortiva', false);
        this.setState({ synchronyDeclined: false });
        let declined = true;
        this.submitFortiva("", declined);
    }

    autoPayMessageModal = (event) => {
        if (this.state.danielsCredit) {
            let promptForAutoPaySpiff = this.state.danielsCredit &&
                this.state.isAutoPayEnabled &&
                (!this.state.autoPay || !this.state.autoPaySubmitted);
            let autoPayMessage = "PLEASE ADD AUTOPAY & EARN SPIFF";
            this.setState({ autoPayMessage: autoPayMessage, autoPayMessagePopup: promptForAutoPaySpiff });
        }
        this.submitStep10(event);
    }

    handleWaterFallStatus = (event) => {
        event.preventDefault();
        if (this.state.progressiveApp || this.state.uownApp)
            this.setState({ waterfallObj: { ...this.state.waterfallObj, waterFallStatus: false, showProgUown: true } });
        else {
            this.setState({ waterfallObj: { ...this.state.waterfallObj, waterFallStatus: false } });
            this.handlesubmitProgUown();
        }
    }

    hanldeProgUownApplication = (event) => {
        event.preventDefault();
        this.setState({ showProgUown: false });
        sessionStorage.removeItem("submitAppFirst");
    }

    rejectFortiva = (pending) => {
        let customerId = localStorage.getItem("selectedCustomer") != "null" ? localStorage.getItem("selectedCustomer") : 0;
        let saveCustResponseFortiva = "";
        if (pending) {
            saveCustResponseFortiva = "Not Sent";
        }
        else {
            saveCustResponseFortiva = "No";
        }

        this.setState({ showFortiva: false });
        trackPromise(
            this.props.actions.creditSubmitFortiva(customerId, saveCustResponseFortiva, this.state.associateId, this.state.store_Id).then(
                response => {
                    if (response) {
                        if (response.errorMessage) {
                            console.log(response.errorMessage);
                        }
                        else {
                            this.setState({ successMsg: "Not send the application to Fortiva", offerModal: true });
                            if (!pending) {

                                this.setState({ waterfallObj: { ...this.state.waterfallObj, waterFallStatus: true } });
                            }
                        }
                    }
                }
            ).catch(err => {
                APIFailedMessage.displayError(err);
            })
        )
    }
    handleFortivaModal = (event) => {
        event.preventDefault();
        this.setState({ showFortiva: !this.state.showFortiva });
        this.rejectFortiva();
    }
    submitFortiva = (event, declined) => {
        if (event)
            event?.preventDefault();
        let customerId = localStorage.getItem("selectedCustomer") != "null" ? localStorage.getItem("selectedCustomer") : 0;
        let saveCustResponseFortiva = "";
        if (declined) {
            saveCustResponseFortiva = "Automatic";
        }
        else {
            saveCustResponseFortiva = "Yes";
        }
        this.setState({ showFortiva: false });
        trackPromise(
            this.props.actions.creditSubmitFortiva(customerId, saveCustResponseFortiva, this.state.associateId, this.state.store_Id).then(
                response => {
                    if (response) {
                        if (response.errorMessage.length > 0) {
                            //localStorage.setItem("fortivaAPIErrorMsg",response.errorMessage);
                            this.setState({
                                fortivaAppError: true, fortivaAppErrMsg: "Your application to Fortiva was not sent due an error in the application. After you submit the Progressive or Uown Leasing applications resubmit the Fortiva application by selecting Apply Again.",
                                fortivaAppErrMsgDesc: response.errorMessage
                            })
                        }
                        else {
                            localStorage.setItem("fortivaAppId", response.customer.fortivaAppId);
                            if (response) {
                                trackPromise(
                                    this.props.customerDetailsActions.getViewOfferFortiva(customerId).then(
                                        response => {
                                            if (response) {
                                                let fortivaOffer = response.data?.filter((val) => { return val.fpType?.toLowerCase() === "fortiva" })[0];
                                                sessionStorage.setItem("updated_fortiva_response", JSON.stringify(response));
                                                if (fortivaOffer) {
                                                    if (
                                                        fortivaOffer.applicationStatus?.toLowerCase() === "d" ||
                                                        fortivaOffer.applicationStatus?.toLowerCase() === "ec" ||
                                                        fortivaOffer.applicationStatus?.toLowerCase() === "cr" ||
                                                        fortivaOffer.applicationStatus?.toLowerCase() === "r"
                                                    ) {
                                                        this.setState({ waterfallObj: { ...this.state.waterfallObj, waterFallStatus: true, fortivaOffer: fortivaOffer } });
                                                    }
                                                    else {
                                                        this.props.history.push("/view-offers");
                                                    }
                                                }
                                            }
                                        }
                                    ).catch(err => {
                                        APIFailedMessage.displayError(err);
                                    })
                                )
                            }
                        }
                    }
                }
            ).catch(err => {
                APIFailedMessage.displayError(err);
            })
        )
    }
    handleFortivaErrorModal = () => {
        this.setState({ fortivaAppError: !this.state.fortivaAppError });
    }
    redirectoFortivaApplication = (event) => {
        event.preventDefault();
        let fortivaAppError = !this.state.fortivaAppError;
        this.setState({ fortivaAppError: fortivaAppError });
        this.setState({ waterfallObj: { ...this.state.waterfallObj, waterFallStatus: true } });
    }
    handleOnchange = (event) => {
        if (event.target.name == "isProg") {
            this.setState({ waterfallObj: { ...this.state.waterfallObj, isProgChecked: event.target.checked } });
        }
        else {
            this.setState({ waterfallObj: { ...this.state.waterfallObj, isUownChecked: event.target.checked } });
        }

    }
    handlesubmitProgUown = (errorMessage) => {
        if (errorMessage) {
            this.setState({ isAPIError: true });
            let error_ssn = errorMessage.replace('Applicant.SSN', 'SSN')
            let error_HomePhone = error_ssn.replace('Applicant.HomePhone', 'Mobile Number')
            let error_HomePhone_1 = error_HomePhone.replace('Applicant.CellPhone', 'Secondary Phone ')
            this.setState({ isAPIErrorMsg: this.state.isAPIErrorMsg.concat(error_HomePhone_1) });
        }
        else {
            let customerId = localStorage.getItem("customerId");
            let fortivaAPIErrorMsg = this.state.fortivaAppErrMsg;
            if (fortivaAPIErrorMsg) {
                sessionStorage.removeItem("progUownApplications");
                //localStorage.setItem("fortivaAPIErrorMsg",fortivaAPIErrorMsg);
                this.setState({ isAPIError: true, fortivaCredit: true, danielsCredit: false, synchronyCredit: false, UOwnLeasing: false, progressiveLeasing: false, isAPIErrorMsg: this.state.fortivaAppErrMsgDesc });
                this.setState({
                    step1: true,
                    isStep1Complete: false,
                    step2: false,
                    toggled: false,
                    isStep2Complete: false,
                    step3: false,
                    isStep3Complete: false,
                    step4: false,
                    isStep4Complete: false,
                    step5: false,
                    isStep5Complete: false,
                    step7: false,
                    isStep7Complete: false,
                    step8: false,
                    isStep8Complete: false,
                    step9: false,
                    isStep9Complete: false,
                    step10: false,
                    isStep10Complete: false,
                    step11: false,
                    isStep11Complete: false,
                    danielsDisclosure: false,
                    synchronyDisclosure: false,
                    verifyPassword: false,
                    showPopup: false,
                    progressiveDisclosure: false,
                    progressiveSMS: false,
                    UOwnDisclosure: false,
                    showSubmitConfirmation: false,
                    isAgreed: false,
                    isSMSOverride: false,
                    isSMSVerified: false,
                    fortivaElecDisclosure: false,
                    formObj: { ...this.state.formObj, verificationCode: "" }
                });
                this.validateMobileVerification(this.state.formObj?.mobileNo);
            }
            else if (sessionStorage.getItem("logout/continue") == "true") {
                setTimeout(() => {
                    window.location.replace("https://www.danielsjewelers.com/");
                }, 1000)
            }
            else {
                setTimeout(() => {
                    this.props.history.push("/view-offers");
                }, 1000)
            }
        }
    }
    // handleMagixPopup = () => {
    //     this.setState({ magixPopupShow: !this.state.magixPopupShow});
    //     if(this.state.multipleMagixId?.length>1){
    //         this.setState({ selectedMagixAccount:"",selectedMagixStoreId:"" }); 
    //     }
    // }
    // handleMagixAccounts = (magixId,storeId) => {
    //     this.setState({selectedMagixAccount:magixId,selectedMagixStoreId:storeId});
    // }
    // confirm = (event) => {
    //     event.preventDefault();
    //     this.setState({ magixPopupShow: !this.state.magixPopupShow});
    //     this.ConfirmationMagixModal(event);
    // }

    render() {

        let fortivaAPIErrorMsg = this.state.fortivaAppErrMsg;
        let progUownApplications = sessionStorage.getItem("progUownApplications");
        let isWaterFallEnable = this.state.isWaterFallEnable;

        const { danielsDisclosureErr, synchronyDisclosureErr, fortivaDisclosureErr, storeCodeErr, firstNameErr, lastNameErr, mailingAdrErr, emailAdrErr, aptUnitErr, dobErr, cityErr, mobileNoErr, stateErr,
            zipCodeErr, empNameErr, empStartDateErr, empPhoneNoErr, netIncomeErr, dutiesErr, housingInfoErr, ssnErr, primaryIdTypeErr,
            primaryIdNoErr, primaryIdStateErr, relativeNameErr, relativePhoneErr, relativeRelationErr, verificationCodeErr, progressiveDisclosureErr, UOwnDisclosureErr,
            oftenPaidErr, ccErr, lastPayDayErr, ccExpiryDateErr, nextPayDayErr, ccNameErr, creditCardBillingAddressErr,
            ccmailingAdrErr, ccaptUnitErr, cccityErr, ccstateErr, cczipCodeErr, bankRouteNoErr, checkAccNoErr,
            primaryIdExpiryDateErr, secondIdTypeErr, sameSecondIdTypeErr, secondIdIssuedByErr, associateVerifiedErr, secondIdExpiryDateErr, chkSynchronyOnlyErr, applicantIdMatchErr, synchronyAgreementGivenErr,
            secPhoneErr, captchaErr, autoPayErr, uOwnOftenPaidErr, uOwnLastPayDayErr, uOwnNextPayDayErr, fortivaElecDiscErr, fortivaWrittenInstrErr, notifyViaTextandEmailErr } = this.state.formErrors;

        //Display waterfall status message 
        let isFortiva = sessionStorage.getItem("isFortiva");
        let isDaniel = sessionStorage.getItem("isDaniel");
        let isSynchrony = sessionStorage.getItem("isSynchrony");
        let fortivaStatus = "";
        let fortivaAmt = 0;
        let synchronyStatus = "";
        let synchronyAmt = 0;
        let fortivaOffer = this.state.waterfallObj.fortivaOffer;
        if (fortivaOffer) {

            if (fortivaOffer.applicationStatus?.toLowerCase() === "a") {
                fortivaStatus = "Approved";
                fortivaAmt = "$" + fortivaOffer.approvalLimit.toLocaleString("en-US");
            }
            else if (
                fortivaOffer.applicationStatus?.toLowerCase() === "d" ||
                fortivaOffer.applicationStatus?.toLowerCase() === "ec" ||
                fortivaOffer.applicationStatus?.toLowerCase() === "cr" ||
                fortivaOffer.applicationStatus?.toLowerCase() === "r"
            ) {
                fortivaStatus = "Declined";

            }
            else if (fortivaOffer.applicationStatus?.toLowerCase() === "p") {
                fortivaStatus = "Error 1";
            }
            else if (fortivaOffer.applicationStatus?.toLowerCase() === "ca") {
                fortivaStatus = "Error 2";
            }
            else if (fortivaOffer.applicationStatus?.toLowerCase() === "an") {
                fortivaStatus = "Error 3";
            }
        }

        let synchronyOffer = this.state.waterfallObj.synchronyOffer;
        if (synchronyOffer) {
            if (synchronyOffer.status?.toLowerCase() === "approved") {
                synchronyStatus = "Approved";
                synchronyAmt = "$" + synchronyOffer.approvalLimit.toLocaleString("en-US");
            }
            else if (synchronyOffer.status?.toLowerCase() == "declined" || synchronyOffer.status?.toLowerCase() == "denied") {
                synchronyStatus = "Declined";
            }
            else if (synchronyOffer.status?.toLowerCase() == "pending" || synchronyOffer.status?.toLowerCase() == "pre-approved") {
                synchronyStatus = "Pending";
            } else if (synchronyOffer.status?.toLowerCase() == "in process") {
                synchronyStatus = "In Process";
            }
        }
        // let waterFallmessage=`
        //     ${isSynchrony=="true" ? `<p> <span class="ml-0 mr-0">Synchrony Status: <span class="font-weight-bold">${synchronyStatus}</span></span> ${synchronyStatus=="Approved"?`<span style={{paddingLeft:"30px"}}>Approval Amount: <span class="font-weight-bold">${synchronyAmt}</span></span>`:""}</p>`:""}
        //     ${(isFortiva=="true" && fortivaOffer) ? `<p> <span class="ml-0 mr-0">Foritva Status: <span class="font-weight-bold">${fortivaStatus}</span></span> ${fortivaStatus=="Approved"?`<span class="ml-4" style={{paddingLeft:"30px"}}>Approval Amount: <span class="font-weight-bold">${fortivaAmt}</span></span>`:""}</p>`:""}
        //     ${isDaniel=="true"?`<p class="mb-0">Daniel's Credit Status: <span class="font-weight-bold">Applied</span></p>`:""}`

        let waterFallmessage = `
                    <table class="table table-bordered mb-0">
                    <thead>
                        <tr>
                        <th class="bg-secondary text-primary" style="border-radius: 0px;">Application</th>
                        <th class="bg-secondary text-primary">Status</th>
                        <th class="bg-secondary text-primary" style="border-radius: 0px;">Approval Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${isSynchrony == "true" ? `
                        <tr>
                        <td>Synchrony</td>
                        <td>${synchronyStatus}</td>
                        <td>${synchronyStatus == "Approved" ? synchronyAmt : ""}</td>
                        </tr>
                        ` : ""} ${(isFortiva == "true" && fortivaOffer) ? `
                        <tr>
                        <td>Foritva</td>
                        <td>${fortivaStatus}</td>
                        <td>${fortivaStatus == "Approved" ? fortivaAmt : ""}</td>
                        </tr>
                        ` : ""} ${(isFortiva == "true" && this.state.fortivaAppErrMsg?.length > 0) ? `
                        <tr>
                        <td>Foritva</td>
                        <td class="text-danger">Not sent</td>
                        <td></td>
                        </tr>
                        ` : ""} ${isDaniel == "true" ? `
                        <tr>
                        <td>Daniel's Credit</td>
                        <td>Applied</td>
                        <td></td>
                        </tr>
                        ` : ""}
                    </tbody>
                    </table>
                    `;

        let screenWidth = "";
        let count = [this.state.fortivaApp, this.state.danielsApp, this.state.progressiveApp, this.state.uownApp];
        count = count.filter((val) => { return val });
        count = count?.length;
        if (count === 4) {
            screenWidth = "col-md-2.5";
        }
        else if (count === 3) {
            screenWidth = "col-md-3";
        }
        else if (count === 2) {
            screenWidth = "col-md-4";
        }
        else if (count === 1) {
            screenWidth = "col-md-6"
        }

        return (
            <>
                <ToastContainer className="p-3" position="top-end">
                    <Toast bg={this.state.isSMSError ? "danger" : "success"} onClose={() => { this.setState({ toastModal: !this.state.toastModal }) }} show={this.state.toastModal} delay={3000} animation autohide>
                        <Toast.Body className="text-white ml-2 mr-2">{this.state.isSMSError ? <FontAwesomeIcon icon={faCircleXmark} className="pr-2" /> : <FontAwesomeIcon icon={faCircleCheck} className="pr-2" />}{this.state.isSMSError ? "Error in sending sms" : "Verification code sent to phone."}</Toast.Body>
                    </Toast>
                </ToastContainer>
                <ToastContainer className="p-3" position="top-end">
                    <Toast bg="danger" onClose={() => { this.setState({ errorInMobileInfo: !this.state.errorInMobileInfo }) }} show={this.state.errorInMobileInfo} delay={5000} animation autohide>
                        <Toast.Body className="text-white ml-2 mr-2">Invalid data in <b>Mobile Verification</b> section.</Toast.Body>
                    </Toast>
                    <Toast bg="danger" onClose={() => { this.setState({ errorInPersonalInfo: !this.state.errorInPersonalInfo }) }} show={this.state.errorInPersonalInfo} delay={5000} animation autohide>
                        <Toast.Body className="text-white ml-2 mr-2">Invalid data in <b>Personal Information</b> section.</Toast.Body>
                    </Toast>
                    <Toast bg="danger" onClose={() => { this.setState({ errorInActVerification: !this.state.errorInActVerification }) }} show={this.state.errorInActVerification} delay={5000} animation autohide>
                        <Toast.Body className="text-white ml-2 mr-2">Invalid data in <b>Customer Account Verification</b> section.</Toast.Body>
                    </Toast>
                    <Toast bg="danger" onClose={() => { this.setState({ errorInEmployment: !this.state.errorInEmployment }) }} show={this.state.errorInEmployment} delay={5000} animation autohide>
                        <Toast.Body className="text-white ml-2 mr-2">Invalid data in <b>Employment</b> section.</Toast.Body>
                    </Toast>
                    <Toast bg="danger" onClose={() => { this.setState({ errorInIdentification: !this.state.errorInIdentification }) }} show={this.state.errorInIdentification} delay={5000} animation autohide>
                        <Toast.Body className="text-white ml-2 mr-2">Invalid data in <b>Identification</b> section.</Toast.Body>
                    </Toast>
                    <Toast bg="danger" onClose={() => { this.setState({ errorInDaniels: !this.state.errorInDaniels }) }} show={this.state.errorInDaniels} delay={5000} animation autohide>
                        <Toast.Body className="text-white ml-2 mr-2">Invalid data in <b>Daniels Credit Required Fields</b> section.</Toast.Body>
                    </Toast>
                    <Toast bg="danger" onClose={() => { this.setState({ errorInSynchrony: !this.state.errorInSynchrony }) }} show={this.state.errorInSynchrony} delay={5000} animation autohide>
                        <Toast.Body className="text-white ml-2 mr-2">Invalid data in <b>Synchrony Required Fields</b> section.</Toast.Body>
                    </Toast>
                    <Toast bg="danger" onClose={() => { this.setState({ erronInProgressive: !this.state.erronInProgressive }) }} show={this.state.erronInProgressive} delay={5000} animation autohide>
                        <Toast.Body className="text-white ml-2 mr-2">Invalid data in <b>Progressive Required Fields</b> section.</Toast.Body>
                    </Toast>
                    <Toast bg="danger" onClose={() => { this.setState({ errorInUown: !this.state.errorInUown }) }} show={this.state.errorInUown} delay={5000} animation autohide>
                        <Toast.Body className="text-white ml-2 mr-2">Invalid data in <b>Uown Required Fields</b> section.</Toast.Body>
                    </Toast>
                    <Toast bg="danger" onClose={() => { this.setState({ errorInAutoPay: !this.state.errorInAutoPay }) }} show={this.state.errorInAutoPay} delay={5000} animation autohide>
                        <Toast.Body className="text-white ml-2 mr-2">Required data in <b>AutoPay</b> section.</Toast.Body>
                    </Toast>
                    <Toast bg="danger" onClose={() => { this.setState({ errorInDisclosure: !this.state.errorInDisclosure }) }} show={this.state.errorInDisclosure} delay={5000} animation autohide>
                        <Toast.Body className="text-white ml-2 mr-2">Required data in <b>Disclosure</b> section.</Toast.Body>
                    </Toast>
                </ToastContainer>
                {this.state.thirdPartySessionLink === true
                    ?
                    <AugmentesIdleTime />
                    :
                    this.state.thirdPartyLink || this.state.SMSLink ? null : <IdleTimeModal />
                }
                <div className={`app ${this.state.toggled ? 'toggled' : ''}`}>
                    {this.state.thirdPartyLink === true
                        ?
                        null
                        :
                        <Sidebar
                            toggled={this.state.toggled}
                            handleToggleSidebar={() => { this.handleToggleSidebar() }}
                        />
                    }

                    <main>
                        <CustomNavbar handleToggleSidebar={() => { this.handleToggleSidebar() }} isApplyNow={true} />
                        {(progUownApplications && this.state.showSubmittedAlert == false) ?
                            <ProgUownForm
                                fortivaApp={this.state.fortivaApp}
                                danielsApp={this.state.danielsApp}
                                progressiveApp={this.state.progressiveApp}
                                uownApp={this.state.uownApp}
                                waterfallObj={this.state.waterfallObj}
                                formObj={this.state.formObj}
                                handlesubmitProgUown={this.handlesubmitProgUown}
                                cancelSessionLink={this.cancelSessionLink}
                                setTimerForAppDelay={this.state.setTimerForAppDelay}
                            /> :

                            <div id="main" className="container-fluid">
                                <div className="row">
                                    <Card
                                        className="bg-white m-3 mt-3 mb-3 border-none w-100"
                                    >
                                        <Card.Title className="ml-3">
                                            <p className="h4 p-0 pl-md-3 pr-md-3 mt-3"><b>Daniel's Jewelers</b></p>
                                            <p className="h4 p-0 pl-md-3 pr-md-3 "><b>Credit Application Form</b></p>
                                        </Card.Title>
                                        <Card.Body>
                                            {this.state.thirdPartySessionLink ?
                                                <p className="m-0 ml-md-3 mr-md-3 text-center mt-4 pt-2 p-2 text-secondary bg-primary">Please note that you must reside in the State of California, Arizona, Nevada, New Mexico, Texas{(this.state.cartId == "" || this.state.cartId == "0") ? " " : ", Florida, Georgia, New York, North Carolina, South Carolina, Virginia, Ohio, Pennsylvania, Michigan "}and be 18 years or older to apply for Daniel's card.</p>
                                                :
                                                <p className="m-0 ml-md-3 mr-md-3 text-center mt-4 pt-2 p-2 text-secondary bg-primary">Please note that you must reside in the State of California, Arizona, Florida, Nevada, New Mexico, Texas and be 18 years or older to apply for Daniel's card.</p>
                                            }
                                            <p className="m-0 ml-md-3 mr-md-3 text-right mt-4 pt-2 p-2 text-danger">Note : All fields are required unless noted as optional.</p>
                                            {this.state.thirdPartyLink === true ? null :
                                                <>
                                                    <div className="row m-1 ml-md-0 mr-md-0 mb-md-0 mt-4">
                                                        <div className="col-12 col-sm-4 col-md-4 p-0 pl-md-3 pr-md-3 ">
                                                            <label className="text-secondary">Select credit accounts to apply:</label>
                                                        </div>
                                                    </div>
                                                    <div className="row m-1 ml-md-0 mr-md-0 mb-md-0 mt-4">
                                                        <div className="col-12 p-0 pl-md-3 pr-md-3 ">
                                                            <div className="row">
                                                                <div className={"col-12  d-flex " + (screenWidth == "col-md-2.5" ? " financialPartner" : screenWidth)}>
                                                                    <OverlayTrigger
                                                                        overlay={<Tooltip>{this.state.alterPopupmessage?.find((item => item.name?.toLowerCase() == "catooltip"))?.description?.split("~`~")[0]}​</Tooltip>}
                                                                        placement="top"
                                                                    >
                                                                        <div className={"form-group d-flex align-items-center justify-content-center radiobtn" + ((fortivaAPIErrorMsg || (this.state.isWaterFallEnable && (progUownApplications || this.state.UOwnLeasing || this.state.progressiveLeasing))) ? " partnerDisable" : "")}>
                                                                            <div className="form-check form-check-inline mr-0 mb-0">
                                                                                <input type="checkbox"
                                                                                    name="chkSyncOnly"
                                                                                    id="chkSyncOnly"
                                                                                    onClick={() => this.onSynchronyCreditChecked()}
                                                                                    value={this.state.synchronyCredit}
                                                                                    checked={this.state.synchronyCredit ? "checked" : ""}
                                                                                    disabled={(fortivaAPIErrorMsg || (this.state.isWaterFallEnable && (progUownApplications || this.state.UOwnLeasing || this.state.progressiveLeasing))) ? true : false}
                                                                                />
                                                                                <label htmlFor="chkSyncOnly" className="mb-0 ml-2 text-secondary">
                                                                                    <label htmlFor="chkSyncOnly" className="mb-0">Synchrony Bank Credit</label>
                                                                                    <div htmlFor="chkSyncOnly" className="mb-0">
                                                                                        ( &nbsp;<div className="d-inline-block" id="squareIcon" /> Synchrony required fields )
                                                                                    </div>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </OverlayTrigger>
                                                                </div>
                                                                {this.state.fortivaApp &&
                                                                    <div className={"col-12  d-flex " + (screenWidth == "col-md-2.5" ? " financialPartner" : screenWidth)}>
                                                                        <OverlayTrigger
                                                                            overlay={<Tooltip>{this.state.alterPopupmessage?.find((item => item.name?.toLowerCase() == "catooltip"))?.description?.split("~`~")[1]}​</Tooltip>}
                                                                            placement="top"
                                                                        >
                                                                            <div className={"form-group d-flex align-items-center justify-content-center radiobtn" + (!this.state.fortivaApp || this.state.progressiveLeasing || this.state.UOwnLeasing || (isWaterFallEnable ? progUownApplications : this.state.danielsCredit) ? " partnerDisable" : "")}>
                                                                                <div className="form-check form-check-inline mr-0">
                                                                                    <input type="checkbox"
                                                                                        name="chkFortivaOnly"
                                                                                        id="chkFortivaOnly"
                                                                                        onClick={() => this.onFortivaChecked()}
                                                                                        value={this.state.fortivaCredit}
                                                                                        checked={this.state.fortivaCredit ? "checked" : ""}
                                                                                        disabled={(!this.state.fortivaApp || this.state.progressiveLeasing || this.state.UOwnLeasing || (isWaterFallEnable ? progUownApplications : this.state.danielsCredit)) ? true : false}
                                                                                    />
                                                                                    <label htmlFor="chkFortivaOnly" className="mb-0 ml-2 text-secondary">Fortiva Retail Credit</label>
                                                                                </div>
                                                                            </div>
                                                                        </OverlayTrigger>
                                                                    </div>}
                                                                {this.state.danielsApp &&
                                                                    <div className={"col-12  d-flex " + (screenWidth == "col-md-2.5" ? " financialPartner" : screenWidth)}>
                                                                        <OverlayTrigger
                                                                            overlay={<Tooltip>{this.state.alterPopupmessage?.find((item => item.name?.toLowerCase() == "catooltip"))?.description?.split("~`~")[2]}​</Tooltip>}
                                                                            placement="top"
                                                                        >
                                                                            <div className={"form-group d-flex align-items-center justify-content-center radiobtn" + ((isWaterFallEnable ? (fortivaAPIErrorMsg || progUownApplications || this.state.UOwnLeasing || this.state.progressiveLeasing) : this.state.fortivaCredit || fortivaAPIErrorMsg) ? " partnerDisable" : "")}>
                                                                                <div className="form-check form-check-inline mr-0">
                                                                                    <input type="checkbox"
                                                                                        name="chkDanielsOnly"
                                                                                        id="chkDanielsOnly"
                                                                                        onClick={() => this.onDanielsCreditChecked()}
                                                                                        value={this.state.danielsCredit}
                                                                                        checked={this.state.danielsCredit ? "checked" : ""}
                                                                                        disabled={isWaterFallEnable ? (fortivaAPIErrorMsg || progUownApplications || this.state.UOwnLeasing || this.state.progressiveLeasing) : (this.state.fortivaCredit || fortivaAPIErrorMsg) ? true : false}
                                                                                    />
                                                                                    <label htmlFor="chkDanielsOnly" className="mb-0 ml-2 text-secondary">Daniel's Credit</label>
                                                                                </div>
                                                                            </div>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                }
                                                                {this.state.progressiveApp &&
                                                                    <div className={"col-12  d-flex " + (screenWidth == "col-md-2.5" ? " financialPartner" : screenWidth)}>
                                                                        <div className={"form-group d-flex align-items-center justify-content-center radiobtn" + ((isWaterFallEnable ? (this.state.fortivaCredit || fortivaAPIErrorMsg || this.state.danielsCredit || this.state.synchronyCredit) : this.state.fortivaCredit || fortivaAPIErrorMsg) ? " partnerDisable" : "")}>
                                                                            <div className="form-check form-check-inline mr-0">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name="chkPrgLeasing"
                                                                                    id="chkPrgLeasing"
                                                                                    onClick={() => this.onProgressiveLeasingChecked()}
                                                                                    value={this.state.progressiveLeasing}
                                                                                    checked={this.state.progressiveLeasing ? "checked" : ""}
                                                                                    disabled={isWaterFallEnable ? (this.state.fortivaCredit || fortivaAPIErrorMsg || this.state.danielsCredit || this.state.synchronyCredit) : (fortivaAPIErrorMsg || this.state.fortivaCredit) ? true : false}
                                                                                ></input>
                                                                                <label htmlFor="chkPrgLeasing" style={{ margin: "10px" }} className="d-inline text-secondary">
                                                                                    Progressive Leasing
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                {this.state.uownApp &&
                                                                    <div className={"col-12  d-flex " + (screenWidth == "col-md-2.5" ? " financialPartner" : screenWidth)}>
                                                                        <div className={"form-group d-flex align-items-center justify-content-center radiobtn" + ((isWaterFallEnable ? (this.state.fortivaCredit || fortivaAPIErrorMsg || this.state.danielsCredit || this.state.synchronyCredit) : this.state.fortivaCredit || fortivaAPIErrorMsg) ? " partnerDisable" : "")}>
                                                                            <div className="form-check form-check-inline mr-0">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name="chkUownLeasing"
                                                                                    id="chkUownLeasing"
                                                                                    onClick={() => this.onUOwnLeasingChecked()}
                                                                                    value={this.state.UOwnLeasing}
                                                                                    checked={this.state.UOwnLeasing ? "checked" : ""}
                                                                                    disabled={isWaterFallEnable ? (this.state.fortivaCredit || this.state.synchronyCredit || this.state.danielsCredit || fortivaAPIErrorMsg) : (this.state.fortivaCredit || fortivaAPIErrorMsg) ? true : false}
                                                                                />
                                                                                <label htmlFor="chkUownLeasing" style={{ margin: "10px" }} className="d-inline text-secondary">
                                                                                    Uown Leasing
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                            {!this.state.danielsCredit && !this.state.fortivaCredit && !this.state.synchronyCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing &&
                                                                <div style={{ color: "red", paddingBottom: 10 }}>Please select a credit account</div>
                                                            }
                                                        </div>
                                                    </div>
                                                    {/* {this.state.fortivaCredit?
                                                <div className="row m-1 ml-md-0 mr-md-0 mb-md-0 mt-2 mb-0">
                                                    <div className="col-12 p-0 pl-md-3 pr-md-3 ">
                                                        <p className="text-secondary">Complete the Fortiva application to know if you're approved - without any impact to your credit score.If you choose to accept the offer, the information provided to credit bureau(s) may impact your credit score.</p>
                                                    </div>
                                                </div>:""} */}
                                                </>
                                            }

                                            <div className="row m-1 ml-md-0 mr-md-0 mb-md-0 mt-1">
                                                <div className="col-12 p-0 pl-md-3 pr-md-3 ">
                                                    <hr className="bg-secondary mt-5 mb-0" style={{ height: "1px" }}></hr>
                                                    <span className="position-relative m-0 pr-3 text-secondary bg-white h5" style={{ top: "-15px" }}><b>Customer Account Verification</b>
                                                        {this.state.step1 === false ?
                                                            <FontAwesomeIcon icon={faAngleDown} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep1(event); }} />
                                                            :
                                                            <FontAwesomeIcon icon={faAngleUp} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep1(event); }} />
                                                        }
                                                    </span>
                                                    {this.state.step1 === true ? (
                                                        <div>
                                                            <div className="row">
                                                                <div className="col-12 col-md-6 col-lg-3">
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Date of Birth (MM/DD/YYYY)</label>
                                                                        <DatePicker
                                                                            className={!this.state.synchronyCredit ? "form-control" + (dobErr ? ' border-dark-error' : ' border-dark')
                                                                                : "form-control-Synchrony" + (dobErr ? ' border-dark-error' : ' border-dark-Synchrony')}
                                                                            name="txtDob"
                                                                            id="txtDob"
                                                                            placeholderText="Date of Birth (MM/DD/YYYY)"
                                                                            selected={this.state.formObj.dob === "" ? null :
                                                                                new Date(this.state.formObj.dob)}
                                                                            onChange={(event) => this.onDOBChange(event)}
                                                                            dateFormat="MM/dd/yyyy"
                                                                            peekNextMonth
                                                                            maxDate={new Date()}
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            dropdownMode="select"
                                                                            disabled={(!this.state.danielsCredit && !this.state.fortivaCredit && !this.state.synchronyCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing) ? true : this.state.formObj.account ? true : false}
                                                                            customInput={
                                                                                <IMaskInput mask="00/00/0000" />
                                                                            }
                                                                        ></DatePicker>
                                                                        {dobErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{dobErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-6 col-lg-3">
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Social Security Number/ITIN#</label>
                                                                        <IMaskInput
                                                                            mask='000-00-0000'
                                                                            className={!this.state.synchronyCredit ? "form-control" + (ssnErr ? ' border-dark-error' : ' border-dark')
                                                                                : "form-control-Synchrony" + (ssnErr ? ' border-dark-error' : ' border-dark-Synchrony')}
                                                                            name="txtSSN"
                                                                            id="txtSSN"
                                                                            placeholder="Social Security Number/ITIN"
                                                                            onAccept={(value, mask) => this.onSSNChange(value, mask)}
                                                                            value={this.state.formObj.ssn}
                                                                            disabled={(!this.state.danielsCredit && !this.state.fortivaCredit && !this.state.synchronyCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing) ? true : this.state.formObj.account ? true : false}
                                                                        >
                                                                        </IMaskInput>
                                                                        {ssnErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{ssnErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <div className="col-12">
                                                                    <button
                                                                        className="float-right btn bg-secondary text-primary pl-5 pr-5"
                                                                        name="confirmStep1"
                                                                        id="confirmStep1"
                                                                        disabled={(!this.state.danielsCredit && !this.state.fortivaCredit && !this.state.synchronyCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing) ? true : false}
                                                                        onClick={(event) => {
                                                                            this.submitStep1(event);
                                                                        }}
                                                                    >
                                                                        Next</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : ""}
                                                </div>
                                            </div>
                                            <div className="row m-1 ml-md-0 mr-md-0 mb-md-0 mt-1">
                                                <div className="col-12 p-0 pl-md-3 pr-md-3 ">
                                                    <hr className="bg-secondary mt-5 mb-0" style={{ height: "1px" }}></hr>
                                                    <span className="position-relative m-0 pr-3 text-secondary bg-white h5" style={{ top: "-15px" }}><b>Mobile Verification</b>
                                                        {this.state.step2 === false ?
                                                            <FontAwesomeIcon icon={faAngleDown} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep2(event); }} />
                                                            :
                                                            <FontAwesomeIcon icon={faAngleUp} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep2(event); }} />
                                                        }
                                                    </span>
                                                    {this.state.isStep1Complete === true && this.state.step2 === true ? (
                                                        <div>
                                                            <p className="text-secondary">To begin, please provide a mobile phone to send verification code.  Enter received code to verify.</p>

                                                            <div className="row">
                                                                <div className="col-12 col-md-6">
                                                                    <div className="row">
                                                                        <div className="col-7 col-lg-6">
                                                                            <div className="form-group text-left mt-md-2">
                                                                                <label className="text-secondary">Mobile Number
                                                                                    {this.state.synchronyCredit ? (
                                                                                        <OverlayTrigger
                                                                                            overlay={<Tooltip className="customTooltip" id="tooltip-disabled">** You authorize Synchrony Bank ("SYNCB") to contact you at each phone number you have provided. By providing a cell phone number and/or email address, you agree to receive account updates and information, including text messages from SYNCB and the dealers/merchants/retailers that accept the Card. Standard text messaging rates may apply. Phone number not required for hearing impaired applicant.</Tooltip>}
                                                                                            placement="auto"
                                                                                        >
                                                                                            <span className="d-inline-block">
                                                                                                <FontAwesomeIcon className="pl-1" icon={faQuestion} style={{ pointerEvents: 'none' }} />
                                                                                            </span>
                                                                                        </OverlayTrigger>
                                                                                    ) : ""}
                                                                                </label>
                                                                                <input
                                                                                    type="text"
                                                                                    className={!this.state.synchronyCredit ? "form-control" + (mobileNoErr ? ' border-dark-error' : ' border-dark')
                                                                                        : "form-control-Synchrony" + (mobileNoErr ? ' border-dark-error' : ' border-dark-Synchrony')}
                                                                                    name="txtMobileNo"
                                                                                    id="txtMobileNo"
                                                                                    placeholder="Mobile Number *"
                                                                                    onChange={(event) => this.onChange(event)}
                                                                                    value={this.state.formObj.mobileNo}
                                                                                    maxLength="12"
                                                                                    disabled={((this.state.isSMSOverride || this.state.isSMSVerified) || (!this.state.danielsCredit && !this.state.fortivaCredit && !this.state.synchronyCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing)) ? true : false}
                                                                                ></input>

                                                                                {mobileNoErr &&
                                                                                    <div style={{ color: "red", paddingBottom: 10 }}>{mobileNoErr}</div>
                                                                                }
                                                                                {this.state.isSMSError &&
                                                                                    <div style={{ color: "red", paddingBottom: 10 }}>{this.state.isSMSErrorMsg}</div>
                                                                                }
                                                                                {this.state.isMobileNoVerifiedOnSameDay && <div className="pt-3 text-success">Your mobile number is already verified for today.</div>}
                                                                            </div>
                                                                        </div>
                                                                        {!this.state.isMobileNoVerifiedOnSameDay ?
                                                                            !this.state.isStep2Complete &&
                                                                            <div className="col-5 col-lg-4">
                                                                                <div className="form-group text-left mt-md-2">
                                                                                    <label className="text-secondary">&nbsp;</label>
                                                                                    <button
                                                                                        className={"form-control border-dark  p-0" + (!this.state.danielsCredit && !this.state.fortivaCredit && !this.state.synchronyCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing ? " creditBtn" : " bg-secondary text-primary")}
                                                                                        name="mobileNoForOTP"
                                                                                        id=""
                                                                                        onClick={(event) => this.submitMobileNo(event)}
                                                                                        disabled={this.state.thirdPartySessionLink || this.state.SMSLink ? false :
                                                                                            (!this.state.permission_status?.canAdd && !this.state.permission_status?.canEdit) || (!this.state.danielsCredit && !this.state.fortivaCredit && !this.state.synchronyCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing) ? true : false}
                                                                                    >Send Code</button>

                                                                                </div>
                                                                            </div>
                                                                            : null}
                                                                        {!this.state.isMobileNoVerifiedOnSameDay ?
                                                                            this.state.thirdPartySessionLink || this.state.SMSLink ? "" :
                                                                                !this.state.isStep2Complete &&
                                                                                <div className={"offset-7 col-5 offset-lg-6 col-lg-4 " + ((this.state.SMSCodeSent || this.state.isSMSError) ? "" : "d-none")}>
                                                                                    <div className="form-group text-left mt-md-2 mb-0">
                                                                                        <button
                                                                                            className={"form-control border-dark  p-0" + (!this.state.danielsCredit && !this.state.fortivaCredit && !this.state.synchronyCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing ? " creditBtn" : " bg-secondary text-primary")}
                                                                                            name="byPassSMS"
                                                                                            id=""
                                                                                            onClick={(event) => this.BypassSMS(event)}
                                                                                            disabled={this.state.thirdPartySessionLink || this.state.SMSLink ? false :
                                                                                                (!this.state.permission_status?.canAdd && !this.state.permission_status?.canEdit) || (!this.state.danielsCredit && !this.state.fortivaCredit && !this.state.synchronyCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing) ? true : false}
                                                                                        >Bypass SMS</button>
                                                                                    </div>
                                                                                </div>
                                                                            : null}
                                                                    </div>
                                                                </div>
                                                                {!this.state.isMobileNoVerifiedOnSameDay ?
                                                                    <>
                                                                        {(this.state.SMSCodeSent || this.state.isSMSError) &&
                                                                            <div className="col-12 col-md-6">
                                                                                {!this.state.isStep2Complete &&
                                                                                    <div className="row">
                                                                                        <div className="col-7 col-lg-6">
                                                                                            <div className="form-group text-left mt-md-2">
                                                                                                <label className="text-secondary">Verification code</label>
                                                                                                <input type="text"
                                                                                                    placeholder="Verification code"
                                                                                                    className={verificationCodeErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                                                    name="txtVerificationCode" id="txtVerificationCode"
                                                                                                    onChange={(event) => this.onChange(event)}
                                                                                                    value={this.state.formObj.verificationCode}
                                                                                                    maxLength="6"
                                                                                                    ref={(input) => { this.txtVerificationCode = input; }}
                                                                                                    disabled={!this.state.danielsCredit && !this.state.fortivaCredit && !this.state.synchronyCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing ? true : false}
                                                                                                />
                                                                                                {verificationCodeErr &&
                                                                                                    <div style={{ color: "red", paddingBottom: 10 }}>{verificationCodeErr}</div>
                                                                                                }
                                                                                                {this.state.thirdPartyLink &&
                                                                                                    <>
                                                                                                        <div className={((this.state.SMSCodeSent || this.state.isSMSError) ? "" : "d-none")}>
                                                                                                            <div className={(this.state.showTempCode ? "d-none" : "")}>
                                                                                                                <label className="text-secondary">Didn’t receive your code?<u style={{ cursor: "pointer" }} onClick={(event) => { this.thirdPartySMSByPass(event); }}>Click here</u></label>
                                                                                                            </div>
                                                                                                            <div className={(this.state.showTempCode ? "" : "d-none")}>
                                                                                                                <p className="text-secondary">Your temporary code is <b>010101</b>.</p>
                                                                                                                <p className="mb-0 text-danger">This application will be submitted but is considered incomplete until your mobile number is verified. Our credit department will be contacting you soon.</p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </>
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-5 col-lg-3">
                                                                                            <div className="form-group text-left mt-md-2">
                                                                                                <label className="text-secondary">&nbsp;</label>
                                                                                                <button
                                                                                                    name="confirmStep2"
                                                                                                    id="confirmStep2"
                                                                                                    className={"form-control border-dark" + (!this.state.danielsCredit && !this.state.fortivaCredit && !this.state.synchronyCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing ? " creditBtn" : " bg-secondary text-primary")}
                                                                                                    placeholder="Enter Code"
                                                                                                    onClick={(event) => {
                                                                                                        this.submitStep2(event);
                                                                                                    }}
                                                                                                    disabled={this.state.thirdPartySessionLink || this.state.SMSLink ? false :
                                                                                                        (!this.state.permission_status?.canAdd && !this.state.permission_status?.canEdit) || (!this.state.danielsCredit && !this.state.fortivaCredit && !this.state.synchronyCredit && !this.state.progressiveLeasing && !this.state.UOwnLeasing) ? true : false}
                                                                                                >Verify</button>
                                                                                            </div>
                                                                                        </div>

                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        }
                                                                    </>
                                                                    : null}
                                                            </div>
                                                            {this.state.isMobileNoVerifiedOnSameDay ?
                                                                <div className="row mt-4">
                                                                    <div className="col-12">
                                                                        <button
                                                                            className="float-right btn bg-secondary text-primary pl-5 pr-5"
                                                                            name="skipMobVerification"
                                                                            id="skipMobVerification"
                                                                            onClick={(event) => {
                                                                                this.skipMobileVerification(event);
                                                                            }}
                                                                        >
                                                                            Next</button>
                                                                    </div>
                                                                </div>
                                                                : null}
                                                        </div>
                                                    ) : ""}
                                                </div>
                                            </div>
                                            <div className="row m-1 ml-md-0 mr-md-0 mb-md-0 mt-4">
                                                <div className="col-12 p-0 pl-md-3 pr-md-3 ">
                                                    <hr className="bg-secondary mt-5 mb-0" style={{ height: "1px" }}></hr>
                                                    <span className="position-relative m-0 pr-3 text-secondary bg-white h5" style={{ top: "-15px" }}><b>Personal Information</b>
                                                        {this.state.step3 === false ?
                                                            <FontAwesomeIcon icon={faAngleDown} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep3(event); }} />
                                                            :
                                                            <FontAwesomeIcon icon={faAngleUp} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep3(event); }} />
                                                        }
                                                    </span>
                                                    {this.state.isStep2Complete === true && this.state.step3 === true ? (
                                                        <div>
                                                            {this.state.thirdPartySessionLink || this.state.SMSLink ? null :
                                                                <div className="row">

                                                                    <div className="col-12 col-md-6 col-lg-3">
                                                                        <div className="form-group text-left mt-md-2">
                                                                            <label className="text-secondary">Store Code</label>

                                                                            <select id="cmbStoreCode" name="cmbStoreCode" value={JSON.parse(localStorage.getItem("associateStores"))} className="form-select p-2" disabled={true}>
                                                                                <option value="0">-- Select --</option>
                                                                                {JSON.parse(sessionStorage.getItem("storeList"))?.map((storeCode) => <option value={storeCode.code} selected={(this.state.formObj.storeCode === "0" ? JSON.parse(localStorage.getItem("associateStores")) == storeCode.code : this.state.formObj.storeCode == storeCode.code) ? "selected" : ""}>{storeCode.code}</option>)}
                                                                            </select>
                                                                            {storeCodeErr &&
                                                                                <div style={{ color: "red", paddingBottom: 10 }}>{storeCodeErr}</div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                            <div className="row">
                                                                <div className="col-12 col-md-6 col-lg-3">
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">First Name</label>
                                                                        <input
                                                                            type="text"
                                                                            className={!this.state.synchronyCredit ? "form-control" + (firstNameErr ? ' border-dark-error' : ' border-dark')
                                                                                : "form-control-Synchrony" + (firstNameErr ? ' border-dark-error' : ' border-dark-Synchrony')}
                                                                            name="txtFirstName"
                                                                            id="txtFirstName"
                                                                            placeholder="First Name"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.firstName}
                                                                            maxLength="200"
                                                                            disabled={sessionStorage.getItem("isNewApplication") == "true" ? false : true}
                                                                        ></input>
                                                                        {firstNameErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{firstNameErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3"}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Middle Name (Optional)</label>
                                                                        <input
                                                                            type="text"
                                                                            className={!this.state.synchronyCredit ? "form-control border-dark" : "form-control-Synchrony border-dark-Synchrony"}
                                                                            name="txtMiddleName"
                                                                            id="txtMiddleName"
                                                                            placeholder="Middle Name (Optional)"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.middleName}
                                                                            maxLength="200"
                                                                            disabled={sessionStorage.getItem("isNewApplication") == "true" ? false : true}
                                                                        ></input>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-6 col-lg-3">
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Last Name</label>
                                                                        <input
                                                                            type="text"
                                                                            className={!this.state.synchronyCredit ? "form-control" + (lastNameErr ? ' border-dark-error' : ' border-dark')
                                                                                : "form-control-Synchrony" + (lastNameErr ? ' border-dark-error' : ' border-dark-Synchrony')}
                                                                            name="txtLastName"
                                                                            id="txtLastName"
                                                                            placeholder="Last Name"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.lastName}
                                                                            maxLength="200"
                                                                            disabled={sessionStorage.getItem("isNewApplication") == "true" ? false : true}
                                                                        ></input>
                                                                        {lastNameErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{lastNameErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Suffix (Optional)</label>

                                                                        <select id="cmbSuffix" name="cmbSuffix" className="form-select p-2" onChange={(event) => this.onChange(event)}>
                                                                            <option value="0">-- Select --</option>
                                                                            {this.state.formObj.lstSuffix.map((suffix) => <option value={suffix.id} selected={this.state.formObj.suffix == suffix.id ? "selected" : ""}>{suffix.description}</option>)}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 col-md-6 col-lg-3">
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Mailing Address
                                                                            {this.state.fortivaCredit ? (
                                                                                <OverlayTrigger
                                                                                    overlay={<Tooltip className="customTooltip" id="tooltip-disabled">Under federal law, a physical mailing address is required for Identification purposes and to process your acceptance.​</Tooltip>}
                                                                                    placement="right"
                                                                                >
                                                                                    <span className="d-inline-block">
                                                                                        <FontAwesomeIcon className="pl-2 pr-2 pt-1 pb-1 border border-dark rounded-circle" icon={faQuestion} style={{ pointerEvents: 'none' }} />
                                                                                    </span>
                                                                                </OverlayTrigger>
                                                                            ) : ""}
                                                                        </label>
                                                                        {!this.state.addressAutoFillEnable === true ?
                                                                            <input
                                                                                type="text"
                                                                                className={!this.state.synchronyCredit ? "form-control" + (mailingAdrErr ? ' border-dark-error' : ' border-dark')
                                                                                    : "form-control-Synchrony" + (mailingAdrErr ? ' border-dark-error' : ' border-dark-Synchrony')}
                                                                                name="txtMailingAdr"
                                                                                id="txtMailingAdr"
                                                                                placeholder="Mailing Address"
                                                                                onChange={(event) => this.onChange(event)}
                                                                                value={this.state.formObj.mailingAdr}
                                                                                maxLength="500"
                                                                            ></input>
                                                                            :
                                                                            <Autocomplete
                                                                                items={this.state.allAddress}
                                                                                shouldItemRender={(item, value) => item?.fullAddress?.toLowerCase()?.indexOf(value?.toLowerCase()) > -1}
                                                                                getItemValue={item => item?.AddressKey}
                                                                                renderItem={(item, isHighlighted) =>
                                                                                    <div key={item?.AddressKey}>
                                                                                        <p style={{ background: isHighlighted ? '#007bff' : 'white', color: isHighlighted ? 'white' : '#1b1b1b', padding: "1px 5px" }} className="mb-0">{item.fullAddress}</p>
                                                                                    </div>
                                                                                }
                                                                                wrapperProps={{ style: { width: '100%', display: 'inline-block' } }}
                                                                                menuStyle={{
                                                                                    borderRadius: '5px',
                                                                                    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                                                                                    background: 'white',
                                                                                    padding: '3px 3px',
                                                                                    position: 'absolute',
                                                                                    maxHeight: mailingAdrErr === undefined || mailingAdrErr == "" ? '200%' : '120%',
                                                                                    overflow: 'auto',
                                                                                    zIndex: '100',
                                                                                    top: mailingAdrErr === undefined || mailingAdrErr == "" ? '85%' : '55%',
                                                                                    left: '4%',
                                                                                }}
                                                                                value={this.state.formObj.mailingAdr}
                                                                                onChange={e => { this.setState({ formObj: { ...this.state.formObj, mailingAdr: e.target.value } }, () => { this.trackChanges(); }); this.loadAddress(e.target.value) }}
                                                                                onSelect={(val) => { this.autoFill(val) }}
                                                                                inputProps={{
                                                                                    placeholder: 'Mailing Address',
                                                                                    className: "form-control border-dark autoAddressField"
                                                                                }}
                                                                            />
                                                                        }
                                                                        {mailingAdrErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{mailingAdrErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-2"}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Apt/Unit (As Needed)</label>
                                                                        {!this.state.addressAutoFillEnable === true ?
                                                                            <input
                                                                                type="text"
                                                                                className={!this.state.synchronyCredit ? "form-control" + (aptUnitErr ? ' border-dark-error' : ' border-dark')
                                                                                    : "form-control-Synchrony" + (aptUnitErr ? ' border-dark-error' : ' border-dark-Synchrony')}
                                                                                name="txtAptUnit"
                                                                                id="txtAptUnit"
                                                                                placeholder="Apt/Unit (As Needed)"
                                                                                onChange={(event) => this.onChange(event)}
                                                                                value={this.state.formObj.aptUnit}
                                                                                maxLength="100"
                                                                            ></input>
                                                                            :
                                                                            <Autocomplete
                                                                                items={this.state.allAptUnit}
                                                                                shouldItemRender={(item, value) => item?.toLowerCase()?.indexOf(value?.toLowerCase()) > -1}
                                                                                getItemValue={item => item}
                                                                                renderItem={(item, isHighlighted) =>
                                                                                    <div key={item}>
                                                                                        <p style={{ background: isHighlighted ? '#007bff' : 'white', color: isHighlighted ? 'white' : '#1b1b1b', padding: "1px 5px" }} className="mb-0">{item}</p>
                                                                                    </div>
                                                                                }
                                                                                wrapperProps={{ style: { width: '100%', display: 'inline-block' } }}
                                                                                menuStyle={{
                                                                                    borderRadius: '5px',
                                                                                    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                                                                                    background: 'white',
                                                                                    padding: '3px 3px',
                                                                                    position: 'absolute',
                                                                                    maxHeight: '200%',
                                                                                    overflow: 'auto',
                                                                                    zIndex: '100',
                                                                                    top: '85%',
                                                                                    left: '4%',
                                                                                }}
                                                                                value={this.state.formObj.aptUnit}
                                                                                onChange={e => this.setState({ formObj: { ...this.state.formObj, aptUnit: e.target.value } }, () => { this.trackChanges(); })}
                                                                                onSelect={(val) => this.setState({ formObj: { ...this.state.formObj, aptUnit: val } })}
                                                                                inputProps={{
                                                                                    placeholder: "Apt/Unit (As Needed)",
                                                                                    className: ("form-control" + (aptUnitErr ? ' border-dark-error' : ' border-dark')),
                                                                                    name: "txtAptUnit",
                                                                                    id: "txtAptUnit"
                                                                                }}
                                                                            />
                                                                        }
                                                                        {aptUnitErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{aptUnitErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3"}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">City</label>

                                                                        <input
                                                                            type="text"
                                                                            className={"form-control" + (cityErr ? ' border-dark-error' : ' border-dark')}
                                                                            name="txtCity"
                                                                            id="txtCity"
                                                                            placeholder="City"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.city}
                                                                            maxLength="100"
                                                                        ></input>
                                                                        {cityErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{cityErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-2"}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">State</label>

                                                                        <select id="cmbState" name="cmbState"
                                                                            className={"form-select p-2" + (stateErr ? ' border-dark-error' : ' form-select-border')}
                                                                            onChange={(event) => this.onChange(event)}>
                                                                            <option value="0">-- Select --</option>
                                                                            {this.state.formObj.lstState.map((state) => <option value={state.id} selected={this.state.thirdPartySessionLink === true && isNaN(this.state.formObj.state) ? this.state.formObj.state.toLowerCase() == state.description.toLowerCase() ? "selected" : "" : this.state.formObj.state == state.id ? "selected" : ""}>{state.description}</option>)}
                                                                        </select>
                                                                        {stateErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{stateErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-6 col-lg-2">
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Zip Code</label>

                                                                        <input
                                                                            type="text"
                                                                            className={!this.state.synchronyCredit ? "form-control" + (zipCodeErr ? ' border-dark-error' : ' border-dark')
                                                                                : "form-control-Synchrony" + (zipCodeErr ? ' border-dark-error' : ' border-dark-Synchrony')}
                                                                            name="txtZipCode"
                                                                            id="txtZipCode"
                                                                            placeholder="Zip Code"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.zipCode}
                                                                            maxLength="5"
                                                                        ></input>
                                                                        {zipCodeErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{zipCodeErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Housing Information</label>
                                                                        <select id="cmbHousingInfo" name="cmbHousingInfo"
                                                                            className={!this.state.synchronyCredit ? "form-select p-2" + (housingInfoErr ? ' border-dark-error' : ' form-select-border')
                                                                                : "form-select-Synchrony p-2" + (housingInfoErr ? ' border-dark-error' : ' form-select-Synchrony-border')}
                                                                            onChange={(event) => this.onChange(event)}>
                                                                            <option value="0">-- Select --</option>
                                                                            {this.state.formObj.lstHousingInfo.map((housingInfo) => <option value={housingInfo.id} selected={this.state.formObj.housingInfo == housingInfo.id ? "selected" : ""}>{housingInfo.description}</option>)}
                                                                        </select>
                                                                        {housingInfoErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{housingInfoErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Secondary Phone (Optional)</label>

                                                                        <input
                                                                            type="text"
                                                                            className="form-control border-dark"
                                                                            name="txtSecPhone"
                                                                            id="txtSecPhone"
                                                                            placeholder="Secondary Phone (Optional)"
                                                                            value={this.state.formObj.secPhone}
                                                                            onChange={(event) => this.onChange(event)}
                                                                            maxLength="12"
                                                                        ></input>
                                                                        {secPhoneErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{secPhoneErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3"}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Email Address
                                                                            {this.state.fortivaCredit ? (
                                                                                <OverlayTrigger
                                                                                    overlay={<Tooltip className="customTooltip" id="tooltip-disabled">Important information will be sent to the email address provided.  Are you sure this is your correct email address?  If not, please update your email address at this time.</Tooltip>}
                                                                                    placement="right"
                                                                                >
                                                                                    <span className="d-inline-block">
                                                                                        <FontAwesomeIcon className="pl-2 pr-2 pt-1 pb-1 border border-dark rounded-circle" icon={faQuestion} style={{ pointerEvents: 'none' }} />
                                                                                    </span>
                                                                                </OverlayTrigger>
                                                                            ) : ""}
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className={emailAdrErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                            name="txtEmailAdr"
                                                                            id="txtEmailAdr"
                                                                            placeholder="Email Address"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.emailAdr}
                                                                            maxLength="100"
                                                                        ></input>
                                                                        {emailAdrErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{emailAdrErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <div className="col-12">

                                                                    <button
                                                                        className="float-right btn bg-secondary text-primary pl-5 pr-5"
                                                                        name="confirmStep3"
                                                                        id="confirmStep3"
                                                                        onClick={(event) => {
                                                                            this.submitStep3(event);
                                                                        }}
                                                                    >
                                                                        Next</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : ""}
                                                </div>
                                            </div>

                                            <div className="row m-1 ml-md-0 mr-md-0 mb-md-0 mt-4">
                                                <div className="col-12 p-0 pl-md-3 pr-md-3 ">
                                                    <hr className="bg-secondary mt-5 mb-0" style={{ height: "1px" }}></hr>
                                                    <span className="position-relative m-0 pr-3 text-secondary bg-white h5" style={{ top: "-15px" }}><b>Employment</b>
                                                        {this.state.step4 === false ?
                                                            <FontAwesomeIcon icon={faAngleDown} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep4(event); }} />
                                                            :
                                                            <FontAwesomeIcon icon={faAngleUp} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep4(event); }} />
                                                        }
                                                    </span>
                                                    {this.state.isStep3Complete === true && this.state.step4 === true ? (
                                                        <div>
                                                            <div className="row">
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.danielsCredit || this.state.UOwnLeasing ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Employer's Name</label>
                                                                        <input
                                                                            type="text"
                                                                            className={empNameErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                            name="txtEmpName"
                                                                            id="txtEmpName"
                                                                            placeholder="Employer's Name"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.empName}
                                                                            maxLength="200"
                                                                        ></input>
                                                                        {empNameErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{empNameErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.danielsCredit ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Type of Work/Job Duties</label>
                                                                        <input
                                                                            type="text"
                                                                            className={dutiesErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                            name="txtDuties"
                                                                            id="txtDuties"
                                                                            placeholder="Type of Work/Job Duties"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.duties}
                                                                            maxLength="500"
                                                                        ></input>
                                                                        {dutiesErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{dutiesErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.danielsCredit ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Employment Start Date (MM/YYYY)</label>
                                                                        <DatePicker
                                                                            className={empStartDateErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                            name="txtEmpStartDate"
                                                                            id="txtEmpStartDate"
                                                                            placeholderText="Start Date (MM/YYYY)"
                                                                            selected={this.state.formObj.empStartDate === "" ? null :
                                                                                new Date(this.state.formObj.empStartDate.split('/')[1], parseInt(this.state.formObj.empStartDate.split('/')[0]) - 1)}
                                                                            onChange={(event) => this.onStartDateChange(event)}
                                                                            dateFormat="MM/yyyy"
                                                                            showMonthYearPicker
                                                                            maxDate={new Date()}
                                                                            customInput={
                                                                                <IMaskInput mask="00/0000" />
                                                                            }
                                                                        />
                                                                        {empStartDateErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{empStartDateErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-6 col-lg-3">
                                                                    <div className="form-group text-left mt-md-2">

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Employer's Phone Number</label>

                                                                        <input
                                                                            type="text"
                                                                            className={!this.state.synchronyCredit ? "form-control" + (empPhoneNoErr ? ' border-dark-error' : ' border-dark')
                                                                                : "form-control-Synchrony" + (empPhoneNoErr ? ' border-dark-error' : ' border-dark-Synchrony')}
                                                                            name="txtEmpPhoneNo"
                                                                            id="txtEmpPhoneNo"
                                                                            placeholder="Employer's Phone Number"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.empPhoneNo}
                                                                            maxLength="12"
                                                                        ></input>
                                                                        {empPhoneNoErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{empPhoneNoErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div className="col-12 col-md-6 col-lg-3">
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Monthly Net Income(from all sources)
                                                                            {this.state.synchronyCredit || this.state.fortivaCredit ? (
                                                                                <OverlayTrigger
                                                                                    overlay={
                                                                                        <Tooltip className="customTooltip" id="tooltip-disabled">
                                                                                            {this.state.synchronyCredit ?
                                                                                                <><p className="mb-0"><b>Synchrony Disclosure</b></p>** Alimony, child support or separate maintenance income need not be included unless relied upon for credit. You may include the monthly amount that you have available to spend from your assets. <b>MARRIED Wisconsin Residents only</b>: If you are applying for an individual account and your spouse also is a WI resident, combine your and your spouse’s financial information.</>
                                                                                                : null
                                                                                            }
                                                                                            {this.state.fortivaCredit ?
                                                                                                <><p className="mb-0"><b>Fortiva Disclosure</b></p>Alimony, child support or separate maintenance income need not be included if you do not wish to have it considered as a basis for repaying this obligation.
                                                                                                    <b>Wisconsin Married Residents</b>: Combine your and your spouse’s information on this application.</>
                                                                                                : null
                                                                                            }
                                                                                        </Tooltip>
                                                                                    }
                                                                                    placement="bottom"
                                                                                >
                                                                                    <span className="d-inline-block">
                                                                                        <FontAwesomeIcon className={((this.state.synchronyCredit && this.state.fortivaCredit) ? "pl-2 pr-2 pt-1 pb-1 border border-dark rounded-circle" : (this.state.synchronyCredit ? "pl-1" : "pl-2 pr-2 pt-1 pb-1 border border-dark rounded-circle"))} icon={faQuestion} style={{ pointerEvents: 'none' }} />
                                                                                    </span>
                                                                                </OverlayTrigger>
                                                                            ) : ""}
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className={!this.state.synchronyCredit ? "form-control" + (netIncomeErr ? ' border-dark-error' : ' border-dark')
                                                                                : "form-control-Synchrony" + (netIncomeErr ? ' border-dark-error' : ' border-dark-Synchrony')}
                                                                            name="txtNetIncome"
                                                                            id="txtNetIncome"
                                                                            placeholder="Monthly Net Income(from all sources) **"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.netIncome}
                                                                            maxLength="5"
                                                                        ></input>

                                                                        {netIncomeErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{netIncomeErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div className="col-12 col-md-6 col-lg-3">
                                                                    <div className="form-group text-left mt-md-2">

                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-6 col-lg-3">
                                                                    <div className="form-group text-left mt-md-2">

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">



                                                            </div>
                                                            <div className="row mt-4">
                                                                <div className="col-12">

                                                                    <button
                                                                        className="float-right btn bg-secondary text-primary pl-5 pr-5"
                                                                        name="confirmStep4"
                                                                        id="confirmStep4"
                                                                        onClick={(event) => {
                                                                            this.submitStep4(event);
                                                                        }}
                                                                    >
                                                                        Next</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : ""}
                                                </div>
                                            </div>

                                            <div className="row m-1 ml-md-0 mr-md-0 mb-md-0 mt-4">
                                                <div className="col-12 p-0 pl-md-3 pr-md-3 ">
                                                    <hr className="bg-secondary mt-5 mb-0" style={{ height: "1px" }}></hr>
                                                    <span className="position-relative m-0 pr-3 text-secondary bg-white h5" style={{ top: "-15px" }}><b>Identification</b>
                                                        {this.state.step5 === false ?
                                                            <FontAwesomeIcon icon={faAngleDown} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep5(event); }} />
                                                            :
                                                            <FontAwesomeIcon icon={faAngleUp} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep5(event); }} />
                                                        }
                                                    </span>
                                                    {this.state.isStep4Complete === true && this.state.step5 === true ? (
                                                        <div>
                                                            <div className="row">
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Primary ID Type
                                                                            {this.state.thirdPartySessionLink || this.state.SMSLink ? "" :
                                                                                <OverlayTrigger
                                                                                    overlay={<Tooltip className="customTooltip" id="tooltip-disabled"><div>
                                                                                        <table style={{ width: "100%" }}>
                                                                                            <tr>
                                                                                                <th style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}></th>
                                                                                                <th style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}>Daniels</th>
                                                                                                <th style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}>Synchrony</th>
                                                                                                <th style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}>Progressive</th>
                                                                                                <th style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}>Uown</th>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}>Primary ID</td>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}><FontAwesomeIcon icon={faCheck} /></td>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}><FontAwesomeIcon icon={faCheck} /></td>
                                                                                                <td rowspan="7" style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}>Primary ID not required</td>
                                                                                                <td rowspan="7" style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}>Primary ID not required</td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}>State Issued ID</td>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}><FontAwesomeIcon icon={faCheck} /></td>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}><FontAwesomeIcon icon={faCheck} /></td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}>Driver's License</td>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}><FontAwesomeIcon icon={faCheck} /></td>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}><FontAwesomeIcon icon={faCheck} /></td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}>Military ID</td>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}><FontAwesomeIcon icon={faCheck} /></td>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}><FontAwesomeIcon icon={faCheck} /></td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}>Resident Alien</td>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}><FontAwesomeIcon icon={faCheck} /></td>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}><FontAwesomeIcon icon={faCheck} /></td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}>Consular ID</td>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}><FontAwesomeIcon icon={faCheck} /></td>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}>not accepted</td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}>Passport</td>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}><FontAwesomeIcon icon={faCheck} /></td>
                                                                                                <td style={{ backgroundColor: "#1B1B1B", color: "white", border: "1px solid white" }}><FontAwesomeIcon icon={faCheck} /></td>
                                                                                            </tr>
                                                                                        </table></div>
                                                                                    </Tooltip>}
                                                                                    placement="auto">
                                                                                    <span className="d-inline-block">
                                                                                        <FontAwesomeIcon className="pl-1" icon={faQuestion} style={{ pointerEvents: 'none' }} />
                                                                                    </span>
                                                                                </OverlayTrigger>
                                                                            }
                                                                        </label>
                                                                        <select id="cmbPrimaryIdType" name="cmbPrimaryIdType"
                                                                            className={"form-select p-2" + (primaryIdTypeErr ? ' border-dark-error' : ' form-select-border')}
                                                                            onChange={(event) => this.onChange(event)}>
                                                                            <option value="0">-- Select --</option>
                                                                            {this.state.formObj.lstPrimaryIdType.map((primaryIdType) => <option value={primaryIdType.id} selected={this.state.formObj.primaryIdType == primaryIdType.id ? "selected" : ""}>{primaryIdType.description}</option>)}
                                                                        </select>
                                                                        {primaryIdTypeErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{primaryIdTypeErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.danielsCredit || this.state.progressiveLeasing || (this.state.nonSynchronyCD && this.state.synchronyCredit) ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Primary ID Number</label>
                                                                        <input
                                                                            type="text"
                                                                            className={primaryIdNoErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                            name="txtPrimaryIdNo"
                                                                            id="txtPrimaryIdNo"
                                                                            placeholder="Primary ID Number"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.primaryIdNo}
                                                                            maxLength="50"
                                                                        ></input>
                                                                        {primaryIdNoErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{primaryIdNoErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.danielsCredit || (this.state.nonSynchronyCD && this.state.synchronyCredit) ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Primary ID State</label>

                                                                        <select id="cmbPrimaryIdState" name="cmbPrimaryIdState"
                                                                            className={"form-select p-2" + (primaryIdStateErr ? ' border-dark-error' : ' form-select-border')}
                                                                            onChange={(event) => this.onChange(event)}>
                                                                            <option value="0">-- Select --</option>
                                                                            {this.state.formObj.lstPrimaryIdState.map((primaryIdState) => <option value={primaryIdState.id} selected={this.state.formObj.primaryIdState == primaryIdState.id ? "selected" : ""}>{primaryIdState.description}</option>)}
                                                                        </select>
                                                                        {primaryIdStateErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{primaryIdStateErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <div className="col-12">
                                                                    <button
                                                                        className="float-right btn bg-secondary text-primary pl-5 pr-5"
                                                                        name="confirmStep5"
                                                                        id="confirmStep5"
                                                                        onClick={(event) => {
                                                                            this.submitStep5(event);
                                                                        }}
                                                                    >
                                                                        Next</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : ""}
                                                </div>
                                            </div>
                                            <div className="row m-1 ml-md-0 mr-md-0 mb-md-0 mt-4">
                                                <div className="col-12 p-0 pl-md-3 pr-md-3 ">
                                                    <hr className="bg-secondary mt-5 mb-0" style={{ height: "1px" }}></hr>
                                                    <span className="position-relative m-0 pr-3 text-secondary bg-white h5" style={{ top: "-15px" }}><b>Daniel's Credit Required Fields</b>
                                                        {this.state.step6 === false ?
                                                            <FontAwesomeIcon icon={faAngleDown} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep6(event); }} />
                                                            :
                                                            <FontAwesomeIcon icon={faAngleUp} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep6(event); }} />
                                                        }
                                                    </span>
                                                    {this.state.isStep5Complete === true && this.state.step6 === true ? (
                                                        <div>
                                                            <div className="row">
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.danielsCredit ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Nearest Relative Name</label>
                                                                        <input
                                                                            type="text"
                                                                            className={relativeNameErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                            name="txtRelativeName"
                                                                            id="txtRelativeName"
                                                                            placeholder="Nearest Relative Name"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.relativeName}
                                                                            maxLength="200"
                                                                        ></input>
                                                                        {relativeNameErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{relativeNameErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.danielsCredit ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Nearest Relative Phone</label>

                                                                        <input
                                                                            type="text"
                                                                            className={relativePhoneErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                            name="txtRelativePhone"
                                                                            id="txtRelativePhone"
                                                                            placeholder="Nearest Relative Phone"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.relativePhone}
                                                                            maxLength="12"
                                                                        ></input>
                                                                        {relativePhoneErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{relativePhoneErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.danielsCredit ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Nearest Relative Relationship</label>
                                                                        <input
                                                                            type="text"
                                                                            className={relativeRelationErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                            name="txtRelativeRelation"
                                                                            id="txtRelativeRelation"
                                                                            placeholder="Nearest Relative Relationship"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.relativeRelation}
                                                                            maxLength="200"
                                                                        ></input>
                                                                        {relativeRelationErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{relativeRelationErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <div className="col-12">

                                                                    <button
                                                                        className="float-right btn bg-secondary text-primary pl-5 pr-5"
                                                                        name="confirmStep6"
                                                                        id="confirmStep6"
                                                                        onClick={(event) => {
                                                                            this.submitStep6(event);
                                                                        }}
                                                                    >
                                                                        Next</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : ""}
                                                </div>
                                            </div>
                                            <div className={"row m-1 ml-md-0 mr-md-0 mb-md-0 mt-4 " + ((this.state.thirdPartySessionLink || this.state.SMSLink) ? "d-none" : (this.state.nonSynchronyCD && this.state.synchronyCredit) ? " " : " d-none")}>
                                                <div className="col-12 p-0 pl-md-3 pr-md-3 ">
                                                    <hr className="bg-secondary mt-5 mb-0" style={{ height: "1px" }}></hr>
                                                    <span className="position-relative m-0 pr-3 text-secondary bg-white h5" style={{ top: "-15px" }}><b>Synchrony Required Fields</b>
                                                        {this.state.step7 === false ?
                                                            <FontAwesomeIcon icon={faAngleDown} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep7(event); }} />
                                                            :
                                                            <FontAwesomeIcon icon={faAngleUp} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep7(event); }} />
                                                        }
                                                    </span>
                                                    {this.state.isStep6Complete === true && this.state.step7 === true ? (
                                                        <div>
                                                            <div className="row">
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.synchronyCredit ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Primary ID Expiration Date (MM/YYYY)</label>
                                                                        <DatePicker
                                                                            className={primaryIdExpiryDateErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                            name="txtPrimaryIdExpiryDate"
                                                                            id="txtPrimaryIdExpiryDate"
                                                                            placeholderText="Primary ID Expiration date (MM/YYYY)"
                                                                            selected={this.state.formObj.primaryIdExpiryDate === "" ? null :
                                                                                new Date(this.state.formObj.primaryIdExpiryDate.split('/')[1], parseInt(this.state.formObj.primaryIdExpiryDate.split('/')[0]) - 1, new Date().getDate())}
                                                                            onChange={(event) => this.onPrimaryIdExpiryDateChange(event)}
                                                                            dateFormat="MM/yyyy"
                                                                            showMonthYearPicker
                                                                            minDate={new Date(new Date().getFullYear(), new Date().getMonth(), "01")}
                                                                            customInput={
                                                                                <IMaskInput mask="00/0000" />
                                                                            }
                                                                        />
                                                                        {primaryIdExpiryDateErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{primaryIdExpiryDateErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.synchronyCredit ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Second ID Type</label>
                                                                        <select id="cmbSecondIdType" name="cmbSecondIdType"
                                                                            className={"form-select p-2" + (secondIdTypeErr ? ' border-dark-error' : ' form-select-border') + (sameSecondIdTypeErr ? ' border-dark-error' : ' form-select-border')}
                                                                            onChange={(event) => this.onChange(event)}>
                                                                            <option value="0">-- Select --</option>
                                                                            {this.state.formObj.lstSecondIdType.map((secondIdType) => <option value={secondIdType.id} selected={this.state.formObj.secondIdType == secondIdType.id ? "selected" : ""}>{secondIdType.description}</option>)}
                                                                        </select>
                                                                        {secondIdTypeErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{secondIdTypeErr}</div>
                                                                        }
                                                                        {sameSecondIdTypeErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{sameSecondIdTypeErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.synchronyCredit ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Second ID Issued By</label>

                                                                        <input
                                                                            type="text"
                                                                            className={"form-control" + (secondIdIssuedByErr ? ' border-dark-error' : ' border-dark')}
                                                                            name="txtSecondIdIssuedBy"
                                                                            placeholder="Second ID Issued By"
                                                                            id="txtSecondIdIssuedBy"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.secondIdIssuedBy}
                                                                            maxLength="20"
                                                                        ></input>

                                                                        {secondIdIssuedByErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{secondIdIssuedByErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.synchronyCredit ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Second ID Expiration Date (MM/YYYY)</label>

                                                                        <DatePicker
                                                                            className={secondIdExpiryDateErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                            name="txtSecondIdExpiryDate"
                                                                            id="txtSecondIdExpiryDate"
                                                                            placeholderText="Second ID Expiration Date (MM/YYYY)"
                                                                            selected={this.state.formObj.secondIdExpiryDate === "" ? null :
                                                                                new Date(this.state.formObj.secondIdExpiryDate.split('/')[1], parseInt(this.state.formObj.secondIdExpiryDate.split('/')[0]) - 1, new Date().getDate())}
                                                                            onChange={(event) => this.onSecondIdExpiryDateChange(event)}
                                                                            dateFormat="MM/yyyy"
                                                                            showMonthYearPicker
                                                                            minDate={new Date(new Date().getFullYear(), new Date().getMonth(), "01")}
                                                                            customInput={
                                                                                <IMaskInput mask="00/0000" />
                                                                            }
                                                                        />
                                                                        {secondIdExpiryDateErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{secondIdExpiryDateErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-6 col-lg-3">
                                                                    <div className="form-group text-left mt-md-2">

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <div className="col-12">

                                                                    <button
                                                                        className="float-right btn bg-secondary text-primary pl-5 pr-5"
                                                                        name="confirmStep6"
                                                                        id="confirmStep6"
                                                                        onClick={(event) => {
                                                                            this.submitStep7(event);
                                                                        }}
                                                                    >
                                                                        Next</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : ""}
                                                </div>
                                            </div>
                                            <div className={"row m-1 ml-md-0 mr-md-0 mb-md-0 mt-4 " + ((this.state.thirdPartySessionLink || this.state.SMSLink) ? "d-none" : "")}>
                                                <div className="col-12 p-0 pl-md-3 pr-md-3 ">
                                                    <hr className="bg-secondary mt-5 mb-0" style={{ height: "1px" }}></hr>
                                                    <span className="position-relative m-0 pr-3 text-secondary bg-white h5" style={{ top: "-15px" }}><b>Progressive Required Fields</b>
                                                        {this.state.step7 === false ?
                                                            <FontAwesomeIcon icon={faAngleDown} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep8(event); }} />
                                                            :
                                                            <FontAwesomeIcon icon={faAngleUp} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep8(event); }} />
                                                        }
                                                    </span>
                                                    {((this.state.nonSynchronyCD && this.state.synchronyCredit) ? this.state.isStep6Complete : this.state.isStep5Complete) === true && this.state.step7 === true ? (
                                                        <div>
                                                            <div className="row">
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.progressiveLeasing === true ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Bank Routing Number (9 digits)</label>
                                                                        <input
                                                                            type="text"
                                                                            placeholder="Bank Routing Number (9 digits)"
                                                                            className={bankRouteNoErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                            name="txtBankRouteNo"
                                                                            id="txtBankRouteNo"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.bankRouteNo}
                                                                            maxLength="9"
                                                                        ></input>
                                                                        {bankRouteNoErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{bankRouteNoErr}</div>
                                                                        }
                                                                        {this.state.ABAError &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{this.state.ABAError}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.progressiveLeasing === true ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Checking Account Number</label>
                                                                        <input
                                                                            type="text"
                                                                            placeholder="Checking account number"
                                                                            className={checkAccNoErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                            name="txtCheckAccNo"
                                                                            id="txtCheckAccNo"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.checkAccNo}
                                                                            maxLength="200"
                                                                        ></input>
                                                                        {checkAccNoErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{checkAccNoErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.progressiveLeasing === true ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">How often are you paid?</label>
                                                                        <select id="cmbOftenPaid" name="cmbOftenPaid"
                                                                            className={"form-select p-2" + (oftenPaidErr ? ' border-dark-error' : ' form-select-border')}
                                                                            onChange={(event) => this.onChange(event)}>
                                                                            <option value="0">-- Select --</option>
                                                                            {this.state.formObj.lstOftenPaid.map((oftenPaid) => <option value={oftenPaid.id} selected={this.state.formObj.oftenPaid == oftenPaid.id ? "selected" : ""}>{oftenPaid.description}</option>)}
                                                                        </select>
                                                                        {oftenPaidErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{oftenPaidErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.progressiveLeasing === true ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Last Pay Day (MM/DD/YYYY)</label>
                                                                        <DatePicker
                                                                            className={"form-control" + (lastPayDayErr ? ' border-dark-error' : ' border-dark')}
                                                                            name="txtLastPayDay"
                                                                            id="txtLastPayDay"
                                                                            placeholderText="Last Pay Day (MM/DD/YYYY)"
                                                                            selected={this.state.formObj.lastPayDay === "" ? null :
                                                                                new Date(this.state.formObj.lastPayDay)}
                                                                            onChange={(event) => this.onLastPayDayChange(event)}
                                                                            dateFormat="MM/dd/yyyy"
                                                                            maxDate={new Date()}
                                                                            peekNextMonth
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            dropdownMode="select"
                                                                            customInput={
                                                                                <IMaskInput mask="00/00/0000" />
                                                                            }
                                                                        />
                                                                        {lastPayDayErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{lastPayDayErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                {<div className={"col-12 col-md-6 col-lg-3" + (this.state.progressiveLeasing === true ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Next Pay Day (MM/DD/YYYY)</label>
                                                                        <DatePicker
                                                                            className={"form-control" + (nextPayDayErr ? ' border-dark-error' : ' border-dark')}
                                                                            name="txtNextPayDay"
                                                                            id="txtNextPayDay"
                                                                            placeholderText="Next Pay Day (MM/DD/YYYY)"
                                                                            selected={this.state.formObj.nextPayDay === "" ? null :
                                                                                new Date(this.state.formObj.nextPayDay)}
                                                                            onChange={(event) => this.onNextPayDayChange(event)}
                                                                            dateFormat="MM/dd/yyyy"
                                                                            minDate={this.state.formObj.lastPayDay === "" ? new Date() : new Date(this.state.formObj.lastPayDay)}
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            dropdownMode="select"
                                                                            customInput={
                                                                                <IMaskInput mask="00/00/0000" />
                                                                            }
                                                                        />
                                                                        {nextPayDayErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{nextPayDayErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                }
                                                            </div>
                                                            <div className="row">
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.progressiveLeasing ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Name on Credit Card</label>
                                                                        <input
                                                                            type="text"
                                                                            className={ccNameErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                            name="txtCCName"
                                                                            placeholder="Name on Credit Card"
                                                                            id="txtCCName"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.ccName}
                                                                            maxLength="200"
                                                                        ></input>
                                                                        {ccNameErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{ccNameErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.progressiveLeasing ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Credit/Debit Card (first 6 digits)</label>
                                                                        <input
                                                                            type="text"
                                                                            className={"form-control" + (ccErr ? ' border-dark-error' : ' border-dark')}
                                                                            name="txtCC"
                                                                            placeholder="Credit Card Number"
                                                                            id="txtCC"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.cc}
                                                                            maxLength="7"
                                                                        ></input>
                                                                        {ccErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{ccErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.progressiveLeasing ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Credit Card Expiration Date (MM/YYYY)</label>

                                                                        <DatePicker
                                                                            className={ccExpiryDateErr ? 'form-control border-dark-error' : 'form-control border-dark'}
                                                                            name="txtCCExpiryDate"
                                                                            id="txtCCExpiryDate"
                                                                            placeholderText="Credit Card Expiration Date (MM/YYYY)"
                                                                            selected={this.state.formObj.ccExpiryDate === "" ? null :
                                                                                new Date(this.state.formObj.ccExpiryDate.split('/')[1], parseInt(this.state.formObj.ccExpiryDate.split('/')[0]) - 1, new Date().getDate())}
                                                                            minDate={new Date(new Date().getFullYear(), new Date().getMonth(), "01")}
                                                                            onChange={(event) => this.onCCExpiryDateChange(event)}
                                                                            dateFormat="MM/yyyy"
                                                                            showMonthYearPicker
                                                                            customInput={
                                                                                <IMaskInput mask="00/0000" />
                                                                            }
                                                                        />
                                                                        {ccExpiryDateErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{ccExpiryDateErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-6 col-lg-3">
                                                                    <div className="form-group text-left mt-md-2">

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className={"col-12" + (this.state.progressiveLeasing ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group form-check mb-1 mt-1">

                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            name="chkCreditCardBillingAddress"
                                                                            id="chkCreditCardBillingAddress"
                                                                            onClick={() => this.onCreditCardBillingAddressChecked()}
                                                                            value={this.state.formObj.creditCardBillingAddress}
                                                                            checked={this.state.formObj.creditCardBillingAddress ? "checked" : ""}
                                                                        />
                                                                        <label htmlFor="chkCreditCardBillingAddress" className="mt-1 ml-2">
                                                                            Credit Card billing address same as residence address (above)
                                                                        </label>
                                                                        <br />
                                                                        {creditCardBillingAddressErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{creditCardBillingAddressErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.progressiveLeasing && !this.state.formObj.creditCardBillingAddress ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Credit Card Billing Address</label>
                                                                        <input
                                                                            type="text"
                                                                            className={"form-control" + (ccmailingAdrErr ? ' border-dark-error' : ' border-dark')}
                                                                            name="txtCCMailingAdr"
                                                                            id="txtCCMailingAdr"
                                                                            placeholder="Mailing Address"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.ccmailingAdr}
                                                                            maxLength="500"
                                                                        ></input>
                                                                        {ccmailingAdrErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{ccmailingAdrErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-2" + (this.state.progressiveLeasing && !this.state.formObj.creditCardBillingAddress ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Apt/Unit (As Needed)</label>
                                                                        <input
                                                                            type="text"
                                                                            className={"form-control" + (ccaptUnitErr ? ' border-dark-error' : ' border-dark')}
                                                                            name="txtCCAptUnit"
                                                                            id="txtCCAptUnit"
                                                                            placeholder="Apt/Unit (As Needed)"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.ccaptUnit}
                                                                            maxLength="100"
                                                                        ></input>
                                                                        {ccaptUnitErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{ccaptUnitErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-2" + (this.state.progressiveLeasing && !this.state.formObj.creditCardBillingAddress ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">City</label>
                                                                        <input
                                                                            type="text"
                                                                            className={"form-control" + (cccityErr ? ' border-dark-error' : ' border-dark')}
                                                                            name="txtCCCity"
                                                                            id="txtCCCity"
                                                                            placeholder="City"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.cccity}
                                                                            maxLength="100"
                                                                        ></input>
                                                                        {cccityErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{cccityErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-2" + (this.state.progressiveLeasing && !this.state.formObj.creditCardBillingAddress ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">State</label>

                                                                        <select id="cmbCCState" name="cmbCCState"
                                                                            className={"form-select p-2" + (ccstateErr ? ' border-dark-error' : ' form-select-border')}
                                                                            onChange={(event) => this.onChange(event)}>
                                                                            <option value="0">-- Select --</option>
                                                                            {this.state.formObj.lstCCState.map((state) => <option value={state.id} selected={this.state.formObj.ccstate == state.id ? "selected" : ""}>{state.description}</option>)}
                                                                        </select>
                                                                        {ccstateErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{ccstateErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-2" + (this.state.progressiveLeasing && !this.state.formObj.creditCardBillingAddress ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Zip Code</label>

                                                                        <input
                                                                            type="text"
                                                                            className={"form-control" + (cczipCodeErr ? ' border-dark-error' : ' border-dark')}
                                                                            name="txtCCZipCode"
                                                                            id="txtCCZipCode"
                                                                            placeholder="Zip Code"
                                                                            onChange={(event) => this.onChange(event)}
                                                                            value={this.state.formObj.cczipCode}
                                                                            maxLength="5"
                                                                        ></input>
                                                                        {cczipCodeErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{cczipCodeErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <div className="col-12">

                                                                    <button
                                                                        className="float-right btn bg-secondary text-primary pl-5 pr-5"
                                                                        name="confirmStep8"
                                                                        id="confirmStep8"
                                                                        onClick={(event) => {
                                                                            this.submitStep8(event);
                                                                        }}
                                                                    >
                                                                        Next</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : ""}
                                                </div>
                                            </div>
                                            <div className={"row m-1 ml-md-0 mr-md-0 mb-md-0 mt-4 " + ((this.state.thirdPartySessionLink || this.state.SMSLink) ? "d-none" : "")}>
                                                <div className="col-12 p-0 pl-md-3 pr-md-3 ">
                                                    <hr className="bg-secondary mt-5 mb-0" style={{ height: "1px" }}></hr>
                                                    <span className="position-relative m-0 pr-3 text-secondary bg-white h5" style={{ top: "-15px" }}><b>Uown Required Fields</b>
                                                        {this.state.step9 === false ?
                                                            <FontAwesomeIcon icon={faAngleDown} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep9(event); }} />
                                                            :
                                                            <FontAwesomeIcon icon={faAngleUp} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep9(event); }} />
                                                        }
                                                    </span>
                                                    {this.state.isStep8Complete === true && this.state.step9 === true ? (
                                                        <div>
                                                            <div className="row">
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.UOwnLeasing === true ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">How often are you paid?</label>
                                                                        <select id="cmbOftenPaid" name="UownCmbOftenPaid"
                                                                            className={"UownCmbOftenPaid form-select p-2" + (uOwnOftenPaidErr ? ' border-dark-error' : ' form-select-border')}
                                                                            onChange={(event) => this.onChange(event)}>
                                                                            <option value="0">-- Select --</option>
                                                                            {this.state.formObj.lstOftenPaid.map((oftenPaid) => <option value={oftenPaid.id} selected={this.state.formObj.oftenPaid == oftenPaid.id ? "selected" : ""}>{oftenPaid.description}</option>)}
                                                                        </select>
                                                                        {uOwnOftenPaidErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{uOwnOftenPaidErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.UOwnLeasing === true ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Last Day (MM/DD/YYYY) Pay $ Was Available</label>
                                                                        <DatePicker
                                                                            className={"form-control" + (uOwnLastPayDayErr ? ' border-dark-error' : ' border-dark')}
                                                                            name="txtLastPayDay"
                                                                            id="txtLastPayDay"
                                                                            placeholderText="Last Day (MM/DD/YYYY) Pay $ Was Available"
                                                                            selected={this.state.formObj.lastPayDay === "" ? null :
                                                                                new Date(this.state.formObj.lastPayDay)}
                                                                            onChange={(event) => this.onLastPayDayChange(event)}
                                                                            dateFormat="MM/dd/yyyy"
                                                                            maxDate={new Date()}
                                                                            peekNextMonth
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            dropdownMode="select"
                                                                            customInput={
                                                                                <IMaskInput mask="00/00/0000" />
                                                                            }
                                                                        />
                                                                        {uOwnLastPayDayErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{uOwnLastPayDayErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 col-md-6 col-lg-3" + (this.state.UOwnLeasing === true ? " ShowContent" : " HideContent")}>
                                                                    <div className="form-group text-left mt-md-2">
                                                                        <label className="text-secondary">Next Day (MM/DD/YYYY) Pay $ Will Be Available</label>
                                                                        <DatePicker
                                                                            className={"form-control" + (uOwnNextPayDayErr ? ' border-dark-error' : ' border-dark')}
                                                                            name="txtNextPayDay"
                                                                            id="txtNextPayDay"
                                                                            placeholderText="Next Day (MM/DD/YYYY) Pay $ Will Be Available"
                                                                            selected={this.state.formObj.nextPayDay === "" ? null :
                                                                                new Date(this.state.formObj.nextPayDay)}
                                                                            onChange={(event) => this.onNextPayDayChange(event)}
                                                                            dateFormat="MM/dd/yyyy"
                                                                            minDate={this.state.formObj.lastPayDay === "" ? new Date() : new Date(this.state.formObj.lastPayDay)}
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            dropdownMode="select"
                                                                            customInput={
                                                                                <IMaskInput mask="00/00/0000" />
                                                                            }
                                                                        />
                                                                        {uOwnNextPayDayErr &&
                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{uOwnNextPayDayErr}</div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row mt-4">
                                                                <div className="col-12">
                                                                    <button
                                                                        className="float-right btn bg-secondary text-primary pl-5 pr-5"
                                                                        name="confirmStep9"
                                                                        id="confirmStep9"
                                                                        onClick={(event) => {
                                                                            this.submitStep9(event);
                                                                        }}
                                                                    >
                                                                        Next</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : ""}
                                                </div>
                                            </div>
                                            {this.state.isAutoPayEnabled ?
                                                <>
                                                    <div className={"row m-1 ml-md-0 mr-md-0 mb-md-0 mt-4 " + (this.state.SMSLink ? "d-none" : "")}>
                                                        <div className="col-12 p-0 pl-md-3 pr-md-3 ">
                                                            <hr className="bg-secondary mt-5 mb-0" style={{ height: "1px" }}></hr>
                                                            <span className="position-relative m-0 pr-3 text-secondary bg-white h5" style={{ top: "-15px" }}><b>Auto-Pay Enroll (Daniel's Credit only)</b>
                                                                {this.state.step10 === false ?
                                                                    <FontAwesomeIcon icon={faAngleDown} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep10(event); }} />
                                                                    :
                                                                    <FontAwesomeIcon icon={faAngleUp} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep10(event); }} />
                                                                }
                                                            </span>
                                                            {this.state.isStep9Complete === true && this.state.step10 === true ? (
                                                                <div>
                                                                    <div className={`row ${this.state.thirdPartySessionLink ? (this.state.cartId.length > 0 && this.state.cartId !== "0" ? "" : "d-none") : ""}`}>
                                                                        <div className={"col-12 col-md-6 col-lg-12" + (this.state.danielsCredit ? " ShowContent" : " HideContent")}>
                                                                            <div className="form-group form-check">
                                                                                {this.state.isAutoPayRequired ? (
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        name="chkAutoPay"
                                                                                        id="chkAutoPay"
                                                                                        onClick={() => this.onAutoPayChecked()}
                                                                                        value={this.state.autoPay}
                                                                                        checked={this.state.autoPay ? "checked" : ""}
                                                                                        disabled="disabled"
                                                                                    />)
                                                                                    :
                                                                                    (
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="checkbox"
                                                                                            name="chkAutoPay"
                                                                                            id="chkAutoPay"
                                                                                            onClick={() => this.onAutoPayChecked()}
                                                                                            value={this.state.autoPay}
                                                                                            checked={this.state.autoPay ? "checked" : ""}
                                                                                        />
                                                                                    )
                                                                                }
                                                                                <label htmlFor="chkAutoPay" className="mt-1 ml-2">YES! I'd like to enroll in monthly Auto-Pay and <b>receive $15 OFF </b>my first statement. (debit cards only) </label>
                                                                                <br />
                                                                                <div style={{ color: "black", paddingBottom: 10 }} className={"" + (this.state.isAutoPayRequired ? " ShowContent" : " HideContent")}>Items in your cart require you to sign up for autopay. If you do not want to sign up for autopay, please select cancel to take you back to the cart.</div>
                                                                                <br />
                                                                                {autoPayErr &&
                                                                                    <div style={{ color: "red", paddingBottom: 10 }}>{autoPayErr}</div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        {this.state.autoPaySubmitted &&
                                                                            <div style={{ color: "green", paddingBottom: 10 }}>Auto Pay Submitted</div>
                                                                        }
                                                                        <div className={"col-12 col-md-6 col-lg-12" + (this.state.danielsCredit && this.state.autoPay ? " ShowContent" : " HideContent")}>
                                                                            <iframe title="autoPayIframe" src={"" + this.state.iframeUrl + ""} height="600" width="1000" style={{ border: "1px solid #1B1B1B" }}></iframe>
                                                                            {this.state.isIframeError &&
                                                                                <div style={{ color: "red", paddingBottom: 10 }}>{this.state.isIframeErrorMsg}</div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mt-4">
                                                                        <div className="col-12">
                                                                            <button
                                                                                className="float-right btn bg-secondary text-primary pl-5 pr-5"
                                                                                name="confirmStep10"
                                                                                id="confirmStep10"
                                                                                onClick={(event) => {
                                                                                    this.autoPayMessageModal(event);
                                                                                }}
                                                                            >
                                                                                Next</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ) : ""}
                                                        </div>
                                                    </div>
                                                </>
                                                : null
                                            }
                                            {this.state.isEstatementEnable ?
                                                <>
                                                    {!this.state.thirdPartyLink ?
                                                        <div className="row m-1 ml-md-0 mr-md-0 mb-md-0 mt-4">
                                                            <div className="col-12 p-0 pl-md-3 pr-md-3 ">
                                                                <hr className="bg-secondary mt-5 mb-0" style={{ height: "1px" }}></hr>
                                                                <span className="position-relative m-0 pr-3 text-secondary bg-white h5" style={{ top: "-15px" }}><b>E-Statement Enrollment (Daniel's Credit only)</b>
                                                                    {this.state.step11 === false ?
                                                                        <FontAwesomeIcon icon={faAngleDown} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep11(event); }} />
                                                                        :
                                                                        <FontAwesomeIcon icon={faAngleUp} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep11(event); }} />
                                                                    }
                                                                </span>
                                                                {this.state.isStep10Complete === true && this.state.step11 === true ? (
                                                                    <div>
                                                                        <div className="row">
                                                                            {this.state.danielsCredit ?
                                                                                <div className="col-12 col-md-6 col-lg-12">
                                                                                    <p className="">YES! I want to enroll in monthly e-statement.</p>
                                                                                    <div className="form-group form-check mb-1">
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            type="checkbox"
                                                                                            name="chkDanielEStatementDisclosure"
                                                                                            id="chkDanielEStatementDisclosure"
                                                                                            onClick={() => this.onDanielEStatementDisclosureChecked()}
                                                                                            value={this.state.isDanielEStatementDisclosure}
                                                                                            checked={this.state.isDanielEStatementDisclosure ? "checked" : ""}
                                                                                        />
                                                                                        <label htmlFor="chkDanielEStatementDisclosure" className="mt-1 ml-2">I have reviewed and agree to the <i style={{ color: "#00aeef", cursor: "pointer" }} onClick={(event) => this.onDanielsEstatementDisclosureClicked(event)}>Daniel's e-statement Agreement</i> and consent to receive an electronic (paperless) copy of my monthly statement.</label>
                                                                                        <br />
                                                                                    </div>
                                                                                    <div className="ml-4">
                                                                                        <div className="form-group form-check mb-1">
                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="checkbox"
                                                                                                name="chkNotifyMeViaText"
                                                                                                id="chkNotifyMeViaText"
                                                                                                onClick={() => this.onNotifyMeViaTextOrEmailChecked("Text")}
                                                                                                value={this.state.notify_me_via_text_at}
                                                                                                checked={this.state.notify_me_via_text_at ? "checked" : ""}
                                                                                                disabled={!this.state.isDanielEStatementDisclosure}
                                                                                            />
                                                                                            <label htmlFor="chkNotifyMeViaText" className="mt-1 ml-2">Notify me via text at {this.state.formObj.mobileNo}</label>
                                                                                            <br />
                                                                                        </div>
                                                                                        <div className="form-group form-check mb-0">
                                                                                            <input
                                                                                                className="form-check-input"
                                                                                                type="checkbox"
                                                                                                name="chkNotifyMeViaEmail"
                                                                                                id="chkNotifyMeViaEmail"
                                                                                                onClick={() => this.onNotifyMeViaTextOrEmailChecked("Email")}
                                                                                                value={this.state.notify_me_via_email_at}
                                                                                                checked={this.state.notify_me_via_email_at ? "checked" : ""}
                                                                                                disabled={!this.state.isDanielEStatementDisclosure}
                                                                                            />
                                                                                            <label htmlFor="chkNotifyMeViaEmail" className="mt-1 ml-2">Notify me via email at {this.state.formObj.emailAdr}</label>
                                                                                            <br />
                                                                                        </div>
                                                                                        {notifyViaTextandEmailErr &&
                                                                                            <div style={{ color: "red", paddingBottom: 10 }}>{notifyViaTextandEmailErr}</div>
                                                                                        }
                                                                                    </div>
                                                                                    <p className="mt-2"><b>You are responsible for providing to us and maintaining with us a valid email address or mobile number for us to send you notification of new statements being available.</b></p>
                                                                                </div>
                                                                                : null}
                                                                        </div>
                                                                        <div className="row mt-4">
                                                                            <div className="col-12">
                                                                                <button
                                                                                    className="float-right btn bg-secondary text-primary pl-5 pr-5"
                                                                                    name="confirmStep11"
                                                                                    id="confirmStep11"
                                                                                    onClick={(event) => {
                                                                                        this.submitStep11(event);
                                                                                    }}
                                                                                >
                                                                                    Next</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ) : ""}
                                                            </div>
                                                        </div>
                                                        : null}
                                                </>
                                                : null
                                            }
                                            <div className="row m-1 ml-md-0 mr-md-0 mb-md-0 mt-4">
                                                <div className="col-12 p-0 pl-md-3 pr-md-3 ">
                                                    <hr className="bg-secondary mt-5 mb-0" style={{ height: "1px" }}></hr>
                                                    <span className="position-relative m-0 pr-3 text-secondary bg-white h5" style={{ top: "-15px" }}><b>Disclosures</b>
                                                        {this.state.step12 === false ?
                                                            <FontAwesomeIcon icon={faAngleDown} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep12(event); }} />
                                                            :
                                                            <FontAwesomeIcon icon={faAngleUp} className="float-right bg-white pl-3" size="lg" onClick={(event) => { this.goStep12(event); }} />
                                                        }
                                                    </span>
                                                    {this.state.isStep11Complete === true && this.state.step12 === true ? (
                                                        <div>
                                                            <div className="row">
                                                                <div className={"col-12 customBorder shadow mt-3" + (this.state.synchronyCredit ? " ShowContent" : " HideContent")}>
                                                                    <div className="pl-3 pr-3 pl-md-0 pr-md-0 pl-lg-0 pr-lg-0">
                                                                        <div id="syncDis1">
                                                                            <p className="h5 mt-3"><b>Synchrony Bank Credit</b></p>
                                                                            <p className="mb-3"><b>SYNCHRONY BANK APPLICANT: We need your signature below.</b></p>
                                                                            <p className="mb-0">I ask Synchrony Bank (“SYNCB”) to issue me a SYNCB Credit Card (the “Card”) and I agree:</p>
                                                                            <ul style={{ paddingLeft: "14px" }}>
                                                                                <li>To the SYNCB Credit Card agreement (“Agreement”).</li>
                                                                                <li>I am providing the information in this application to SYNCB and to dealers/merchants/retailers that accept the Card and program sponsors (and their respective affiliates), and I consent to SYNCB’s providing information about me to dealers/merchants/retailers that accept the Card and program sponsors (and their respective affiliates) for their own business purposes.</li>
                                                                                <li>SYNCB may obtain credit reports and other information, including employment and income, about me to evaluate my application and for other purposes.</li>
                                                                                <li>SYNCB, and any other owner or servicer of my account, may contact me about my account, including through text messages, automatic telephone dialing systems and/or artificial or prerecorded voice calls for informational, servicing or collection related communications, as provided in the Address/Phone Change and Consent To Communications provisions of the Agreement. I also agree to update my contact information.</li>
                                                                                <li>The Agreement will govern my account and includes: <b>(1) a resolving a dispute with arbitration provision that limits my rights unless: (a) I reject the provision by following the provision’s instructions or (b) I am covered by the Notice for Active Duty Military Members and their Dependents set forth in the Agreement;</b> and (2) makes each applicant responsible for paying the entire amount of credit extended.</li>
                                                                                <li><b>Authorization for the Social Security Administration to Disclose Your Social Security Number Verification.</b>
                                                                                    I authorize the Social Security Administration (SSA) to verify and disclose to SYNCB for the purpose of this transaction whether the name, Social Security Number (SSN) and date of birth I have submitted matches information in SSA records. My consent is for a one-time validation within the next 90 days.</li>
                                                                            </ul>
                                                                            <p><b>Federal law requires Synchrony Bank to obtain, verify, and record information that identifies you when you open an account.  Synchrony Bank will use your name, address, date of birth, and other information for this purpose.</b></p>
                                                                            <p className="mb-0">PLEASE READ THE SYNCB CREDIT CARD AGREEMENT FOR RATES, FEES, AND OTHER COST INFORMATION BEFORE SIGNING THIS APPLICATION.</p>
                                                                        </div>
                                                                        <div className="form-group form-check ml-1">
                                                                            <input
                                                                                style={{ display: 'flex', marginTop: '20px' }}
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                name="chkSynchronyDisclosure"
                                                                                id="chkSynchronyDisclosure"
                                                                                onChange={(event) => this.onChange(event)}
                                                                                onClick={() => this.onSynchronyDisclosureChecked()}
                                                                                value={this.state.synchronyDisclosure}
                                                                                checked={this.state.synchronyDisclosure ? "checked" : ""}
                                                                            />
                                                                            <label id="syncDis2" htmlFor="chkSynchronyDisclosure" className="mt-1 ml-2"><b>By checking this box, I agree that I want to apply for a Synchrony Bank Credit Card, that I have received a paper copy of the credit terms, that I have read and agree to the credit terms and application disclosures provided above, and that selecting “Submit Application” below constitutes my electronic signature.</b></label>
                                                                            <br />
                                                                            {synchronyDisclosureErr &&
                                                                                <div style={{ color: "red", paddingBottom: 10 }}>{synchronyDisclosureErr}</div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 customBorder mt-3 shadow " + ((this.state.fortivaCredit && this.state.synchronyCredit) ? (this.state.synchronyDisclosure ? "ShowContent" : "HideContent") : (this.state.fortivaCredit ? " showContent" : " HideContent"))}>
                                                                    <div className="pl-3 pr-3 pl-md-0 pr-md-0 pl-lg-0 pr-lg-0">
                                                                        <div id="forDis1">
                                                                            {(this.state.fortivaCredit && this.state.synchronyCredit) ?
                                                                                null
                                                                                : <><p className="h5 mt-3"><b>Fortiva Retail Credit</b></p>
                                                                                    <p className="h5 mt-3 text-secondary"><b>About Procedures for Opening a New Account</b></p></>
                                                                            }
                                                                            {(this.state.fortivaCredit && this.state.synchronyCredit) ?
                                                                                <>
                                                                                    <p className="mt-3"><b>If your application is declined by Synchrony Bank (“SYNCB”), you direct SYNCB to share all of your application information, on your behalf, with The Bank of Missouri (“TBOM”) to see if you prequalify for a Fortiva Retail Line of Credit. The rates, fees, and other credit terms provided by SYNCB may differ from the terms of the Fortiva Retail Line of Credit.​</b></p>
                                                                                    <p>By signing below, you also agree that if you are not approved for a SYNCB account, you are providing “written instructions” to TBOM, its successors, assigns and agents, specifically including, on behalf of TBOM and at its express direction, the Fortiva Retail Credit program manager (collectively, the “Lender”) to obtain a credit report from a consumer reporting agency in accordance with the federal Fair Credit Reporting Act.  You authorize Lender to obtain such information solely to conduct an initial pre-qualification review. Then, if you select a prequalified offer, you authorize Lender to investigate your creditworthiness and specifically authorize the release of further information to Lender.  A full credit report (a hard inquiry) will be requested in connection with your acceptance of an offer.​</p>
                                                                                    <hr></hr>
                                                                                </>
                                                                                : null}
                                                                        </div>
                                                                        <div className="form-group form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                name="fortivaElecDisclosure"
                                                                                id="chkFortivaElecDisclosure"
                                                                                onChange={(event) => this.onChange(event)}
                                                                                onClick={(event) => this.onFortivaDisclosure(event)}
                                                                                value={this.state.fortivaElecDisclosure}
                                                                                checked={this.state.fortivaElecDisclosure ? "checked" : ""}
                                                                            />
                                                                            <label id="forDis2" htmlFor="chkFortivaElecDisclosure" className="mt-1 ml-2"><b>Consent to Electronic Disclosures</b>: By checking the box at the left, you certify that you have read, retained and agree to the <u style={{ color: "#5C068C", cursor: "pointer", fontWeight: "bold" }} onClick={(event) => this.onElectronicDisclosure(event)}>Consent to Electronic Disclosures.</u> and understand that this constitutes your electronic signature authorizing us to process this form on your behalf.</label>
                                                                            <br />
                                                                            {fortivaElecDiscErr &&
                                                                                <div style={{ color: "red", paddingBottom: 10 }}>{fortivaElecDiscErr}</div>
                                                                            }
                                                                        </div>
                                                                        <div className={(this.state.fortivaCredit && this.state.synchronyCredit) ? " d-none" : "form-group form-check"}>
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                name="fortivaDisclosure"
                                                                                id="chkFortivaDisclosure"
                                                                                onChange={(event) => this.onChange(event)}
                                                                                onClick={(event) => this.onFortivaDisclosure(event)}
                                                                                value={this.state.fortivaDisclosure}
                                                                                checked={this.state.fortivaDisclosure ? "checked" : ""}
                                                                            />
                                                                            <label id="forDis3" htmlFor="chkFortivaDisclosure" className="mt-1 ml-2"><u style={{ color: "#5C068C", cursor: "pointer", fontWeight: "bold" }} onClick={(event) => this.onApplicationDis(event)}>Application Disclosures</u>: By checking the box at the left you certify that you have read and agree to the Application Disclosures.</label>
                                                                            <br />
                                                                            {fortivaDisclosureErr &&
                                                                                <div style={{ color: "red", paddingBottom: 10 }}>{fortivaDisclosureErr}</div>
                                                                            }
                                                                        </div>
                                                                        <div className={(this.state.fortivaCredit && this.state.synchronyCredit) ? " d-none" : "form-group form-check"}>
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                name="fortivaWrittenInstr"
                                                                                id="chkfortivaWrittenInstr"
                                                                                onChange={(event) => this.onChange(event)}
                                                                                onClick={(event) => this.onFortivaDisclosure(event)}
                                                                                value={this.state.fortivaWrittenInstr}
                                                                                checked={this.state.fortivaWrittenInstr ? "checked" : ""}
                                                                            />
                                                                            <label id="forDis4" htmlFor="chkfortivaWrittenInstr" className="mt-1 ml-2">By clicking Submit, you are providing “written instructions” to The Bank of Missouri, its successors, assigns and agents, specifically including, on behalf of The Bank of Missouri and at its express direction, the Fortiva Retail Credit program manager (collectively, the “Lender”) to obtain a credit report from a consumer reporting agency in accordance with the federal Fair Credit Reporting Act. You authorize the Lender to obtain such information solely to conduct an initial pre-qualification review.</label>
                                                                            <br />
                                                                            {fortivaWrittenInstrErr &&
                                                                                <div style={{ color: "red", paddingBottom: 10 }}>{fortivaWrittenInstrErr}</div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 mt-3 customBorder shadow" + (this.state.danielsCredit ? " ShowContent" : " HideContent")}>
                                                                    <div className="pl-3 pr-3 pl-md-0 pr-md-0 pl-lg-0 pr-lg-0">
                                                                        <p className="h5 mt-3"><b>DANIEL'S CREDIT APPLICANTS</b></p>
                                                                        <p className="text-justify">By applying for this account, I am (we are) asking Daniel’s Jewelers (“Daniel’s”) to open a credit account for me (us) and by signing this agreement I (we) (A) acknowledge receipt of the Daniel’s Jewelers Preferred Charge Retail Installment Agreement Summary of Terms (RICA) and Privacy Policy (available at <a href="https://www.danielsjewelers.com/pages/privacy-policy" rel="noreferrer" target="_blank" style={{ color: "rgb(0, 82, 204)" }}> www.DanielsJewelers.com/Pages/Privacy-Policy</a>), and if approved for this account, to be bound by the full terms and conditions of the RICA, (B) authorize Daniel’s and affiliates to verify all credit, employment, references, or banking information, obtain current balances on any such accounts, and request information from credit bureau reporting agencies, and, if approved for this account, whether a purchase is charged to this account or not, authorize Daniel’s to re-verify, obtain updates on such accounts and to obtain information from and report the payment history and account status of this account to and from credit bureau reporting agencies without my (our) specific authorization or a specific request for purchase approval or credit line increase, (C) if a joint account is requested by providing information about and the signature of a second individual, agree that the primary and joint accountholder each can individually sign and incur obligations on behalf of the other, (D) understand and agree that I am (we are) submitting this application and all of the information on this application to both the designated entities that I (we) have signed for as well as their affiliates and designees for their use in marketing products and services to me as permitted by applicable law; I (we) authorize Daniel’s, its affiliates and its designees to submit and disclose this application to other lender(s) or lease-to-own providers which is/are not affiliated with any of the designated entities on this application, (E) authorize Daniel’s to contact me via mail, email, telephone, cellular telephone, text messaging (SMS or MMS), and any other electronic means, including, but not limited to through automatic telephone dialing systems and/or with artificial or prerecorded voices at, including, but not limited to, those contact methods noted with (+ or *) above, for account service, collections, sales promotion including marketing, and other consumer business related matters. I (we) assume the risk that electronic communications to us (text, email, voice message) may be viewed or accessed by others with access to our device(s). I (we) acknowledge that we may receive up to ten (10) calls and ten (10) text messages per month. I (we) acknowledge that, to opt out now or at any time from receiving calls or texts for any purpose other than accounts servicing or collection, I may call (310) 846-5630 or text “STOP” in response to any text message. I (we) acknowledge that standard text messaging and call use rates may apply and will be accepted by me (us) with no reimbursement or payment by Daniel’s; I (we) make to or receive from Daniel’s may be monitored or recorded by Daniel’s for supervisory purposes; I understand that consent for marketing is NOT a condition of purchasing or receiving service and I can opt out at any time, (F) understand that in order to discontinue receiving contact for any purpose other than accounts servicing or collection, I can call (310) 846-5630 during regular business hours. </p>
                                                                        <p className="text-center"><b>Please <u style={{ color: "#00aeef", cursor: "pointer" }} onClick={(event) => this.onDanielsDisclosureClicked(event)}>click here</u> for Daniel’s Jewelers disclosures and credit agreement.</b></p>
                                                                        <p className="text-center mb-0"><b>NOTICE TO BUYER(S):</b></p>
                                                                        <p className="text-center"><b>DO NOT SIGN THIS APPLICATION BEFORE READING THE DANIEL’S RETAIL INSTALLMENT CREDIT AGREEMENT OR IF IT CONTAINS BLANK SPACES.</b></p>
                                                                        <p className={"text-center text-uppercase " + (this.state.thirdPartySessionLink ? "" : "d-none")}><b>The Ohio laws against discrimination require that all creditors make credit equally available to all credit worthy customers. The Ohio Civil Rights Commission administers compliance with this law</b></p>
                                                                        <div className="form-group form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                name="chkDanielsDisclosure"
                                                                                id="chkDanielsDisclosure"
                                                                                onChange={(event) => this.onChange(event)}
                                                                                onClick={() => this.onDanielsDisclosureChecked()}
                                                                                value={this.state.danielsDisclosure}
                                                                                checked={this.state.danielsDisclosure ? "checked" : ""}
                                                                            />
                                                                            <label htmlFor="chkDanielsDisclosure" className="mt-1 ml-2">I have read and agree to the Application Disclosure, Consent to Electronic Communication, Credit Agreement, and Privacy Policy. Selecting “Submit Application” below constitutes my electronic signature.</label>
                                                                            <br />
                                                                            {danielsDisclosureErr &&
                                                                                <div style={{ color: "red", paddingBottom: 10 }}>{danielsDisclosureErr}</div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 customBorder shadow mt-3" + (this.state.progressiveLeasing ? " ShowContent" : " HideContent")}>
                                                                    <div className="pl-3 pr-3 pl-md-0 pr-md-0 pl-lg-0 pr-lg-0">
                                                                        <p className="h5 mt-3"><b>PROGRESSIVE LEASING</b></p>
                                                                        <ol>
                                                                            <li> I certify that I provided complete and accurate information on my application.</li>
                                                                            <li> I authorize Prog Leasing, LLC and/or affiliates (“Progressive”) to obtain reports from consumer reporting agencies and verify information provided.  I agree that Progressive may use my consumer reports to any lawful purpose, such as: (1) authenticating my identity; (2) making lease-to-own eligibility decisions; (3) assisting with internal modeling and analysis; (4) serving my account through the life of my lease and (5) verifying information in my application. </li>
                                                                            <li>I authorize Progressive to share information regarding my application, including the decision, with the Retailer.</li>
                                                                        </ol>
                                                                        <div className="form-group form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                name="chkProgressiveDisclosure"
                                                                                id="chkProgressiveDisclosure"
                                                                                onClick={() => this.onProgressiveDisclosureChecked()}
                                                                                value={this.state.progressiveDisclosure}
                                                                                checked={this.state.progressiveDisclosure ? "checked" : ""}
                                                                            />
                                                                            <label htmlFor="chkProgressiveDisclosure" className="mt-1 ml-2">
                                                                                I have read, and I agree to all of the above statements.  I further agree to the <a href="https://progleasing.com/terms/" target="_blank" rel="noreferrer" className="text-decoration-none" style={{ color: "#00aeef" }}>Terms of Use</a>, <a href="https://progleasing.com/privacy/" target="_blank" rel="noreferrer" style={{ color: "#00aeef" }}>Privacy Policy</a>, <a href="https://progleasing.com/application-disclosure/" target="_blank" rel="noreferrer" style={{ color: "#00aeef" }}>Application Disclosure</a>, <a href="https://progleasing.com/arbitration-clause/" target="_blank" rel="noreferrer" style={{ color: "#00aeef" }}>Arbitration Provision</a> and <a href="https://progleasing.com/e-sign-disclosure/" target="_blank" rel="noreferrer" style={{ color: "#00aeef" }}>E-Sign Disclosure</a>.
                                                                            </label>
                                                                            <br />
                                                                            {progressiveDisclosureErr &&
                                                                                <div style={{ color: "red", paddingBottom: 10 }}>{progressiveDisclosureErr}</div>
                                                                            }
                                                                        </div>
                                                                        <div className="form-group form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                name="chkProgressiveSMS"
                                                                                id="chkProgressiveSMS"
                                                                                onClick={() => this.onProgressiveSMSChecked()}
                                                                                value={this.state.progressiveSMS}
                                                                                checked={this.state.progressiveSMS ? "checked" : ""}
                                                                            />
                                                                            <label htmlFor="chkProgressiveSMS" className="mt-1 ml-2">Yes! I would like to receive marketing communications at <b>{this.state.formObj.mobileNo}</b> on behalf of Progressive Leasing. These communications may be delivered using an auto dialer or a prerecorded message. Consent is not a condition of application, lease, or purchase. For text messages, message and data rates may apply. Text STOP to cancel future marketing messages. Text HELP for help. Message frequency is recurring. </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className={"col-12 customBorder shadow mt-3" + (this.state.UOwnLeasing ? " ShowContent" : " HideContent")}>
                                                                    <div className="pl-3 pr-3 pl-md-0 pr-md-0 pl-lg-0 pr-lg-0">
                                                                        <p className="h5 mt-3"><b>UOWN LEASING</b></p>
                                                                        <div className="form-group form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                name="chkUOwnDisclosure"
                                                                                id="chkUOwnDisclosure"
                                                                                onClick={() => this.onUOwnDisclosureChecked()}
                                                                                value={this.state.UOwnDisclosure}
                                                                                checked={this.state.UOwnDisclosure ? "checked" : ""}
                                                                            />
                                                                            <label htmlFor="chkUOwnDisclosure" className="mt-1 ml-2">I acknowledge that I am applying for Uown Leasing and have provided complete and accurate information.</label>
                                                                            <br />
                                                                            {UOwnDisclosureErr &&
                                                                                <div style={{ color: "red", paddingBottom: 10 }}>{UOwnDisclosureErr}</div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <hr className={"bg-secondary ml-3 mr-3" + this.state.fortivaCredit ? "d-none" : ""} style={{ height: "1px" }}></hr>
                                                            {this.state.isDanielsApplicationFlowChanges ?
                                                                <div className={"row mt-3 " + (((this.state.danielsCredit && sessionStorage.getItem("addOn") == "true") && (localStorage.getItem("magix_account_no") != "null" && localStorage.getItem("magix_account_no")) != "") ? " ShowContent" : " HideContent")}>
                                                                    <div className={"col-12 col-md-6 col-lg-12"}>
                                                                        <div className="form-group form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                name="chkAddOnWithOutChanges"
                                                                                id="chkAddOnWithOutChanges"
                                                                                value={this.state.addOnwithOutchanges}
                                                                                checked={this.state.addOnwithOutchanges ? "checked" : ""}
                                                                                disabled={false}
                                                                            />
                                                                            <label htmlFor="chkAddOnWithOutChanges" className="mt-1 ml-2">Add-On without Changes </label>

                                                                        </div>
                                                                    </div>
                                                                    <div className={"col-12 col-md-6 col-lg-12"}>
                                                                        <div className="form-group form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                name="chkAddOnWithChanges"
                                                                                id="chkAddOnWithChanges"
                                                                                value={this.state.addOnWithChange}
                                                                                checked={this.state.addOnWithChange ? "checked" : ""}
                                                                                disabled={false}
                                                                            />
                                                                            <label htmlFor="chkAddOnWithChanges" className="mt-1 ml-2">Add-On with Changes </label>

                                                                        </div>
                                                                    </div>
                                                                </div> : ""}
                                                            {this.state.thirdPartyLink === false ?
                                                                <div className={"pl-3" + (this.state.nonSynchronyCD && this.state.synchronyCredit ? " ShowContent" : " HideContent")}>
                                                                    <p>Employee section</p>
                                                                    <div className="row">

                                                                        <div className={"col-12 col-md-8 col-lg-6 pl-0 pl-md-4 pl-lg-4" + (!this.state.isVerifyPassword ? " ShowContent" : " HideContent")}>
                                                                            <div className="form-group text-left mt-md-2">
                                                                                <button
                                                                                    name="verifyPassword"
                                                                                    id="verifyPassword"
                                                                                    className="border-dark bg-secondary text-primary btn w-100"
                                                                                    onClick={(event) => {
                                                                                        this.verifyPassword(event);
                                                                                    }}
                                                                                >Store associate click here to verify your identification</button>
                                                                                {associateVerifiedErr &&
                                                                                    <div style={{ color: "red", paddingBottom: 10 }}>{associateVerifiedErr}</div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            <div className="form-group form-check">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name="chkApplicantIdMatch"
                                                                                    id="chkApplicantIdMatch"
                                                                                    onClick={() => this.onApplicantIdMatchChecked()}
                                                                                    value={this.state.applicantIdMatch}
                                                                                    checked={this.state.applicantIdMatch ? "checked" : ""}
                                                                                ></input>
                                                                                <label htmlFor="chkApplicantIdMatch" style={{ margin: "10px" }} className="d-inline">
                                                                                    Yes! Customer IDs are a match.
                                                                                </label>
                                                                                {applicantIdMatchErr &&
                                                                                    <div style={{ color: "red", paddingBottom: 10 }}>{applicantIdMatchErr}</div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-12">
                                                                            <div className="form-group form-check">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name="chkSynchronyAgreementGiven"
                                                                                    id="chkSynchronyAgreementGiven"
                                                                                    onClick={() => this.onSynchronyAgreementGivenChecked()}
                                                                                    value={this.state.synchronyAgreementGiven}
                                                                                    checked={this.state.synchronyAgreementGiven ? "checked" : ""}
                                                                                ></input>
                                                                                <label htmlFor="chkSynchronyAgreementGiven" style={{ margin: "10px" }} className="d-inline">
                                                                                    Yes! Customer has received Synchrony Agreement.
                                                                                </label>
                                                                                {synchronyAgreementGivenErr &&
                                                                                    <div style={{ color: "red", paddingBottom: 10 }}>{synchronyAgreementGivenErr}</div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className={"col-12" + (this.state.synchronyCredit && !this.state.danielsCredit ? " " : " d-none")}>
                                                                            <div className="form-group form-check">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name="chkSynchronyOnly"
                                                                                    id="chkSynchronyOnly"
                                                                                    onClick={() => this.onChkSynchronyOnly()}
                                                                                    value={this.state.chkSynchronyOnly}
                                                                                    checked={this.state.chkSynchronyOnly ? "checked" : ""}
                                                                                ></input>
                                                                                <label htmlFor="chkSynchronyOnly" style={{ margin: "10px" }} className="d-inline">
                                                                                    This is a sycnchrony only application.
                                                                                </label>
                                                                                {chkSynchronyOnlyErr &&
                                                                                    <div style={{ color: "red", paddingBottom: 10 }}>{chkSynchronyOnlyErr}</div>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                : <div className="row ml-1 mb-4 mt-4">
                                                                    <div className="col-12 col-md-6 pl-0">
                                                                        <p className="h3 mb-4 font-weight-bold">Captcha {this.state.captchaVerified === true ? "Verified" : "Verification"}<FontAwesomeIcon icon={faCircleCheck} className={` ${this.state.captchaVerified === true ? " text-success pl-2" : "d-none"}`} /></p>
                                                                        <div className={`pl-2 ${this.state.captchaVerified === true ? "d-none" : ""}`}>
                                                                            <div className="row">
                                                                                <form>
                                                                                    <ReCAPTCHA sitekey={this.state.siteKey} onChange={this.verifyCaptcha} />
                                                                                </form>
                                                                            </div>
                                                                            {captchaErr &&
                                                                                <div style={{ color: "red", paddingBottom: 10, paddingTop: 10 }}>{captchaErr}</div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    ) : ""}
                                                </div>
                                            </div>
                                            <div className="row mt-4">
                                                <div className="col-12">
                                                    {/*<button*/}
                                                    {/*    name="confirmStep2"*/}
                                                    {/*    id="confirmStep2"*/}
                                                    {/*    disabled={(this.state.formObj.rdApply === "DS" ? (this.state.danielsDisclosure && this.state.synchronyDisclosure && this.state.synchronyContinue ? "" : " disabled") :*/}
                                                    {/*        (this.state.formObj.rdApply === "D" ? (this.state.danielsDisclosure ? "" : " disabled") :*/}
                                                    {/*            (this.state.synchronyDisclosure && this.state.synchronyContinue ? "" : " disabled")*/}
                                                    {/*        )*/}
                                                    {/*    )}*/}
                                                    {/*    className="border-dark btn w-100 bg-secondary text-primary"*/}
                                                    {/*    onClick={(event) => this.handleFormValidationOnSubmit(event)}*/}
                                                    {/*>*/}
                                                    {/*    Submit*/}
                                                    {/*</button>*/}
                                                    {/* {this.state.isAPIError &&
                                                                        <div style={{ color: "red", paddingBottom: 10 }}>{this.state.isAPIErrorMsg}</div>
                                                                    } */}
                                                    <div className="float-right">
                                                        {!this.state.SMSLink ?
                                                            !this.state.thirdPartySessionLink ?
                                                                <button className={"ml-auto mr-4 mr-md-5 btn bg-primary text-secondary border-secondary pl-4 pr-4 pl-md-5 pr-md-5 " + (this.state.djoSubmitted ? " d-none" : "")}
                                                                    name="cancelSessionId"
                                                                    id="cancelSessionId" onClick={(event) => this.cancelSessionLink(event)}
                                                                >
                                                                    Cancel</button>
                                                                : this.state.thirdPartySessionLink && (this.state.isStep11Complete === true && this.state.step12 === true) ?
                                                                    <button className={"ml-auto mr-4 mr-md-5 btn bg-primary text-secondary border-secondary pl-4 pr-4 pl-md-5 pr-md-5 " + (this.state.djoSubmitted ? " d-none" : "")}
                                                                        name="cancelSessionId"
                                                                        id="cancelSessionId" onClick={(event) => this.cancelSessionLink(event)}
                                                                    >
                                                                        Cancel</button>
                                                                    : null
                                                            : null}
                                                        {this.state.isStep11Complete === true && this.state.step12 === true ? (
                                                            (this.state.danielsCredit || this.state.synchronyCredit || this.state.progressiveLeasing || this.state.UOwnLeasing || this.state.fortivaCredit) ?
                                                                <button className={"ml-auto btn bg-secondary text-primary pl-4 pr-4 pl-md-5 pr-md-5 " + (this.state.djoSubmitted ? " d-none" : "")} name="confirmStep12" id="confirmStep12"
                                                                    onClick={(event) => this.handleFormValidationOnSubmit(event)}
                                                                    disabled={((this.state.thirdPartyLink || this.state.thirdPartySessionLink) &&
                                                                        this.state.isAlldisclosuresChecked) ? false : !this.state.permission_status?.canAdd &&
                                                                            !this.state.permission_status?.canEdit ? true : this.state.isAlldisclosuresChecked ? false : true}
                                                                >
                                                                    Submit</button>
                                                                : null
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>

                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>}

                        <DanielsDisclosureForm
                            onDanielsDisclosureClicked={this.onDanielsDisclosureClicked}
                            isAgreedRevort={this.isAgreedRevort}
                            onElectronicAgree={this.onElectronicAgree}
                            show={this.state.showPopup}
                            isAgreed={this.state.isAgreed}
                        />

                        <DanielsEStatementDisclosure
                            onDanielEStatementDisclosureChecked={this.onDanielsEstatementDisclosureClicked}
                            show={this.state.showEstatementPopup}
                            eStatementContent={this.state.eStatementContent}
                        />
                        <FortivaDisclosures
                            title={"ELECTRONIC RECORDS DISCLOSURE AND CONSENT AGREEMENT"}
                            onDisclosure={this.onElectronicDisclosure}
                            onClose={(event) => { this.setState({ isElectronicDisclosure: !this.state.isElectronicDisclosure }) }}
                            show={this.state.isElectronicDisclosure}
                            disclosuresMsg={this.state.fortivaElectronicDisMsg}
                        />
                        <FortivaDisclosures
                            title={"APPLICATION DISCLOSURES"}
                            onDisclosure={this.onApplicationDis}
                            onClose={(event) => { this.setState({ isApplicationDisclosure: !this.state.isApplicationDisclosure }) }}
                            show={this.state.isApplicationDisclosure}
                            disclosuresMsg={this.state.fortivaDisMsg}
                        />
                        <FortivaDialog
                            show={this.state.isDuplicateCustomer}
                            message={`<span class=\"mb-0 \"><b>A customer record with this profile exists.</b></span><br><br><p class=\"mb-0 \">1. Identify the correct customer profile and click on Continue to go to the Customer Details page</p><p class=\"mb-0 popmsg\">OR</p><p class=\"mb-2 \">2. Click Cancel to go back to the Customer Lookup page.</p><span><b>First Name</b> : ${this.state.duplicateCustData.firstName}</span><br><span><b>Last Name</b> : ${this.state.duplicateCustData.lastName}</span><br><span><b>SSN</b> : ${this.state.duplicateCustData.ssn}</span><br><span><b>DOB</b> : ${this.state.formObj.dob}</span>`}
                            handleFortivaModal={this.handleDuplicateCustCancel}
                            submitFortiva={this.handleDuplicateCust}
                            btn1_name="Cancel"
                            btn2_name="Continue"
                        />
                        <AddressSuggestionForm
                            show={this.state.showAddressSuggestionForm}
                            originalAddress={this.state.originalAddress}
                            suggestedAddress={this.state.suggestedAddress}
                            onUseOriginalAddressClicked={(event) => this.onUseOriginalAddress(event)}
                            onUseSuggestedAddressClicked={(event) => this.onUseSuggestedAddress(event)}
                            onClose={(event) => { this.setState({ originalAddress: '', suggestedAddress: '', showAddressSuggestionForm: false }) }}
                        />
                        <Modal show={this.state.isMagixDuplicateCustomer} >
                            <Modal.Header className="pb-0"><b className="text-secondary h4">Confirmation</b></Modal.Header>
                            <Modal.Body className="pb-0">
                                <>
                                    <p><b>A Daniels credit account exists</b></p>
                                    <p>1. Identify the correct customer profile, select it, and click on Continue to go to the Customer Details page.</p>
                                    <p className="text-center">OR</p>
                                    <p>2. Click Cancel to go back to the Customer Lookup page.</p>
                                    <p className="text-center bg-secondary text-primary mb-0">Daniels Credit</p>
                                    <table className="table w-100">
                                        <thead>
                                            <tr className="bg-secondary text-primary">
                                                <td>Name</td>
                                                <td>Store Code</td>
                                                <td>Account</td>
                                                <td>Balance</td>
                                                <td>Credit Rating</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.magixDuplicateCustData?.data?.map((item) => {
                                                return (
                                                    <>
                                                        <tr onClick={() => this.setState({ selectedDuplicateMagixRecord: item })} className={this.state.selectedDuplicateMagixRecord?.id == item.id ? "bg-secondary text-primary" : ""}>
                                                            <td className="p-0">{item.firstName}</td>
                                                            <td>{item.store_code}</td>
                                                            <td>{item.customer_Id}</td>
                                                            <td>${item.strbalanceDue}</td>
                                                            <td>{item.custAcctStat === null ? "" : item.custAcctStat} {item.maxCustBal === null ? "" : item.maxCustBal}</td>
                                                        </tr></>);
                                            })}
                                        </tbody>
                                    </table>
                                </>
                            </Modal.Body>
                            <Modal.Footer className="border-top-0 mt-1 pt-0 pb-3">
                                <button className="btn ml-1 mr-1 mb-0 reStay" style={{ backgroundColor: "#1B1B1B", color: "white" }} onClick={(event) => { this.handleDuplicateCustCancel(event) }}>Cancel</button>
                                <button className="btn mr-1 ml-1 mb-0 reLogout" style={{ backgroundColor: "#5c068c", color: "white" }} onClick={() => { this.createCustomer(this.state.selectedDuplicateMagixRecord) }} disabled={this.state.selectedDuplicateMagixRecord?.id > 0 ? false : true}>Continue</button>
                            </Modal.Footer>
                        </Modal>


                        {/*In logout&continue if a duplicate profile exists the modal will popup*/}
                        <Modal show={this.state.associateRelogin}>
                            <Modal.Header className="pb-0"><b className="text-secondary h4">Confirmation</b></Modal.Header>
                            <Modal.Body className=" text-center pb-1 pt-3">
                                <p className="h5">A customer record with this profile exists</p>
                                <p>please reach out to <b>store associate</b></p>
                            </Modal.Body>
                            <Modal.Footer className="border-0 justify-content-center pt-0 pb-3">
                                <button className="btn bg-secondary w-25 text-primary" onClick={() => this.associateRelogin()}>OK</button>
                            </Modal.Footer>
                        </Modal>
                        <Modal show={this.state.isAPIError}>
                            <Modal.Header className="pb-0"><b className="text-secondary h4">Warning</b></Modal.Header>
                            <Modal.Body className=" text-center pb-1 pt-3">
                                <p className="text-danger">{this.state.isAPIErrorMsg}</p>
                            </Modal.Body>
                            <Modal.Footer className="border-0 justify-content-right pt-0 pb-3">
                                <button className="btn bg-secondary w-20 text-primary" onClick={() => this.handleErrorMessage()}>OK</button>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={this.state.showSubmitConfirmation} onHide={(event) => this.handleSubmitModalCancel(event)}>
                            <Modal.Header className="pb-0"><b className="text-secondary h4">Confirmation</b><FontAwesomeIcon icon={faClose} className="btn" onClick={(event) => this.handleSubmitModalCancel(event)} /></Modal.Header>
                            <Modal.Body>Are you sure you want to submit?</Modal.Body>
                            <Modal.Footer className="border-0">
                                <form>
                                    <button className="btn mr-2" style={{ backgroundColor: "#1B1B1B", color: "white" }} onClick={(event) => this.handleSubmitModalCancel(event)}>Cancel</button>
                                    <button className="btn ml-2" style={{ backgroundColor: "#5c068c", color: "white" }} onClick={(event) => {
                                        this.submitStep12(event);
                                    }}>Submit</button>
                                </form>
                            </Modal.Footer>
                        </Modal>
                        {/* {(localStorage.getItem("magix_account_no") != "null" && localStorage.getItem("magix_account_no") != "")?
                        <MagixCrediAppDialog
                            show={this.state.magixPopupShow}
                            handleMagixAccounts={this.handleMagixAccounts}
                            handleModalPopup={this.handleMagixPopup}
                            confirm={this.confirm}
                            magixAcctList={this.state.magixAcctList}
                            selectedMagixAccount={this.state.selectedMagixAccount}
                        />:""} */}

                        <Modal show={this.state.showSubmittedAlert} onHide={(event) => this.handleSubmittedAlert(event)}>
                            <Modal.Header className="pb-0"><b className="text-secondary h4">Credit Application</b><FontAwesomeIcon icon={faClose} className="btn" onClick={(event) => this.handleSubmittedAlert(event)} /></Modal.Header>
                            <Modal.Body>We have received application. Thank you.</Modal.Body>
                            <Modal.Footer className="border-0">
                                <form>
                                    <button className="btn ml-2" style={{ backgroundColor: "#5c068c", color: "white" }} onClick={(event) => {
                                        this.handleSubmittedAlert(event);
                                    }}>Close</button>
                                </form>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={this.state.sessionIdVerificationRes}>
                            <Modal.Body>Your session is expired, please try again</Modal.Body>
                        </Modal>

                        <Modal show={this.state.permission_status === '' ? false : this.state.permission_status?.canView ? false : true}>
                            <Modal.Header className="pb-0"><b className="text-secondary h4">Access Denied</b></Modal.Header>
                            <Modal.Body>You didn't have access to the page</Modal.Body>
                        </Modal>

                        <Modal show={this.state.smsURLError}>
                            <Modal.Header className="pb-0"><b className="text-secondary h4">Warning</b></Modal.Header>
                            <Modal.Body>It's an invalid URl, please visit your nearest store for assistance.</Modal.Body>
                        </Modal>

                        <Modal show={this.state.autoPayModal} >
                            <Modal.Header className="pb-0"><b className="text-secondary h4">Confirmation</b></Modal.Header>
                            <Modal.Body><p>The item you are purchasing with $0 down payment requires auto-pay enrollment.</p>
                                <p>Do you want to continue with auto-pay enrollment?</p>
                            </Modal.Body>
                            <Modal.Footer className="border-0">
                                <button className="btn mr-2" style={{ backgroundColor: "#1B1B1B", color: "white" }} onClick={(event) => this.cancelSessionLink(event)}>No</button>
                                <button className="btn ml-2" style={{ backgroundColor: "#5c068c", color: "white" }} onClick={() => this.setState({ autoPayModal: !this.state.autoPayModal })}>Yes</button>
                            </Modal.Footer>
                        </Modal>

                        {/* <Modal show={this.state.verificationBox} >
                        <Modal.Header className="pb-0"><b className="text-secondary h4">Duplicate Application Found</b><FontAwesomeIcon icon={faCircleXmark} style={{cursor : "pointer"}} size="2x"  onClick={(event) => this.duplicateDJOApplication("continue")}/></Modal.Header>
                            <Modal.Body className="pb-0">
                                        <p>An application that matching your email/phone was found in our system. To use this application, please provide Personal ID (Driver's License, etc.) previously submitted.</p>
                                        <div className="d-flex justify-content-center mb-1">
                                            <label className="mb-0 mt-2">ID: </label>
                                            <input type="text" className="form-control ml-2 mr-2 w-50 border-dark" name="exitingId" id="exitingId" value={this.state.djoId} onChange={(event) => this.onChange(event)}/>
                                            <button className="btn bg-secondary text-primary" onClick={() => {this.setState({djoIdConfirm : true, verificationBox : false});}} >Submit</button>
                                        </div>
                                        {this.state.djoIdError &&
                                            <p className="text-center" style={{ color: "red"}}>{this.state.djoIdError}</p>
                                        }
                                        <p><b>To start a new application please click continue button below</b></p>
                            </Modal.Body>
                            <Modal.Footer className="border-0 pt-0">
                                <button className="btn mx-auto" style={{ backgroundColor: "#1B1B1B", color: "white" }} onClick={(event) => this.duplicateDJOApplication("continue")}>Continue</button>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={this.state.djoIdConfirm}>
                            <Modal.Header className="pb-0"><b className="text-secondary h4">Confirmation</b><FontAwesomeIcon icon={faClose} className="btn" onClick={() => {this.setState({djoIdConfirm : false, verificationBox : true});}} /></Modal.Header>
                            <Modal.Body>Are you sure you want to verify?</Modal.Body>
                            <Modal.Footer className="border-0">
                                    <p className="btn mr-2 mb-0" style={{ backgroundColor: "#1B1B1B", color: "white" }} onClick={() => {this.setState({djoIdConfirm : false, verificationBox : true});}}>Cancel</p>
                                    <button className="btn ml-2" style={{ backgroundColor: "#5c068c", color: "white" }} onClick={() => this.duplicateDJOApplication("verify")}>Submit</button>
                            </Modal.Footer>
                        </Modal>  */}

                        {/*In logout&continue user need to relogin for redirect to portal in that scenario. If user doesn't have no store code the below modal will popup*/}
                        <ConfirmDialog
                            show={this.state.noStoreAssign}
                            handleModalPopup={this.handleAccessModal}
                            message={"<p class='mb-0'>No stores assigned for " + (localStorage.getItem("loggedUserName")) + ". Please contact administrator.</p>"}
                            header_name="Warning!!"
                            button2_name="OK"
                            button2={this.handleAccessModal}
                        />
                        {/*In logout&continue user need to relogin for redirect to portal in that scenario. If user doesn't have access to portal the below modal will popup*/}
                        <ConfirmDialog
                            show={this.state.accessModal}
                            handleModalPopup={this.handleAccessModal}
                            message={"<p class='mb-0'>Access is denied, please contact administrator.</p>"}
                            header_name="Warning!!"
                            button2_name="Close"
                            button2={this.handleAccessModal}
                        />
                        {/*In logout&continue user need to relogin for redirect to portal in that scenario. If user is inActive the below modal will popup*/}
                        <ConfirmDialog
                            show={this.state.userStatus}
                            handleModalPopup={this.handleAccessModal}
                            message={"<p class='mb-0'>User is inActive and can't access the portal, please contact administrator.</p>"}
                            header_name="Warning!!"
                            button2_name="Close"
                            button2={this.handleAccessModal}
                        />
                        {/* display modal if synchrony status is pedning */}
                        <ConfirmDialog
                            show={this.state.synchronyPending}
                            handleModalPopup={this.synchronPendingModal}
                            message={`<p class="mb-0  text-danger font-weight-bold text-left">Your application cannot be sent to Fortiva because the Synchrony status is Pending.  Contact Synchrony and resolve the pending issue first, then apply for Fortiva only.</p>`}
                            header_name="Confirmation"
                            button2_name="OK"
                            button2={this.synchronPendingOk}
                            isSynchronyPending={this.state.synchronyPending}
                        />

                        {/* display fortiva modal if synchrony is approved to submit fortiva app */}
                        <FortivaDialog
                            show={this.state.showFortiva}
                            handleModalPopup={this.handleFortivaModal}
                            message={`<span class=\"mb-0 \">Your Synchrony application has been approved.  Do you still want to send your application to Fortiva?</span>`}
                            handleFortivaModal={this.handleFortivaModal}
                            submitFortiva={this.submitFortiva}
                            btn1_name="No"
                            btn2_name="Yes"
                        />
                        <FortivaErrorDialog
                            show={this.state.fortivaAppError}
                            handleModalPopup={this.handleFortivaErrorModal}
                            message={`<span class="mb-0 text-danger">${this.state.fortivaAppErrMsg}</span>`}
                            submitFortiva={this.redirectoFortivaApplication}
                        />
                        <ProgUownModal
                            show={this.state.waterfallObj.showProgUown}
                            cancelProgUownApplication={this.cancelProgUownApplication}
                            redirectProgUownApplication={this.redirectProgUownApplication}
                            fortivaApp={this.state.fortivaApp}
                            danielsApp={this.state.danielsApp}
                            progressiveApp={this.state.progressiveApp}
                            uownApp={this.state.uownApp}
                            // isProgChecked={this.state.waterfallObj.isProgChecked}
                            // isUownChecked={this.state.waterfallObj.isUownChecked}
                            // handleOnchange={this.handleOnchange}
                            message={this.state.alterPopupmessage?.find((item => item.name?.toLowerCase() == "progressiveuwon"))}
                        />
                        <FortivaErrorDialog
                            show={this.state.synchronyDeclined}
                            message={`<span class="mb-0 font-weight-bold" style="color:#0000ff">Sending the application to Fortiva</span>`}
                            submitFortiva={this.synchronDeclinedOk}
                        />

                        <FortivaErrorDialog
                            show={this.state.autoPayMessagePopup}
                            message={`<span class="m-0 font-weight-bold">${this.state.autoPayMessage}</span>`}
                            submitFortiva={this.submitStep10}
                        />

                        <FortivaErrorDialog
                            show={this.state.waterfallObj.waterFallStatus}
                            message={waterFallmessage}
                            submitFortiva={this.handleWaterFallStatus}
                        />

                        <Modal show={this.state.isLeasingAppOnly}>
                            <Modal.Header className="pb-0"><b className="text-secondary h4">{this.state.alterPopupmessage?.find(item => item.name?.toLowerCase() == "waterfallmessage")?.description?.split("~`~")[0]}</b></Modal.Header>
                            <Modal.Body className="pb-0">
                                <div>
                                    <p ><b>{this.state.alterPopupmessage?.find(item => item.name?.toLowerCase() == "waterfallmessage")?.description?.split("~`~")[1]}</b></p>
                                    <p class="mb-1"> {<FontAwesomeIcon icon={faCircle} className="pr-2" size="xs" />}<label className="mb-0 ml-2">{this.state.alterPopupmessage?.find(item => item.name?.toLowerCase() == "waterfallmessage")?.description?.split("~`~")[2]}</label> </p>
                                    <p class="mb-1"> {<FontAwesomeIcon icon={faCircle} className="pr-2" size="xs" />}<label className="mb-0 ml-2">{this.state.alterPopupmessage?.find(item => item.name?.toLowerCase() == "waterfallmessage")?.description?.split("~`~")[3]}</label> </p>
                                    <p class="mb-0"> {<FontAwesomeIcon icon={faCircle} className="pr-2" size="xs" />}<label className="mb-0 ml-2">{this.state.alterPopupmessage?.find(item => item.name?.toLowerCase() == "waterfallmessage")?.description?.split("~`~")[4]}</label> </p>
                                </div>
                            </Modal.Body>
                            <Modal.Footer className="border-top-0 mt-1">
                                <button className="btn mr-1 ml-1 mb-0 reLogout" style={{ backgroundColor: "#5c068c", color: "white" }} onClick={(event) => { this.setState({ isLeasingAppOnly: false }) }}>Ok</button>
                            </Modal.Footer>
                        </Modal>

                        <Modal show={this.state.validateMagix}>
                            <Modal.Header className="pb-0"><b className="text-secondary h4">Warning</b></Modal.Header>
                            <Modal.Body className="pb-0">
                                <div>
                                    <p className="text-danger"><b>The SSN and/or DOB needs to be corrected in Magix to proceed.</b></p>
                                </div>
                            </Modal.Body>
                            <Modal.Footer className="border-top-0 mt-1">
                                <button className="btn mr-1 ml-1 mb-0 reLogout" style={{ backgroundColor: "#5c068c", color: "white" }} onClick={(event) => { this.setState({ validateMagix: false }) }}>Ok</button>
                            </Modal.Footer>
                        </Modal>
                        <Modal show={this.state.showAppInProgress} >
                            <Modal.Header className="pb-0"><b className="text-secondary h4">Confirmation</b></Modal.Header>
                            <Modal.Body>Your application is being processed, please wait for some time.</Modal.Body>
                        </Modal>
                    </main>
                </div>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(applyNowActions, dispatch),
        customerDetailsActions: bindActionCreators(customerDetailsActions, dispatch),
        authActions: bindActionCreators(authActions, dispatch),
        actionStore: bindActionCreators(storeactions, dispatch),
        userRightsactions: bindActionCreators(userRightsActions, dispatch),
        userListactions: bindActionCreators(adminUserListActions, dispatch),
        adminActions: bindActionCreators(adminActions, dispatch),
        customerLookUpActions: bindActionCreators(customerLookupAction, dispatch),
        customerUpdation: bindActionCreators(customerUpdationActions, dispatch)
    }
}
export default connect(null, mapDispatchToProps)(ApplyNow);